import {
  TypeList,
  Type,
  spacer16,
  spacer20,
  spacer8,
  spacer80,
  spacer64,
  TextLink,
  screenLgMin,
} from '@spotify-internal/encore-web';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useCookie } from 'react-use';
import styled from 'styled-components';

const Layout = styled.div`
  margin: 0 auto;
  max-width: ${screenLgMin};
  padding: ${spacer64} ${spacer80};
`;

const TermsAndConditionsKo = () => {
  return (
    <Layout>
      <Type variant="altoBrio" as="h1" paddingBottom={spacer20}>
        이용 약관
      </Type>
      <Type variant="cello" as="p" paddingBottom={spacer20}>
        발효일: 2021년 9월 6일
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#1-introduction">
          소개
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#2-service-provider">
          당사가 제공하는 Spotify 서비스
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#3-your-use-of-service">
          Spotify 서비스 이용
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#4-property-rights">
          콘텐츠 및 지적 재산권
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#5-customer-support">
          고객 지원, 정보, 문의, 불만 사항
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#6-problems-disputes">
          문제 및 분쟁
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#7-about-terms">
          본 약관에 대한 정보
        </TextLink>
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="1-introduction">
        1. 소개
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 이용 약관(본 “약관”)은 본 약관을 통합하거나 연결하는 모든 웹사이트 및
        소프트웨어 애플리케이션(이하 총칭하여 “서비스”)과 본 서비스를 통해
        제공되는 모든 자료(이하 “콘텐츠”)를 포함하여 서비스의 사용(액세스
        포함)에 적용되므로 주의 깊게 읽어 보시기 바랍니다. 본 서비스의 이용은
        Spotify가 제시한 추가 이용 약관의 적용을 받을 수 있으며, 본 참조에 의해
        본 이용 약관에 통합되어 있습니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 서비스는 음악 업계의 사용자만 업무용으로 사용할 수 있으며, 해당
        소비자 보호법에 명시된 “소비자”나 개인, 가족 또는 가정의 목적을 위해
        행동하는 사람에게는 공개되지 않습니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 서비스에 가입하거나 액세스하거나 기타 방법으로 사용함으로써 귀하는
        귀하가 대표하는 단체, 조직 또는 사업체(귀하와 관계된 퍼블리셔 또는 하위
        퍼블리셔 포함)(이하 귀하의 “가입 단체”)를 대신하여 본 약관에 동의하게
        되며, 귀하는 (1) 귀하가 향후 해당 가입 단체의 허가된 대리인으로 남아
        있는지 여부에 관계없이 가입 단체를 본 약관에 구속할 권한이 있는 해당
        가입 단체의 권한 있는 대리인이고, (2) 가입 단체가 본 약관에 구속되는 데
        동의하고, (3) 귀하가 해당 가입 단체를 대신하여 본 약관에 구속되는 데
        동의한다는 것을 진술하고 보증합니다. 위의 모든 내용에 동의할 수 없는
        경우에는 본 서비스를 이용해서는 안 됩니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 약관에는 아래 섹션 6에 명시된 바와 같이 배심원 재판 또는 기타 법원
        소송 또는 모든 종류의 집단 소송 대신 분쟁을 해결하기 위해 개인적으로
        중재를 사용하도록 요구하는 필수 중재 조항이 포함되어 있습니다.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        서비스 제공업체
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 약관은 귀하의 가입 단체 그리고 (a) 귀하의 가입 단체가 미국 법률에
        따라 조직되었거나 미국 법률의 적용을 받는 경우에는 델라웨어 기업인
        Spotify USA Inc.(사무소 소재지: 4 World Trade Center, 150 Greenwich
        Street, 62nd Floor, New York, New York 10007) 또는 (b) 귀하의 가입
        단체가 미국 이외 국가 법률에 따라 조직되었거나 달리 미국 이외 국가
        법률의 적용을 받는 법인인 경우에는 Spotify AB(사무소 소재지:
        Regeringsgatan 19, 111 Stockholm 53, Sweden, 등록 번호: 556703-7495)
        간에 체결됩니다.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        연령 및 자격 요건
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하가 귀하의 가입 단체를 대신하여 본 서비스를 이용하려면 (1) 13세(또는
        거주 국가에서 이에 상당하는 최소 연령) 또는 그 이상이어야 하며, (2)
        귀하가 거주 국가에서 미성년자에 해당하는 경우 부모 또는 보호자의 동의를
        받아야 하며, (3) 가입 단체를 대신하여 당사와 구속력 있는 계약을 체결할
        수 있는 권한이 있으며 관련 법률에 따라 당사와 계약을 체결하는 것이
        금지되어 있지 않아야 하고 (4) 본 서비스가 제공되는 국가에 거주하고
        있어야 합니다. 또한 귀하는 Spotify에 제출하는 모든 등록 정보가 사실이고
        정확하며 완전하다는 것을 약속하며, 이 정보를 항상 그렇게 유지하는 것에
        동의합니다.
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="2-service-provider"
      >
        2. 당사가 제공하는 Spotify 서비스.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        베타 기능
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        때때로 당사는 본 서비스(이하 “베타 기능”)를 통해 베타 기능을 제공할 수
        있습니다. 당사는 베타 기능을 사용하여 새로운 기능 아이디어를 시험하고
        테스트합니다. 따라서 귀하는 베타 기능이 어느 날 나타나거나 주기적으로
        변경되거나 예고 없이 완전히 사라지는 것을 확인할 수 있습니다.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        서비스 제한 및 수정 사항
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        당사는 서비스를 운영하기 위해 합리적인 노력을 기울입니다. 그러나 본
        서비스의 이용 가능 여부는 귀하에 대한 책임 없이 수시로 변경될 수
        있습니다. 예를 들면 다음과 같습니다.
      </Type>

      <TypeList as="ul" listStyleReset={false}>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          본 서비스는 기술적 문제, 유지 보수나 테스트 또는 업데이트로 인해
          일시적으로 중단될 수 있습니다. 여기에는 관련 법률 및 규정 요구 사항의
          변경 사항을 반영해야 하는 경우가 포함됩니다.
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          당사는 본 서비스를 지속적으로 개선 및 발전시키기 위해 노력하고 있으며,
          서비스의 모든 부분(특정 기능, 특성 및 제안 포함)을 수정, 중단 또는
          중지(영구 또는 임시)할 수 있습니다.
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          Spotify는 본 서비스를 통해 특정 콘텐츠를 제공할 의무가 없으며, Spotify
          또는 해당 소유자는 통지 없이 콘텐츠를 제거할 수 있습니다.
        </Type>
      </TypeList>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify는 정부 기관, 기타 제삼자 또는 당사의 통제 범위를 벗어나는
        사건으로 인해 발생하는 인터넷 또는 기타 서비스의 중단이나 장애와
        관련하여 귀하에 대해 아무런 책임도 지지 않습니다.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        제삼자 애플리케이션, 장치 및 오픈 소스 소프트웨어
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 서비스는 제삼자 애플리케이션, 웹사이트 및 서비스(이하 “제삼자
        애플리케이션”) 및 제삼자 PC, 모바일 핸드셋, 태블릿, 웨어러블 장치,
        스피커, 및 기타 장치(이하 본 “장치”)에 통합되거나 기타 방식으로
        상호작용할 수 있습니다. 이러한 제삼자 애플리케이션 및 본 장치를 이용하는
        경우 해당 제삼자가 제공하는 추가 약관, 조건 및 정책이 적용될 수
        있습니다. Spotify는 제삼자 애플리케이션 및 본 장치가 본 서비스와
        호환된다고 보장하지 않습니다.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        데이터 인사이트, 실수
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하는 본 서비스가 당사의 재량에 따라 귀하에게 제공하는 선택적
        서비스라는 점을 인정합니다. 본 서비스는 음악 사용량 데이터와 귀하의
        팬들에 대한 인구 통계 데이터를 볼 수 있는 기능을 제공할 수 있습니다.
        당사는 데이터의 정확성을 보장하기 위해 최선을 다하지만 본 서비스 또는
        당사가 제공한 데이터에 오류가 없거나, 당사가 귀하에게 제공하는 데이터
        인사이트에서 발생하는 실수를 비롯한 실수가 수시로 발생하지 않음을
        보장하지 않습니다. 본 서비스에 결함이나 실수가 있는 경우, 당사는 이러한
        실수를 해결하거나 시정하기 위해 모든 합리적인 노력을 기울일 것입니다.
        귀하는 본 무료 서비스의 실수, 오류 또는 흠결로 인해 발생하거나 데이터
        사용으로 인해 발생하는 손해, 책임 또는 비용으로부터 당사를 면책하고
        보호하는 데 동의합니다. 모든 데이터는 “있는 그대로” 제공됩니다. 귀하는
        당사가 제공하는 그러한 모든 데이터를 귀하의 단독 책임 및 재량에 따라
        사용합니다.
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify는 서비스를 제공하기 위해 Spotify가 사용하는 데이터베이스에
        저장된 콘텐츠를 보존하고 보호하기 위해 합리적인 예방 조치를 취하지만,
        귀하는 본 서비스를 유일한 저장 시설로서 의존해서는 안 되며, 콘텐츠의
        백업 사본을 보존해야 합니다. Spotify는 콘텐츠의 손상, 삭제 또는 저장
        실패에 대해 책임을 지지 않습니다.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="3-your-use-of-service"
      >
        3. Spotify 서비스 이용
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Spotify 계정 생성
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 서비스를 전부 또는 부분적으로 이용하려면 Spotify 계정을 생성해야 할
        수 있습니다. 귀하의 사용자 이름과 비밀번호는 개인용으로만 사용해야 하며
        기밀로 유지해야 합니다. 귀하는 귀하의 사용자 이름과 비밀번호의 모든
        사용(무단 사용 포함)에 대해 귀하에게 책임이 있음을 이해합니다. 사용자
        이름 또는 비밀번호를 분실하거나 도난당한 경우 또는 계정에 대한 무단
        액세스가 있었다고 생각되는 경우 즉시 고객 서비스 팀에 알리십시오.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        서비스 이용 권리
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        서비스에 대한 액세스
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하와 귀하의 가입 단체가 본 약관(기타 관련 약관 포함)을 준수하는 경우,
        당사는 귀하의 가입 단체를 대신하여 콘텐츠를 포함하되 이에 국한되지 않고
        서비스를 이용할 수 있는 비독점적이고 취소 가능한 권한(이하 “액세스”)을
        귀하에게 부여합니다. 이 액세스 권한은 귀하의 가입 단체 또는 Spotify에
        의해 종료될 때까지 유효합니다. 귀하는 본 서비스 또는 콘텐츠를
        재배포하거나 이전하지 않을 것에 동의합니다. 본 서비스의 소프트웨어
        애플리케이션과 콘텐츠는 귀하의 가입 단체에 판매되거나 양도되지 않고
        귀하의 가입 단체에 라이선스가 부여되며, Spotify와 해당 라이선스 제공자는
        귀하의 장치에 설치된 후에도 서비스의 소프트웨어 애플리케이션과 콘텐츠의
        모든 사본에 대한 소유권을 보유합니다. 본 서비스에 액세스할 때 귀하는
        서비스에 부당한 부담을 가하는 어떠한 조치도 취하지 않을 것에 동의합니다.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        약관 준수, 위임
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하는 귀하의 가입 단체를 대신하여 본 약관이 서비스에 대한 액세스 및
        서비스의 기타 사용에 적용됨을 인정하고 이에 동의합니다. 귀하는 귀하의
        가입 단체를 대신하여 서비스, 콘텐츠 또는 그 일부를 본 약관에서
        명시적으로 허용하지 않는 방식으로 사용하지 않는 것에 동의합니다. 본
        약관에 구체적으로 명시된 경우를 제외하고, 귀하는 (a) 서비스 또는
        콘텐츠를 복사하거나, (b) 서비스 또는 콘텐츠의 전부나 일부를 배포하거나,
        (c) 수정, 개조, 번역, 리버스 엔지니어링, 변경, 디컴파일, 복제, 분해 또는
        서비스나 콘텐츠를 기반으로 파생 저작물을 생성하는 행위를 하거나, (d)
        서비스나 콘텐츠에 대한 기타 권리를 사용, 임대, 대여, 재라이선스, 배포
        또는 제삼자에 대한 부여를 시도하거나, (e) 서비스나 콘텐츠에 대한 원격
        액세스를 다른 사람에게 허용해서는 안 됩니다. 본 서비스를 사용할 때
        귀하는 모든 관련 법률, 규칙 및 규정을 준수해야 하며, 제삼자의 지적 재산,
        개인 정보 및 기타 권리를 존중해야 합니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하는 업무상의 이유가 있는 귀하의 가입 단체(이하 “대리인”) 내에서만 본
        서비스를 추가 사용자에게 사용할 권한을 위임할 수 있습니다. 귀하는 본
        서비스 내에서 특정 팀에만 대리인을 추가해야 하며, 이 팀은 귀하의 가입
        단체로부터 권한을 부여받을 뿐 아니라 타당한 사업적 이유도 있어야 합니다.
        대리인이 서비스에 액세스하거나 다른 방식으로 이를 사용하는 경우, 귀하는
        본 약관이 서비스의 사용에도 적용된다는 점을 귀하의 가입 단체를 대신하여
        인정하고 이에 동의합니다. 귀하는 각 대리인이 서비스를 사용할 권한이
        있음을 당사에 진술하고 보증하며, 가입 단체를 대리 및 대신하여 추가
        사용자에게 권한을 2차 위임합니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하의 가입 단체를 대신하여 귀하는 (1) 귀하와 모든 대리인이 본 약관을
        준수하고, (2) 가입 단체가 귀하와 각 대리인의 약관 위반에 대해 전적으로
        책임을 지며, (3) 가입 단체가 약관의 목적에 따라 귀하와 귀하의 대리인의
        작위나 부작위를 책임진다는 것에 명시적으로 동의합니다.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Spotify의 독점적 권리
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        서비스와 콘텐츠는 Spotify 또는 Spotify 라이선스 제공자의 자산입니다.
        모든 Spotify 상표, 서비스마크, 상호, 로고, 도메인 이름, Spotify 브랜드의
        기타 특성(이하 “Spotify 브랜드 특성”)은 Spotify 또는 해당 라이선스
        제공자의 단독 자산입니다. 본 약관은 귀하 또는 귀하의 가입 단체에 상업적
        또는 비상업적 용도로 Spotify 브랜드 특성을 사용할 수 있는 권리를
        부여하지 않습니다.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        수출 통제 및 제재
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify 제품은 미국 수출 및 재수출 통제 법률 및 규정, 또는 미국 상무부가
        관리하는 수출 관리 규정(이하 “EAR”), 재무부 해외 자산 통제실(이하
        “OFAC”)이 관리하는 무역 및 경제 제재, 국무부가 관리하는 국제 무기 거래
        규정(이하 “ITAR”)을 포함한 다른 관할권에 적용되는 유사한 법률의 적용을
        받습니다. 귀하는 (1) 미국이 상품을 수출 금지하거나 경제 제재를 적용한
        국가에 위치해 있지 않으며, (2) 수출과 재수출에 관한 법률과 규정 또는
        다른 관할권에 적용되는 유사한 법률에서 거부된 당사자로 명시되거나 미국
        정부의 금지 당사자나 제한 당사자 목록에 거부된 당사자로 기재되어 있지
        않음을 보증합니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하의 가입 단체를 대신하여 귀하는 OFAC에서 유지 관리하는 EAR, 무역 및
        경제 제재를 포함하되 이에 국한되지 않는, 적용되는 모든 수출 및 재수출
        통제 법률 및 규정을 준수하는 데 동의합니다. 특히 귀하의 가입 단체를
        대신하여 귀하는 본 약관에 따라 Spotify로부터 받은 제품, 소프트웨어, 또는
        기술(해당 기술에서 파생되거나 이를 기반으로 하는 제품 포함)을 해당
        법률과 규정이 요구하는 대로 관할 정부 당국의 사전 승인을 받지 않은 채
        EAR, OFAC이 유지 관리하는 무역 및 경제 제재, 또는 미국이나 기타 관할권의
        관련 법률이나 규정에 따라 금지된 목적지, 법인, 개인에게 또는 최종 사용
        목적을 위해 직간접적으로 판매, 수출, 재수출, 양도, 전용 또는 처분하지
        않는 것에 동의합니다.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="4-property-rights"
      >
        4. 콘텐츠 및 지적 재산권
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        사용자 콘텐츠
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        서비스에 게시하는 콘텐츠
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하는 귀하의 가입 단체 대신 본 서비스에 콘텐츠(이하 “사용자 콘텐츠”)를
        게시, 업로드 또는 기타 방식으로 제공할 수 있습니다. 의심의 여지를 피하기
        위해, “사용자 콘텐츠”에는 사용자가 본 서비스에 추가, 생성, 업로드, 제출,
        배포하거나 게시한 모든 정보, 자료 및 기타 콘텐츠가 포함됩니다. Spotify
        및/또는 Spotify에서 지정한 제삼자는 전적인 재량으로 해당 사용자 콘텐츠와
        관련하여 제공된 메타데이터의 전부 또는 일부를 사용할 수 있으며 해당
        메타데이터를 보완 및/또는 대체할 수 있습니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하가 게시한 모든 사용자 콘텐츠에 대한 책임은 전적으로 귀하 및 귀하의
        가입 단체에 있습니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하의 가입 단체를 대신하여 귀하는 귀하가 본 서비스에 게시한 사용자
        콘텐츠와 관련하여 (1) 귀하가 사용자 콘텐츠를 소유 또는 게시할 권리를
        가지고 있으며 (2) 해당 사용자 콘텐츠 또는 부여된 라이선스에 따른
        Spotify의 해당 사용자 콘텐츠 사용이 (i) Spotify 사용자 가이드라인, 관련
        법률, 모든 협회, 노동조합 또는 공동 사업체의 규정 및 규칙을 포함한 본
        약관을 위반하지 않거나 지적 재산권(저작권을 포함하되 이에 국한되지
        않음), 퍼블리시티, 사생활, 인격, 계약 또는 타인의 기타 권리를 포함하여
        제삼자의 권리를 위반 또는 침해하지 않거나, (ii) Spotify 또는 기타 개인
        또는 단체의 명시적인 사전 동의 없이 Spotify 또는 아티스트, 밴드, 레이블
        또는 기타 개인 또는 법인이 귀하 또는 귀하의 사용자 콘텐츠에 대한 어떠한
        관계나 지지도 암시하지 않으며, (3) 귀하가 본 서비스에 게시하는 사용자
        콘텐츠와 관련 있고 Spotify가 본 약관에서 부여된 라이선스를 행사하도록
        요구하는 제삼자 권리, 라이선스, 허가, 동의, 허락 및 승인을 적절히 취득,
        보존 및 관리해야 하고, (4) 귀하가 본 항의 (3)에 언급된 각 제삼자
        라이선스, 허가, 동의, 허락 및 승인에 명시된 조건을 준수할 책임이 있으며,
        귀하가 제삼자의 라이선스, 허가, 동의, 허락 및 승인에 따라 필요한 경우
        모든 제삼자에게 로열티, 수수료 및 기타 모든 금전(특성에 관계없음)을
        지급할 책임이 있으며, (5) 귀하가 본 서비스에 게시하는 사용자 콘텐츠,
        또는 Spotify가 본 약관에 부여된 라이선스를 행사하는 것과 관련하거나
        여기서 발생하는 로열티, 수수료 및 기타 모든 금전(그 특성은 관계없음)은
        Sportify가 직접 지불하거나 Sportify를 대신하여 또는 개인이나 법인을
        대신하여 지불해야 하며, (6) 본 서비스에 게시하는 모든 사용자 콘텐츠는
        정확하고, 당사의 가이드라인에 위배되는 콘텐츠가 포함되어 있지 않으며,
        (7) 귀하가 본 서비스에 사용자 콘텐츠를 게시할 때 적용되는 모든 법률,
        규정, 산업 표준을 비롯해 FTC의 광고 내 추천 및 보증 사용에 관한
        가이드라인, FTC의 온라인 공개 지침, FTC의 네이티브 광고 가이드라인 및
        FTC가 수시로 발행하는 기타 가이드라인과 이들의 업데이트본을 준수하고
        있으며 준수해야 한다는 것을 약속합니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 서비스에 사용자 콘텐츠를 게시하거나 공유할 경우, 사용자 콘텐츠에 일반
        대중이 액세스할 수 있게 되고 서비스와 기타 Spotify 서비스 및 웹에서 다른
        사람이 사용하고 재공유할 수 있으므로 서비스에 게시하거나 공유할 때는
        주의하고 계정 설정에 유의하시기 바랍니다. Spotify는 귀하 또는 다른
        사람이 본 서비스에 게시하거나 공유한 내용에 대해 책임을 지지 않습니다.
        귀하 또는 귀하의 가입 단체가 본 서비스의 특정 페이지나 계정에 액세스할
        수 있는 한도 내에서, 하나 이상의 다른 사용자나 가입 단체도 액세스할 수
        있는 경우, 귀하의 특정 사용자 콘텐츠(귀하의 이름, 역할, 액세스 수준 및
        서비스에서 취하는 특정 행동을 포함하되 이에 국한되지 않음)를 이러한 다른
        사용자나 가입 단체가 볼 수 있습니다. 페이지 또는 자산에 대한 액세스 및
        편집 권한은 해당 자료에 대한 기본 권한 및 본 서비스 액세스 수준에 따라
        달라질 수 있습니다. 경우에 따라 본 서비스의 특정 페이지나 계정에 대한
        편집 권한을 다른 사용자 또는 가입 단체와 공유할 수 있습니다.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        사용자 콘텐츠 요약 및 모니터링
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify는 본 서비스를 통해 사용자 콘텐츠를 포함하거나 배포할 의무가
        없습니다. Spotify는 사용자 콘텐츠를 모니터링하거나 검토할 수 있지만 이에
        대한 의무는 없습니다. 관련 법률에서 금지하는 경우를 제외하고, Spotify는
        사용자 콘텐츠가 Spotify 사용자 가이드라인에 위배되는 경우를 포함하되
        이에 국한되지 않는 어떠한 이유로든 본 서비스의 사용자 콘텐츠에 대한
        액세스를 단독으로 제거 또는 비활성화할 수 있습니다. Spotify는 귀하 또는
        제삼자에게 사전 통보 없이 이러한 조치를 취할 수 있으며, 그러한 제거에
        대해 귀하에게 어떠한 책임도 지지 않습니다.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        귀하가 당사에 부여하는 라이선스
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        사용자 콘텐츠
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify는 귀하가 본 서비스에 게시한 사용자 콘텐츠에 대한 소유권을
        주장하지 않습니다. 본 서비스에 사용자 콘텐츠를 게시하면, 귀하와 Spotify
        간에 체결된 약관에 따라 귀하는 사용자 콘텐츠에 대한 모든 권한을 계속
        보유합니다. 여기에는 사용자 콘텐츠와 관련된 지적 재산권 또는 기타 독점적
        권한이 포함되며, 이 섹션의 다음 단락에서 귀하가 Spotify에 부여하는
        라이선스가 적용됩니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 서비스에 사용자 콘텐츠를 게시함으로써 귀하는 귀하의 가입 단체를
        대신하여 본 서비스 및 Spotify의 음악 스트리밍 서비스와 본 서비스 및
        Spotify의 음악 스트리밍 서비스에 대한 프로모션 및 마케팅과 관련하여 어떤
        미디어를 통해서든, 단독으로든 다른 콘텐츠 또는 자료와 함께든, 어떠한
        방식으로든 그리고 현재 알려져 있거나 이후에 만들어진 어떠한 방법이나
        수단 또는 기법을 통해서든 사용자 콘텐츠를 복제, 제공, 실행 및 전시하고
        번역, 수정하고 파생 저작물을 제작하고 배포하고 기타 방법으로 사용할 수
        있는 비독점적이고 양도 가능하고 재라이선스 가능하고 로열티 없고
        완납했으며 전 세계 라이선스를 Spotify에 부여합니다. Spotify가 이러한
        목적으로 사용자 콘텐츠를 사용하지 않도록 하려면 사용자 콘텐츠를 본
        서비스에 게시하면 안 됩니다. 귀하가 자신의 이름, 초상 또는 사진이 포함된
        사용자 콘텐츠를 제공하는 경우, 귀하는 본 서비스 및 Spotify의 음악
        스트리밍 서비스에서는 물론 본 서비스 및 Spotify의 음악 스트리밍 서비스에
        있는 귀하의 사용자 콘텐츠를 사용할 수 있음을 광고, 마케팅 및 홍보하는
        마케팅 커뮤니케이션에서 그러한 이름, 초상 또는 사진을 사용할 수 있는
        비독점적이고 완납된 전 세계 권리를 당사에 추가로 부여합니다. 적용 가능한
        경우 그리고 관련 법률에 따라 허용되는 범위에서, 귀하는 피드백(아래
        정의되어 있음)을 포함한 사용자 콘텐츠의 저자로 여겨질 권리와 해당 사용자
        콘텐츠에 대한 모욕적 취급에 반대할 권리와 같은 “도덕적 권리” 또는
        동등권을 포기하고 시행하지 않는 것에 동의합니다.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        피드백
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 서비스 또는 콘텐츠의 사용과 관련하여 아이디어, 제안 또는 기타
        피드백(이하 본 “피드백”)을 제공하는 경우, 본 피드백은 기밀로 취급되지
        않으며 Spotify가 제한 없이 그리고 귀하에 대한 지불 없이 사용할 수
        있습니다. 본 약관에 따라 본 피드백은 일종의 사용자 콘텐츠로 간주됩니다.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        귀하의 장치
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하는 또한 본 서비스의 운영을 도모하기 위해 서비스가 귀하의 장치에 있는
        프로세서, 대역폭 및 저장소 하드웨어를 사용하도록 허용할 수 있습니다.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        침해 주장
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify는 지적 재산 소유자의 권리를 존중합니다. 콘텐츠가 귀하의 저작권
        권리를 침해한다고 생각되는 경우 Spotify 저작권 방침을 참조하십시오.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="5-customer-support"
      >
        5. 고객 지원, 정보, 문의 및 불만 사항
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        고객 지원, 정보, 문의, 불만 사항
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        고객 지원(이하 “고객 지원 문의”)을 받으려면 당사 웹사이트의 연락처
        섹션에 나열된 고객 지원 리소스를 사용하십시오. 또한 본 약관 시작 부분에
        있는 “서비스 제공업체” 섹션에 명시된 우편 주소로 당사에 문의할 수
        있습니다.
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="6-problems-disputes"
      >
        6. 문제 및 분쟁
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        서비스의 일시 중단 및 해지
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 약관은 귀하의 가입 단체나 Spotify가 약관을 해지할 때까지 귀하에게
        계속 적용됩니다. 귀하 또는 귀하의 가입 단체가 본 약관을 위반했다고
        판단되는 경우 또는 당사가 관련 법률을 준수하기 위해 필요하다고 판단하여
        본 서비스 또는 그 구성 요소의 제공을 중단하는 경우, Spotify는 언제든지
        본 약관(본 약관에 통합된 추가 약관 포함)을 해지하거나 본 서비스에 대한
        귀하의 액세스를 일시 중단할 수 있습니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하 및/또는 귀하의 가입 단체와 제삼자 간에 계정(대리인 계정 포함)의
        소유권 또는 승인된 사용에 관한 분쟁이 있는 경우, Spotify는 귀하, 귀하의
        대리인 및/또는 귀하의 가입 단체를 포함한 기타 개인 또는 법인에 대해
        어떠한 책임도 지지 않고 언제든지 해당 계정에 대한 모든 액세스를 보류할
        수 있습니다. Spotify는 사용자 간 분쟁을 직접 해결하거나 관련 당사자에게
        분쟁 해결을 맡길 수 있습니다. 그러면 관련 당사자는 관할 법원의 도움을
        요청할 수 있습니다. Spotify가 분쟁을 해결할 경우 귀하는 Spotify의 결정이
        최종적이며 귀하와 귀하의 가입 단체에 구속력을 가한다는 데 동의하며,
        귀하가 관련 법률에 규정된 대로 제삼자에 상소할 수 있더라도 귀하 또는
        귀하의 가입 단체가 Spotify에 대한 소송의 근거를 갖지 않는다는 데
        동의합니다. Spotify는 관할 법원의 합법적인 명령도 준수합니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하의 가입 단체 또는 Spotify가 본 약관을 해지하는 경우 또는 본 서비스에
        대한 귀하의 액세스를 Spotify가 일시 중단하는 경우, 귀하의 가입 단체를
        대신하여 귀하는 Spotify가 관련 법률에 따라 귀하 또는 귀하의 가입 단체에
        어떠한 책임도 지지 않는다는 데 동의합니다. 그리고 (본 약관에 명시적으로
        규정된 경우를 제외하고) Spotify는 귀하가 이미 결제한 금액을 환불해
        드리지 않습니다. 귀하의 가입 단체는 언제든지 본 약관을 종료하거나 본
        서비스에 액세스할 수 있는 귀하의 개인 권리를 종료할 수 있습니다. 이 경우
        귀하는 서비스에 액세스하거나 서비스를 사용할 수 없습니다. Spotify 계정을
        해지하는 방법에 대한 자세한 내용은 당사의 회사 정보 페이지의 고객 지원
        리소스를 참조하십시오.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        섹션 2(당사가 제공하는 Spotify 서비스), 섹션 3(Spotify 서비스
        사용)(명시된 경우는 제외), 섹션 4(콘텐츠 및 지적 재산권), 섹션 6(문제 및
        분쟁), 섹션 7(본 약관에 대한 정보)과 명시적으로 또는 그 특성상 본 약관의
        종료 후에도 계속 유효한 본 약관의 기타 섹션은 종료 후에도 유효합니다.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        보증 권리 포기
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 서비스는 명시적, 묵시적 또는 법률적 보증 없이 “있는 그대로”, “사용
        가능한 상태로” 제공됩니다. 또한 Spotify와 콘텐츠의 모든 소유자는
        만족스러운 품질, 상품성, 특정 목적에의 적합성 또는 비침해에 대한 보증을
        포함하여 콘텐츠에 대한 명시적, 묵시적 및 법적 보증을 부인합니다.
        Spotify와 콘텐츠의 모든 소유자는 본 서비스 또는 콘텐츠에 멀웨어 또는
        기타 유해한 구성 요소가 없음을 보증하지 않습니다. 또한 Spotify는 제삼자
        애플리케이션(또는 그에 따른 콘텐츠), 사용자 콘텐츠, 본 장치, 기타 제품
        또는 본 서비스나 하이퍼링크된 웹 사이트에서 제삼자가 광고하고, 홍보하고
        제안한 서비스에 대해 어떠한 진술도 하지 않고 이를 보증하거나 이에 대해
        책임지지 않으며, Spotify는 귀하와 전술한 제삼자 제공업체 간의 어떠한
        거래에 대해서도 책임지지 않습니다. Spotify로부터 귀하가 구두 또는
        서면으로 얻은 조언이나 정보는 Spotify를 대표하여 어떤 것도 보증하지
        않습니다. 이 섹션은 관련 법률에서 허용하는 최대 범위까지 적용됩니다.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        청구 제기에 대한 책임 제한 및 청구 제기 기한
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하는 본 서비스에 대한 모든 문제나 불만족에 대한 유일하고 독점적인
        구제책이 모든 Spotify 소프트웨어를 제거하고 본 서비스 이용을 중지하는
        것임을 동의합니다. 귀하는 본 서비스를 통해서 또는 본 서비스와 관련해서
        제공된 제삼자 애플리케이션이나 그 콘텐츠로 인해 발생하거나 이와 관련된
        의무나 책임을 Spotify가 지지 않는다는 데 동의하며, 귀하와 해당 제삼자
        애플리케이션과의 관계에 대해 해당 제삼자와 맺은 개별 계약이 적용될 수
        있는 한편으로 Spotify와 관련해서 제삼자 애플리케이션이나 그 콘텐츠에
        대해 발생하는 모든 문제나 불만족에 대한 귀하의 유일하고 독점적인
        구제책은 해당 제삼자 애플리케이션을 제거하는 것 또는 사용 중지하는
        것입니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify, 경영진, 주주, 직원, 대리인, 이사, 자회사, 계열사, 승계인,
        양도인, 공급자 또는 라이선스 제공자는 (1) 모든 간접, 특별, 부대적,
        징벌적, 결과적 손해에 대해 책임지지 않으며, (2) 법적 이론에 관계없이
        Spotify가 이러한 손해의 가능성에 대해 경고를 받은 적이 있는지 여부와
        관계없이 그리고 구제책이 그 중요한 목적을 달성하지 못한 경우에도 본
        서비스, 본 장치, 제삼자 애플리케이션 또는 제삼자 애플리케이션 콘텐츠를
        사용하거나 사용하지 못함으로 인해 발생하는 모든 경우에 사용, 데이터,
        비즈니스 또는 이익의 손실(직접적인지 간접적인지 상관없음)에 대해
        책임지지 않으며, (3) (A) 첫 번째 청구 전 12개월 동안 귀하가 Spotify에
        지불한 금액 또는 $30.00 이상을 발생시키는 Sportify for Artists, 제삼자
        애플리케이션 또는 제삼자 애플리케이션 콘텐츠와 관련된 모든 청구에 대한
        총체적 책임을 지지 않습니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        명확히 설명하자면, 본 약관은 관련 법률이 그러한 제한을 금지하는 한도
        내에서 사기, 허위 진술 또는 사망이나 신체 상해에 대한 Spotify의 책임을
        제한하지 않습니다.
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 약관에 따라 발생하는 모든 청구는 청구를 주장한 당사자가 청구를
        유발하는 작위, 부작위 또는 불이행에 대해 처음 알았거나 합리적으로
        알았어야 하는 날짜로부터 1년 이내에 (중재 요구를 제기하거나 아래의 중재
        관련 계약에 따라 개별적으로 소송을 제기함으로써) 시작되어야 하며, 해당
        기간 내에 주장하지 않은 청구에 대해서는 구제를 받을 권리가 없습니다.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        제삼자 권리
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하는 콘텐츠의 소유자와 특정 배포자(예: 앱 스토어 제공업체)가 본 약관의
        의도된 수혜자이며 귀하에게 직접 본 약관을 집행할 권리가 있음을 인정하고
        이에 동의합니다. 이 섹션에 명시된 경우 외에, 본 약관은 귀하와 Spotify를
        제외한 누구에게도 권리를 부여하지 않으며, 어떠한 경우에도 본 약관은
        제삼자 수혜 권리를 만들지 않습니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Apple, Inc.(이하 “Apple”) 앱 스토어에서 당사의 소프트웨어
        애플리케이션(앱)을 다운로드했거나 iOS 장치에서 앱을 사용하는 경우,
        귀하는 Apple에 관한 다음 통지를 읽고 이해했으며 이에 동의함을
        인정합니다. 본 약관은 Apple이 아닌, 귀하의 가입 단체와 Spotify 간에
        체결되며, Apple은 본 서비스와 그 내용에 대해 책임을 지지 않습니다.
        Apple은 본 서비스 관련 유지 관리와 지원 서비스를 제공할 의무가 없습니다.
        본 서비스가 적용되는 보증 내용을 준수하지 못하는 경우, 귀하가 이를
        Apple에 통보하면 Apple은 귀하에게 앱에 대한 해당 구매 가격을 환불할
        것입니다. 그리고 관련 법률이 허용하는 최대 범위까지 Apple은 본 서비스와
        관련하여 다른 보증에 대한 의무를 지지 않습니다. Apple은 (1) 제품 책임
        청구, (2) 본 서비스가 관련 법률 또는 규제 요건을 준수하지 않는다는 주장,
        (3) 소비자 보호 또는 유사한 법률에 따라 발생하는 청구 및 (4) 지적 재산
        침해와 관련한 청구를 포함하여 귀하나 제삼자가 본 서비스나 본 서비스의
        소유 또는 이용과 관련하여 제기하는 일체의 청구에 대응할 책임이 없습니다.
        Apple은 본 서비스 및/또는 귀하의 앱 소유와 사용이 해당 제삼자의 지적
        재산권을 침해한다고 주장하는 제삼자의 주장에 대해 조사, 방어, 해결,
        이행할 책임을 지지 않습니다. 귀하는 본 서비스를 사용할 때 해당 제삼자
        약관을 준수하는 데 동의합니다. Apple과 Apple의 자회사는 본 약관의 제삼자
        수혜자이며, 귀하가 본 약관을 수락하면 Apple은 본 약관의 제삼자
        수혜자로서 귀하에게 본 약관을 집행할 권리를 보유합니다(그리고 권리를
        수락한 것으로 간주됩니다).
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        면책
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하의 가입 단체를 대신하여 귀하는 다음과 관련하여 발생하는 모든 손해,
        손실, 모든 종류의 비용(합당한 변호사 수임료와 비용 포함)에 대해
        Spotify를 면책하고 손해가 없도록 보장하는 것에 동의합니다. (1) 귀하의 본
        약관(본 약관에 통합된 추가 Spotify 약관 및 조건)에 대한 위반, (2) 귀하가
        게시하거나 다른 방식으로 기여한 사용자 콘텐츠, (3) 본 서비스에서 또는 본
        서비스를 통해 참여한 모든 활동, (4) 귀하의 법률 위반이나 제삼자의 권리
        침해.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        준거법, 강제 중재 및 재판지
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        준거법 및 관할권
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 약관은 뉴욕주의 법률 선택 원칙이나 법률 충돌 원칙에 관계없이 미국
        뉴욕주 법률의 적용을 받으며 그에 따라 해석됩니다. 또한 귀하의 가입 단체
        및 Spotify는 아래 중재 계약에 따른 강제 중재의 대상이 되지 않으며 본
        약관 또는 본 서비스와 관련되거나 이와 관련하여 발생하는 분쟁, 청구 또는
        논쟁을 해결할 관할권이 뉴욕 카운티에 위치한 연방 및 주 법원에 있다는
        것에 동의하고, 해당 법원에 관할권, 재판지 또는 재판지 불편에 관한 이의를
        제기할 권한을 포기합니다.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        중재 계약
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 중재 계약 섹션은 귀하와 Spotify 간의 분쟁, 청구 및 논쟁을 중재로써
        해결할 때 적용되는 약관(이하 “중재 계약”)을 명시합니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 중재 계약은 미국 내 가입 단체 및 그 사용자에게만 적용됩니다.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        분쟁 해결 및 중재
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하와 Spotify는 본 약관 또는 서비스 사용자로서 귀하 및/또는 귀하의
        가입단체 및 Spotify와의 관계와 관련하여 발생하는 귀하와 Spotify 간의
        모든 분쟁, 청구 또는 논쟁이 (그것이 계약, 불법 행위, 법령, 사기, 허위
        진술 또는 기타 어떠한 법적 이론에 근거하든지 그리고 청구가 본 약관의
        해지 중에 발생하든 해지 후에 청구가 발생하든지 관계없이) 의무적인 구속력
        있는 개별 중재에 의해 결정된다는 것에 동의합니다. 또한 귀하의 가입
        단체를 대신하여 귀하와 Spotify는 중재자가 중재 계약의 존재, 범위 또는
        유효성 또는 모든 청구 또는 반청구에 대한 중재 가능성 등에 대한 이의를
        포함하여 자신의 사법권에 따라 판결할 독점적 권한을 보유한다는 데
        동의합니다. 중재에는 판사나 배심원이 없으며, 중재결정에 대한 법원 검토는
        제한됩니다. 중재자는 본 약관을 따라야 하며, 중재자는 중재 당사자에게만
        선언적 또는 지시적 금지 명령 구제를 포함하는 구제 조치를 판정할 수
        있다는 점을 제외하고는 법원과 동일한 손해 및 구제 조치(관련 법률에서
        허용하는 경우에만 변호사 비용 및 기타 비용 포함)를 판정할 수 있습니다.
        본 중재 조항은 본 약관 해지 후에도 존속합니다.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        예외 조항
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하의 가입 단체를 대신하여 귀하와 Spotify는 본 중재 계약의 어떠한
        내용도 (1) 미국 소액 청구 법원에서 또는 (2) 어떠한 법원에서 위의 분쟁
        해결 및 중재 섹션에서 언급하는 관할권 및 재판지에 따라 (a) 임시 또는
        예비적인 개별 금지명령 구제와 중재자의 최종 판결에 대한 보류를 구하거나,
        (b) 공개 금지명령 구제와 중재인의 청구 판정에 대한 보류를 구하는
        개별적인 소송을 언제든지 제기할 수 있는 당사의 권리를 포기하거나
        배제하거나 제한하는 것으로 간주되지 않는다는 데 동의합니다. 또한 본 중재
        계약은 귀하 또는 당사가 연방, 주 또는 지방 기관에 문제를 제공하는 것을
        막지 않습니다. 해당 기관은 법률이 허용하는 경우 귀하를 대신하여 당사에
        구제 조치를 구할 수 있습니다(또는 그 반대의 경우도 동일).
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        집단 소송 또는 대표 소송 금지, 집단 소송 포기
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하 및 Spotify는 각자가 개인 자격으로만 상대에게 청구를 제기할 수
        있으며, 어떠한 집단 소송이나 대표 소송의 원고나 일원이 되지 않는다는
        것에 동의합니다. 귀하와 Spotify가 모두 동의하지 않는 한, 중재자나 판사는
        한 사람 이상의 청구를 통합하거나 다른 형태의 대표소송이나 집단 소송을
        주재할 수 없습니다. 중재자는 구제 조치를 구하는 개별 당사자를 위해, 해당
        당사자의 개별적인 청구에 의해 보증되는 구제 조치를 제공하는 데 필요한
        한도 내에서 금지 명령 구제를 판정할 수 있습니다. 관련 법률이 특정 구제
        청구와 관련하여 본 단락의 제한 중 어떤 것의 집행을 배제한다고 법원이
        결정하는 경우, 해당 청구(그리고 해당 청구만)는 중재에서 분리되어야 하며
        법원에 소송을 제기할 수 있습니다.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        중재 규칙
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하 또는 당사가 중재 절차를 시작할 수 있습니다. 귀하와 Spotify 간의
        모든 중재는 본 중재 계약에 의해 수정된 대로, 중재 시점에서 시행 중인
        미국중재협회(American Arbitration Association, "AAA")의 소비자 중재
        규칙("AAA 규칙")에 따라 시행됩니다. 귀하와 Spotify는 (상기 법률 조항의
        선택에도 불구하고) 연방중재법이 본 조항의 해석 및 시행에 적용되고 이를
        규율한다는 데 동의합니다. AAA 규칙 및 AAA와 함께 진행되는 중재 절차를
        신청하는 방법에 대한 지침은 adr.org에서 확인하거나 1-800-778-7879로
        AAA에 문의하여 확인할 수 있습니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        중재 심리는 가급적 전화 또는 화상 회의를 통해 진행되지만, 중재자가 직접
        심리를 진행해야 한다고 판단하는 경우에는 AAA 규칙에 따라 중재인이 심리
        장소를 결정합니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        귀하가 중재 절차를 신청하기로 결정하고 신청 수수료를 지불해야 하는 경우,
        Spotify는 귀하의 청구 금액이 미화 10,000달러를 초과하는 경우를 제외하고
        귀하에게 해당 신청 수수료를 배상하며, 이 경우 귀하가 신청 수수료에 대한
        책임을 집니다. Spotify는 AAA 규칙 또는 법원 명령이 달리 요구하지 않는 한
        중재자 보수에 대한 귀하의 몫을 포함하여 기타 모든 중재 수수료를
        지급합니다. 중재자는 중재의 수행 방식에 관계없이 결정 및 판정의 근거가
        되는 핵심적 조사 결과와 결론을 충분히 설명할 수 있는 합리적인 서면
        결정문을 발부합니다. 중재자는 해당 절차 중 언제든지 그리고 본안에 대한
        중재자의 판결 후 14일 이내에 각 당사자의 요청이 있을 경우, 수수료 또는
        경비의 지급 및 배상에 관한 분쟁을 판결하고 해결할 수 있습니다.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        통지, 절차
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        중재를 신청하고자 하는 당사자는 먼저 분쟁에 대한 서면 통지를 다른
        당사자에게 전자 우편(legal@spotify.com)으로 전송하고, 동시에 등기우편,
        Federal Express, UPS 또는 Express Mail(서명 필요) 등 방식을 이용하여
        아래 주소로 보내야 합니다(이하 “통지”). 통지를 위한 Spotify의 주소는
        Spotify USA Inc., Attn: General Counsel, 4 World Trade Center, 150
        Greenwich Street, 62nd Floor, New York, New York 10007, USA입니다.
        통지는 반드시 (1) 청구 또는 분쟁의 성격과 근거를 설명해야 하고, (2) 특정
        구제책(이하 “요구”)을 제시해야 합니다. 당사는 청구를 직접 해결하기 위해
        선의의 노력을 기울일 것에 동의하지만, 통지를 받은 후 30일 이내에 합의에
        도달하지 않는 경우, 귀하나 Spotify가 중재 절차를 시작할 수 있습니다.
        중재 중에 귀하나 Spotify가 제안한 합의 금액은 중재자가 최종 결정 및
        판정을 내릴 때까지 중재자에게 공개되지 않습니다(있을 경우). 분쟁이
        중재를 통해 귀하에게 유리하게 최종 해결되고 중재자가 Spotify의 마지막
        서면 제안서 금액보다 큰 판정을 내리는 경우, Spotify는 판정 금액과
        1,000달러 중 더 큰 금액을 지급합니다. 수령자는 중재 과정에서 공개된 모든
        문서와 정보에 관해 엄격하게 기밀을 유지해야 하고 중재 목적 또는 중재자의
        결정 및 판정 집행 이외의 목적으로 사용해서는 안 되며, 해당 정보는 해당
        목적을 위해서 또는 관련 법률의 요구에 따라 알아야 할 사람에게 비밀리에
        공개되어야 합니다.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        집행 가능성
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 중재 계약의 전부나 일부가 무효화될 경우, 당사자들은 위의 ‘준거법 및
        관할권’ 섹션에서 언급하는 배타적 관할권과 재판지가 그러한 무효의 결과로
        인해 더 이상 본 중재 계약의 적용을 받지 않는 분쟁, 청구 또는 논쟁에 대해
        적용된다는 데 동의합니다.
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="7-about-terms">
        7. 본 약관에 대한 정보
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        관련 법률에 따라 귀하에게 계약으로 제한할 수 없는 특정 권리가 있을 수
        있습니다. 본 약관은 그러한 권리를 제한하려는 의도를 내포하지 않습니다.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        본 약관의 변경
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        당사는 해당 Spotify 서비스에 개정된 약관을 게시하는 것을 포함하여 모든
        합리적인 방법으로 이러한 변경 사항을 귀하에게 통지함으로써 본
        약관(여기에 참조로 통합된 추가 Spotify 약관 포함)을 수시로 변경할 수
        있습니다(단, 중대한 변경 사항의 경우, 당사는 이메일, 서비스 내 팝업
        메시지, 눈에 잘 띄는 서비스 내 통지 또는 기타 방법으로 이러한 통지를
        보완할 것입니다). 이러한 변경 사항은 귀하 및 본 약관이 변경된 날짜
        이전에 발생한 당사 간의 분쟁에는 적용되지 않습니다. 본 약관의 변경 후 본
        서비스를 사용하면 해당 변경 사항에 동의하는 것으로 간주됩니다.
        업데이트된 약관에 따라 본 서비스를 계속 이용하지 않으려면 당사에
        연락하여 계정을 해지할 수 있습니다. 본 문서에 처음 명시된 발효일은 본
        약관이 마지막으로 변경된 시점을 나타냅니다.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        완전한 합의
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 섹션에 명시되어 있거나 귀하와 Spotify 간에 서면으로 명시적 합의가
        이루어진 경우를 제외하고, 본 약관은 귀하와 Spotify 간에 합의된 모든 이용
        약관을 구성하며, 서면으로든 구두로든 본 약관의 주제와 관련된 이전의 모든
        계약을 대체합니다. 위에서 언급한 바와 같이 Spotify 사용자 가이드라인,
        Spotify 저작권 방침, 및 Spotify 지원 커뮤니티 약관을 포함하여 본
        서비스의 이용에 적용되는 기타 약관은 본 약관에 참조로 통합됩니다.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        분리 가능성 및 포기
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        본 약관에 달리 명시되지 않은 한, 본 약관의 조항이 어떠한 이유나 범위
        내에서 무효하거나 집행 불가능한 것으로 판정될 경우, 본 약관의 나머지
        조항은 영향을 받지 않으며, 해당 조항의 적용은 법률이 허용하는 범위
        내에서 시행되어야 합니다.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify나 제삼자 수혜자가 본 약관이나 그 조항을 시행하지 않는다고 해서
        Spotify나 해당 제삼자 수혜자가 그렇게 할 권리를 포기하는 것은 아닙니다.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        양도
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify는 본 약관의 일부 또는 전부를 양도할 수 있으며, 본 약관에 따른
        권리 또는 의무를 전부나 일부 양도 또는 위임할 수 있습니다. 귀하는 본
        약관의 전체 또는 일부를 양도할 수 없으며, 본 약관에 따른 귀하의 권리를
        제삼자에게 이전하거나 재라이선스할 수 없습니다.
      </Type>
    </Layout>
  );
};
const TermsAndConditionsJa = () => {
  return (
    <Layout>
      <Type variant="altoBrio" as="h1" paddingBottom={spacer20}>
        利用規約
      </Type>
      <Type variant="cello" as="p" paddingBottom={spacer20}>
        2021 年 9 月 6 日から有効
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#1-introduction">
          はじめに
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#2-service-provider">
          弊社が提供する Spotify サービス
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#3-your-use-of-service">
          Spotify サービスの利用
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#4-property-rights">
          コンテンツおよび知的財産権
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#5-customer-support">
          カスタマーサポート、情報、質問、苦情
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#6-problems-disputes">
          問題および紛争
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#7-about-terms">
          本規約について
        </TextLink>
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="1-introduction">
        1. はじめに
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本利用規約 (以下「本規約」)
        は、本規約が規定する以下に関連するサービスの利用 (アクセスを含む)
        に適用されます。本規約をよくお読みください。上記のサービスには、本規約が組み込まれている、または本規約にリンクされているすべてのウェブサイトおよびソフトウェアアプリケーション
        (以下総称して「本サービス)」、ならびに本サービスを通じて提供されるあらゆる素材
        (以下「本コンテンツ」) が含まれます。本サービスの利用には、Spotify
        が提示する追加の契約条件が適用される場合があります。当該条件は、参照により本規約に組み込まれます。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本サービスは、音楽業界のユーザーのみがビジネス目的で利用できるようになっており、適用される消費者保護法で意図されている「消費者」、または個人、家族もしくは家庭の目的のために行動するいかなる人も利用できません。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本サービスに登録する、アクセスする、またはその他の方法で本サービスを利用することにより、お客様は、お客様が代表する主体、組織または企業
        (お客様が関係するパブリッシャー、サブパブリッシャーなどを含む)
        (以下、お客様の「登録主体」)
        に代わり本規約に同意し、かつ、以下を表明し保証したものとみなされます。(1)
        お客様が登録主体を本規約に拘束する権限を有する当該登録主体の授権代表者であること
        (今後も継続して登録主体の授権代表者であるか否かは問わない)、(2)
        登録主体が本規約に拘束されることに同意すること、および (3)
        お客様が、当該登録主体を代表して本規約に拘束されることに同意すること。上記のすべてに同意できない場合、お客様は本サービスを利用してはなりません。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本規約には、下記セクション 6
        にさらに規定されるとおり、紛争解決において、陪審裁判もしくはその他の裁判手続きまたは集団訴訟
        (種類を問わない)
        ではなく、個別仲裁の利用を要求する強制仲裁規定が含まれています。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        サービスプロバイダ
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本規約は、お客様の登録主体と、(a)
        お客様の登録主体が米国の法律の下で組織されているかその他の形で同法の適用を受ける場合は、4
        World Trade Center, 150 Greenwich Street, 62nd Floor, New York, New York
        10007 に事務所を有するデラウェア州法人である Spotify USA Inc.、(b)
        お客様の登録主体が米国以外の国の法律の下で組織されているかその他の形で同法の適用を受ける場合は、Regeringsgatan
        19, 111 53 Stockholm, Sweden に住所を有する Spotify AB (登録番号
        556703-7495)との間で締結されます。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        年齢および資格要件
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様の登録主体に代わり本サービスを利用し、本コンテンツにアクセスするには、(1)
        13 歳以上 (もしくは居住国における同等の最低年齢) であること、(2)
        居住国において未成年者である場合は、親または保護者の同意を得ていること、(3)
        お客様の登録主体に代わり弊社との間で拘束力のある契約を締結する能力を有しており、適用法に基づき契約の締結を禁止されていないこと、および
        (4)
        本サービスが利用できる国に居住していることが必要です。また、お客様は、自身が
        Spotify
        に送信する登録情報がすべて真実、正確かつ完全であることを約束し、常にそれを維持することに同意します。
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="2-service-provider"
      >
        2. 弊社が提供する本サービス。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        ベータ機能
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        弊社は、本サービスを通じてベータ機能 (以下「ベータ機能」)
        を随時提供することがあります。弊社は、ベータ機能を使用して、新機能のアイデアを試し、テストします。したがって、ベータ機能がいずれかの日に表示されたり、定期的に変更されたり、通知なく完全に消えたりする場合があります。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        本サービスの制限と変更
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        弊社は、本サービスを継続的に運用するために、合理的な努力を払います。ただし、本サービスの利用可能性は、お客様に対して責任を負うことなく、随時変わる場合があります。たとえば、次のような場合があります。
      </Type>

      <TypeList as="ul" listStyleReset={false}>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          本サービスは、技術的な問題、メンテナンスもしくはテストまたは更新
          (関連する法律や規制要件の変更を反映するために必要なものを含む)
          が原因で、一時的な中断が発生する場合があります。
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          弊社は、本サービスを常に進化させ、改善することを目指しています。また、本サービスのすべての部分
          (特定の機能、特徴、提供内容など) を変更、中断、または
          (永続的もしくは一時的に) 停止することがあります。
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          Spotify
          には、本サービスを通じて特定のコンテンツを提供する義務はなく、Spotify
          または該当する所有者は、予告なく本コンテンツを削除することができます。
        </Type>
      </TypeList>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        は、政府機関、その他の第三者、または弊社の支配を超える事象に起因するインターネット、その他のサービスの停止または障害に関しては、お客様に対する責任を一切負いません。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        第三者のアプリケーション、デバイス、およびオープンソースソフトウェア
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本サービスは、第三者のアプリケーション、ウェブサイト、サービス
        (以下「第三者アプリケーション」)、および第三者のパーソナルコンピュータ、携帯電話、タブレット、ウェアラブルデバイス、スピーカー、その他のデバイス
        (以下「本デバイス」)
        と統合されている場合や、その他の方法でこれらとやり取りする場合があります。お客様による当該第三者アプリケーションおよび本デバイスの使用には、該当する第三者からお客様に提供される追加の条件およびポリシーが適用される場合があります。Spotify
        は、第三者アプリケーションおよび本デバイスが本サービスと互換性があることを保証しません。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        データインサイト、間違い
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、本サービスが、お客様が利用できるように弊社の裁量で提供されるオプションサービスであることを認めます。本サービスでは、音楽の利用状況データおよびファンのデモグラフィックデータを表示できる場合があります。弊社は、当該データの正確性を確保するために懸命に努力していますが、本サービスまたは弊社が提供するデータが誤りなく利用できることを保証せず、間違い
        (お客様に提供するデータインサイトの間違いを含む)
        が随時発生しないことも保証しません。本サービスに不具合または間違いがある場合、弊社は、そうした間違いに対処またはそれらを是正するためにあらゆる合理的な努力を払います。お客様は、この無料サービスに含まれる間違い、エラー、もしくは不具合の結果として、またはお客様によるこのデータの利用に起因してお客様が被る損害賠償、責任、もしくは費用について、弊社を免責し、補償することに同意します。すべてのデータは、「現状のまま」お客様に提供されます。お客様は、弊社が提供するすべてのデータを、お客様の単独のリスクと裁量において利用するものとします。
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify は、本サービスを提供するために Spotify
        が利用するデータベースに保存されているユーザーコンテンツを保持および保護するため、合理的な予防措置を講じますが、お客様は、唯一の保存サービスとして本サービスに依拠してはならず、コンテンツのバックアップコピーを保持する必要があります。Spotify
        は、本コンテンツの破損、削除、または保存の失敗について責任を負いません。
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="3-your-use-of-service"
      >
        3. Spotify サービスの利用
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Spotify アカウントの作成
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本サービスのすべてまたは一部を利用するには、Spotify
        アカウントの作成が必要になる場合があります。ユーザー名とパスワードはお客様個人でのみ使用し、秘密保持する必要があります。お客様は、ユーザー名とパスワードのすべての使用
        (許可されていない使用を含む)
        については、ユーザーが責任を負うことを了承します。ユーザー名もしくはパスワードの紛失もしくは盗難が発生した場合、またはアカウントへの不正アクセスがあったと思われる場合は、ただちにカスタマーサービスチームまでご連絡ください。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        本サービスを利用する権利
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        本サービスへのアクセス
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様およびお客様の登録主体が本規約 (その他の適用される規約を含む)
        を遵守することを条件として、弊社は、本サービス (本コンテンツなどを含む)
        を利用する、限定的、非独占的、取消可能な許可
        (以下総称して「アクセス権」) をお客様 (お客様の登録主体の代表者として)
        に付与します。このアクセス権は、お客様の登録主体または Spotify
        が終了させない限り、有効に存続します。お客様は、本サービスまたは本コンテンツを再配布または転送しないことに同意します。本サービスのソフトウェアアプリケーションおよび本コンテンツは、お客様の登録主体に使用許諾されるものであり、お客様に対して販売または譲渡は行われません。また、Spotify
        およびそのライセンサーは、本サービスのソフトウェアアプリケーションおよび本コンテンツのすべてのコピーについて、お客様のデバイスへのインストール後も、その所有権を留保します。本サービスにアクセスする際、お客様は本サービスに過剰な負担をかける行為を行わないことに同意します。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        規約の遵守、委任
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、お客様の登録主体に代わり、お客様による本サービスへのアクセスおよび本サービスのその他の利用には本規約が適用されることを認め、これに同意します。お客様は、お客様の登録主体に代わり、本規約で明示的に許可されていない方法で本サービス、本コンテンツ、またはそれらの一部を利用しないことに同意します。本規約に別段の定めがない限り、お客様は、全部または一部を問わず、以下の行為を行わないものとします。(a)
        本サービスもしくはいずれかのコンテンツをコピーすること、(b)
        本サービスもしくはいずれかのコンテンツのコピーを配布すること、(c)
        本サービスもしくはいずれかのコンテンツを改ざん、改変、翻訳、逆エンジニアリング、改造、逆コンパイル、複製、分解、もしくは二次的著作物の作成を行うこと、(d)
        本サービスもしくはいずれかのコンテンツの使用、レンタル、貸与、サブライセンス、リース、配布、もしくはその他に関する権利を第三者に付与しようと試みること、または
        (e)
        本サービスもしくはいずれかのコンテンツへのリモートアクセスを何らかの方法で不特定の個人に許可すること。本サービスを利用するには、適用されるすべての法律、規則、規制を遵守し、第三者の知的財産、プライバシー、およびその他の権利を尊重する必要があります。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、本サービスを利用する権限を、当該利用を行うビジネス上の理由があるお客様の登録主体内の追加ユーザーにのみ委任することができます
        (以下それぞれを「代行者」)。お客様は、代行者を、お客様の登録主体による許可および有効なビジネス上の根拠を有する本サービス内の特定のチームにのみ追加する必要があります。お客様の代行者のいずれかが本サービスにアクセスしたり、その他の方法で利用したりした場合、お客様はお客様の登録主体に代わり、本規約が当該代行者による本サービスの利用にも適用されることを認め、これに同意するものとします。お客様は、お客様の各代行者が、登録主体を代表して、本サービスを利用する権限を有し、かつ自らの権限を追加ユーザーにさらに委任する権限を有していることを弊社に表明、保証および誓約します。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、お客様の登録主体に代わり、(1)
        お客様およびすべての代行者が本規約を遵守すること、(2)
        登録主体が、お客様および各代行者による本規約の違反について全責任を負うこと、ならびに
        (3)
        登録主体が、本規約の目的上のお客様およびお客様の代行者の作為または不作為について責任を負うことに明示的に同意します。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Spotify の所有権
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本サービスおよび本コンテンツの所有権は、Spotify または Spotify
        のライセンサーに帰属します。Spotify
        のすべての商標、サービスマーク、商号、ロゴ、ドメイン名、および Spotify
        ブランドのその他の機能 (以下「Spotify ブランド機能」)
        の所有権は、Spotify
        またはそのライセンサーにのみ帰属します。本規約は、Spotify
        ブランド機能を商用利用または非商用利用する権利をお客様またはお客様の登録主体に付与するものではありません。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        輸出規制および制裁
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        の製品には、米国の輸出・再輸出規制に関する法令および他の法域で適用される同様の法律が適用される場合があります。これには、米国商務省が管理する輸出管理規則
        (以下「EAR」)、財務省外国資産管理局 (以下「OFAC」)
        が管理する貿易・経済制裁措置、および国務省が管理する国際武器取引規則
        (以下「ITAR」)
        が含まれます。お客様は、お客様およびお客様の登録主体のいずれも、(1)
        米国が物品の禁輸を行っているかその他の経済制裁を適用している国に所在しておらず、(2)
        適用される輸出・再輸出に関する法令、他の法域で適用される同様の法律、その他米国政府の禁止・制限対象者リストに記載されている取引禁止対象者でなないことを保証します。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、お客様の登録主体に代わり、OFAC が管理する EAR
        および貿易・経済制裁措置など含むすべての該当する輸出・再輸出規制に関する法令を遵守することに同意します。具体的には、お客様は、お客様の登録主体に代わり、本規約に基づいて
        Spotify から受領した製品、ソフトウェア、技術
        (当該技術から派生した、または当該技術に基づく製品を含む) を、EAR、OFAC
        が管理する貿易・掲載制裁措置、または米国もしくはその他の法域の適用される法令で禁止されている目的地、団体、個人に対して、これらの法令で必要とされる事前承認を管轄政府機関から得ることなく、直接的または間接的に、使用、販売、輸出、再輸出、移転、転用、リリース、またはその他の方法で処分しないことに同意します。
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="4-property-rights"
      >
        4. コンテンツおよび知的財産権
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        ユーザーコンテンツ
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        本サービスに投稿するコンテンツ
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、お客様の登録主体に代わり、本サービスにコンテンツを投稿、アップロード、またはその他の方法で提供することができます
        (以下「ユーザーコンテンツ」)。疑義を避けるために記載すると、「ユーザーコンテンツ」には、ユーザーが本サービスに追加、作成、アップロード、送信、配布または投稿するすべての情報、素材、その他のコンテンツが含まれます。Spotify
        および/または Spotify
        によって指名された第三者は、その独自の裁量により、当該ユーザーコンテンツに関連して提供されたメタデータの全部または一部を使用すること、ならびに当該メタデータを補足および/または交換することを決定できます。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様およびお客様の登録主体は、お客様が投稿するすべてのユーザーコンテンツについて単独で責任を負います。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、お客様の登録主体に代わり、お客様が本サービスに投稿するユーザーコンテンツに関して、以下を約束するものとします。(1)
        お客様が当該ユーザーコンテンツを投稿する権利を所有または有していること。(2)
        当該ユーザーコンテンツ、または後述のとおりに弊社に付与されたライセンスに基づく
        Spotify による当該ユーザーコンテンツの使用が、(i) 本サービス規約
        (Spotify
        ユーザーガイドラインを含む)、適用法、いかなるギルド、組合、団体の規制および規則にも違反せず、他者の知的財産
        (著作権などを含む)、パブリシティ、プライバシー、人格、契約その他の権利を含む、いかなる第三者の権利も違反または侵害しておらず、(ii)
        Spotify
        または何らかのアーティスト、バンド、レーベル、その他の個人または団体によるお客様またはお客様のユーザーコンテンツとの提携または支持を、Spotify
        または当該個人もしくは団体から事前の明示的な書面による同意を得ることなく暗示しないこと。(3)
        お客様が本サービスに投稿するユーザーコンテンツに関連し、かつ本規約内で付与されるライセンスを行使するために
        Spotify
        が要求する、第三者の権利、ライセンス、認証、同意、許可および承認をお客様が有し、取得し、保持し、適切に管理していること。(4)
        お客様が、本項 (3)
        に記載されている第三者の各ライセンス、認証、同意、許可および承認に定められている条件を遵守する責任を単独で負い、かつ、当該第三者のライセンス、認証、同意、許可および承認の下で必要とされる場合、すべての第三者に対して、ロイヤルティ、手数料、その他の金銭
        (性質を問わない) のすべての支払いを行う責任を単独で負うこと。(5)
        お客様が本サービスに投稿するユーザーコンテンツ、または Spotify
        による本規約で付与されたライセンスの行使に関連または起因して、いずれかの個人もしくは団体に対して、またはいずれかの個人もしくは団体に代わり、Spotify
        により、または Spotify
        に代わり支払われるべきロイヤルティ、手数料、その他の金銭
        (性質を問わない) が一切存在しないこと。(6)
        お客様が本サービスに投稿するすべてのユーザーコンテンツが正確であり、弊社のユーザーガイドラインに違反するコンテンツを含まないこと。(7)
        お客様が、本サービスにユーザーコンテンツを投稿する際、適用されるすべての法律、規制、および業界基準を遵守すること。これには、米国連邦取引委員会
        (FTC) の Guidelines Concerning the Use of Testimonials and Endorsements
        in Advertising
        (広告における推薦および証言の使用に関するガイドライン)、FTC の .com
        Disclosures Guide (ドットコムディスクロージャーガイド)、FTC のNative
        Advertising Guidelines
        (ネイティブ広告ガイドライン)、およびFTCが適宜発行するその他のガイドライン、およびそれらの更新が含まれます。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本サービス上でユーザーコンテンツを投稿または共有した場合、特定のユーザーコンテンツが一般にアクセス可能になること、ならびに本サービスおよび他の
        Spotify
        サービスおよびウェブ上で他のユーザーがこれを使用したり再共有したりできることをご承知おきください。そのため、本サービス上で投稿または共有する際には注意を払い、アカウントの設定を慎重に行ってください。Spotify
        は、お客様または他者が本サービス上で投稿または共有する内容について責任を負いません。1
        人以上の他のユーザーや登録主体もアクセスできる本サービスの特定のページまたはアカウントにお客様またはお客様の登録主体がアクセスできる範囲で、お客様の特定のユーザーコンテンツ
        (お客様の名前、役割、アクセスレベル、本サービス上でお客様が行う特定のアクションなどを含む)
        は、当該他のユーザーや登録主体に表示される場合があります。ページまたは資産へのお客様のアクセス権および編集権は、当該素材に対するお客様の基本的な権利および本サービスへのお客様のアクセスレベルによって異なる場合があります。場合によっては、本サービスの特定のページまたはアカウントの管理権や編集権を他のユーザーまたは登録主体と共有することができます。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        ユーザーコンテンツの削除および監視
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        は、本サービスにユーザーコンテンツを含めたり、本サービスを介してユーザーコンテンツを配信したりする義務を一切負いません。Spotify
        は、ユーザーコンテンツを監視または確認するいかなる義務も負いません。適用法で禁止されている範囲を除き、Spotify
        は、ユーザーコンテンツが Spotify
        ユーザーガイドラインに違反した場合などを含め、理由の有無を問わず、その独自の裁量により、本サービスからユーザーコンテンツを削除、またはユーザーコンテンツへのアクセスを無効にする権利を留保します。Spotify
        は、お客様または第三者に事前に通知することなく、かつ当該削除についてお客様に対して責任を負うことなく、これらの措置を講じることができます。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        お客様が弊社に付与するライセンス
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        ユーザーコンテンツ
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        は、お客様が本サービスに投稿したユーザーコンテンツの所有権を主張することはありません。ユーザーコンテンツを本サービスに投稿した後、お客様と
        Spotify
        との間においては、お客様のユーザーコンテンツに関してお客様が有する権利
        (お客様のユーザーコンテンツに関連する知的財産権その他の所有権を含む)
        は、Spotify
        に付与するライセンスを条件として、本セクションの次の段落に従ってお客様が引き続き保持します。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本サービスにユーザーコンテンツを投稿することにより、お客様は、お客様の登録主体に代わり、本サービスおよび
        Spotify の音楽ストリーミングサービス、ならびに本サービスおよび Spotify
        の音楽ストリーミングサービスのプロモーションおよびマーケティングに関連して、当該ユーザーコンテンツを、あらゆる媒体で、単独か他のコンテンツもしくは素材との組み合わせであるかを問わず、現在知られているか今後作成されるあらゆる方法、手段または技術により、複製、提供、実行、表示、翻訳、変更、二次的著作物を作成、配布、その他の方法で使用することができる、非独占的、譲渡可能、サブライセンス可能、ロイヤルティフリー、全額支払い済み、かつ全世界で有効なライセンスを
        Spotify に付与します。Spotify
        によるこれらの目的でのお客様のユーザーコンテンツの使用を望まない場合は、本サービスにユーザーコンテンツを投稿しないでください。また、お客様が、氏名、肖像、写真、またはブランド機能を含むユーザーコンテンツを提供する範囲において、お客様は、本サービスおよび
        Spotify
        の音楽ストリーミングサービス上でのお客様のユーザーコンテンツの利用可能性を広告、マーケティングおよびプロモーションするために、本サービスおよび
        Spotify
        の音楽ストリーミングサービス上、および弊社のマーケティングコミュニケーションにおいて当該氏名、肖像、もしくは写真を使用することができる、非独占的、全額支払い済み、かつ全世界で有効な権利を弊社に付与します。該当する場合、および適用法で許可される範囲において、お客様は、フィードバック
        (下記に定義)
        を含むユーザーコンテンツの著作者であることを主張する権利、およびユーザーコンテンツの同一性が損なわれるような取り扱いに異議を唱える権利などの「著作者人格権」または同等の権利を放棄し、これを行使しないことにも同意します。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        フィードバック
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様が本サービスまたは本コンテンツの利用に関連するアイデア、提案、またはその他のフィードバック
        (以下「フィードバック」)
        を提供する場合、そのようなフィードバックは秘密情報ではないものとし、これらは制限なく、およびお客様への支払いなく、Spotify
        により使用される場合があります。フィードバックは、本規約に基づくユーザーコンテンツの一種とみなされます。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        お客様のデバイス
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様はまた、本サービスの運用を円滑にするために、本サービスでお客様のデバイスのプロセッサ、帯域幅、およびストレージハードウェアを使用できるようにする権利を弊社に付与します。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        侵害の申し立て
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        は知的財産の所有者の権利を尊重します。本コンテンツが著作権を侵害していると思われる場合は、Spotify
        著作権ポリシーを参照してください。
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="5-customer-support"
      >
        5. カスタマーサポート、情報、質問、および苦情。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        カスタマーサポート、情報、質問、苦情
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        カスタマーサポート (以下「カスタマーサポートのお問い合わせ」)
        については、弊社ウェブサイトの「お問い合わせ」セクションに記載されているカスタマーサポートリソースをご利用ください。また、本規約の冒頭の「サービスプロバイダ」セクションに記載されている郵送先住所にお問い合わせいただくこともできます。
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="6-problems-disputes"
      >
        6. 問題および紛争
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        本サービスの一時停止と終了
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本規約は、お客様の登録主体または Spotify
        によって終了されるまで、引き続きお客様に適用されます。Spotify
        は、お客様またはお客様の登録主体が本規約のいずれかに違反したと判断した場合、本サービスまたはその素材コンポーネントの提供を停止した場合、または適用法に従う必要があると判断した場合には、本規約
        (本規約に組み込まれている追加の契約条件を含む)
        を終了するか、またはお客様による本サービスへのアクセスをいつでも停止することができます。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様および/またはお客様の登録主体と第三者との間でアカウント
        (代行者のアカウントを含む)
        の所有権または承認された使用に関する紛争がある場合、Spotify
        は、お客様、お客様の代行者、その他の個人または団体
        (お客様の登録主体を含む)
        に対して一切の責任を負うことなく、当該アカウントへのすべてのアクセスをいつでも停止することができます。Spotify
        は、ユーザー間の紛争を解決することができます。または、関係当事者らに紛争の解決を委ねる場合があり、当該当事者らは、管轄裁判所の救済を求めることができます。Spotify
        が紛争を解決する場合、お客様は、Spotify
        の決定が最終的であり、お客様およびお客様の登録主体に対して拘束力を有すること、ならびにお客様またはお客様の登録主体のいずれも
        Spotify に対する訴訟原因を有さない
        (ただしお客様は、適用法に基づく第三者に対する償還請求権を有する場合があります)
        ことに同意するものとします。Spotify
        はまた、管轄裁判所からの法定命令に従います。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様の登録主体もしくは Spotify が本規約を終了した場合、または Spotify
        が
        お客様による本サービスへのアクセスを一時停止した場合、お客様は、Spotify
        がお客様もまたはお客様の登録主体に対して責任を負わないこと、および
        (本規約で明示的に定められている場合を除き)
        すでに支払われた金額の払い戻しを行わないことに同意します。お客様の登録主体は、本規約をいつでも終了すること、または本サービスへのお客様個人のアクセス権を終了することができます。その場合、お客様は、本サービスへのアクセスまたはその利用ができなくなります。Spotify
        アカウントを終了する方法については、弊社の「会社概要」ページのカスタマーサポートリソースをご利用ください。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        以下のセクションは、終了後も存続するものとします。セクション 2
        (弊社が提供する本サービス)、セクション 3 (本サービスの利用)
        (当該セクション内で定められる場合を除く)、セクション4
        (コンテンツおよび知的財産権)、セクション 6 (問題および紛争)、セクション
        7
        (本規約について)、および明示的にまたはその性質により本規約の終了後も有効である必要がある本規約のその他のセクション。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        保証の否認
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本サービスは、明示、黙示、または制定法上のいかなる保証もなく、「現状のまま」かつ「提供可能な範囲で」提供されます。さらに、Spotify
        およびコンテンツのすべての所有者は、当該コンテンツについて、明示、黙示、および制定法上の保証
        (満足のいく品質、商品性、特定目的への適合性、または非侵害性の保証を含む)
        を一切否認します。Spotify
        およびコンテンツの所有者はいずれも、本サービスまたは当該コンテンツにマルウェアその他の有害なコンポーネントが存在しないことを保証しません。また、Spotify
        は、第三者アプリケーション
        (またはそのコンテンツ)、ユーザーコンテンツ、デバイス、または第三者が本サービスまたはハイパーリンクされたウェブサイト上、またはこれらを通じて宣伝、プロモーション、または提供する製品またはサービスについて、いかなる表明も保証も行わず、一切責任を負いません。さらに、Spotify
        は、お客様と前述の第三者プロバイダとの間のいかなる取引についても責任を負いません。お客様が
        Spotify から得た口頭または書面によるいかなる助言または情報も、Spotify
        に代わって行われる保証となることはありません。本セクションは、適用法で許可される最大限の範囲で適用されます。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        責任の限定および請求の申立期限
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、本サービスに関する問題または不満に関する唯一かつ排他的な救済が
        Spotify
        ソフトウェアのアンインストールおよび本サービスの利用停止であることに同意します。お客様は、本サービスを通じて、または
        本サービスに関連して提供された第三者アプリケーションまたはそのコンテンツに起因または関連して、Spotify
        がいかなる義務も責任も負わないことに同意します。また、お客様と当該第三者アプリケーションとの関係には、当該第三者との個別の契約が適用される場合がありますが、第三者アプリケーションまたはそのコンテンツに関する問題もしくは不満については、Spotify
        に関する場合と同様に、当該第三者アプリケーションのアンインストールまたは利用停止がお客様の唯一かつ排他的な救済となります。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        いかなる場合も、Spotify、その役員、株主、従業員、代理人、取締役、子会社、関連会社、承継人、譲受人、サプライヤーまたはライセンサーは、次のいずれについても責任を負わないものとします。(1)
        間接損害、特別損害、付随的損害、懲罰的損害、または派生的損害、(2)
        本サービス、デバイス、第三者アプリケーション、もしくは第三者アプリケーションのコンテンツの使用または使用不能に起因するすべての場合における、使用機会の喪失、データの損失、取引上の損失、または利益の損失
        (直接または間接を問わない) (法的理論にかかわらず、Spotify
        が当該損害の可能性について警告されていたかを問わず、かつ、救済策がその本質的目的を果たさなかった場合も含む)、(3)
        本サービス、第三者アプリケーション、または第三者アプリケーションのコンテンツに関連するすべての請求に対する累積損害賠償で、(a)
        初回請求前の 12 か月間にお客様が Spotify に支払った金額、または 30.00
        ドルのうちいずれか大きい方を超える金額。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        明確にするために付言すると、本規約は、適用法で制限が禁止される範囲において、不正行為、悪意のある不実表示、死亡または人身傷害に対する
        Spotify の責任を制限しません。
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本規約に基づき生じるすべての請求は、請求権を行使する当事者が請求原因である作為、不作為、もしくは不履行を最初に知った日または合理的に知るべきであった日から
        1 年以内に
        (仲裁要求の申し立てまたは後述の仲裁合意に基づく個別の訴訟提起により)
        開始されなければなりません。当該期限内に請求権が行使されなかった場合、当該請求について救済を求める権利は存在しないものとします。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        第三者の権利
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、当該コンテンツの所有者および特定のディストリビュータ
        (アプリストアのプロバイダなど)
        は本規約の受益者となることを意図されており、これらの者は本規約をお客様に直接適用する権利を有することを認め、これに同意します。本規約は、本セクションに定める場合を除き、お客様および
        Spotify
        以外の者に権利を付与することを意図しておらず、いかなる場合においても本規約が第三者受益権を創出することはないものとします。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Apple Inc. (以下「Apple」) の App Store
        からモバイルソフトウェアアプリケーション (以下それぞれを「アプリ」)
        をダウンロードしている場合、または iOS
        デバイスでアプリを使用している場合、お客様は、Apple
        に関する以下の通知を読み、理解し、これに同意するものとします。本規約は、お客様の登録主体と
        Spotify との間にのみ適用され、Apple
        との間には適用されません。また、Apple
        は本サービスおよびその内容について責任を負いません。Apple
        は、本サービスに関するメンテナンスおよびサポートサービスを提供する義務を一切負いません。本サービスが適用される保証に適合しない場合、お客様は
        Apple にその旨を通知することができ、Apple
        は当該アプリに適用される購入代金をお客様に返金するものとします。また、適用法で許可されている最大限の範囲において、Apple
        は本サービスに関するその他の保証義務を一切負いません。Apple は、(1)
        製造物責任に関する請求、(2)
        適用される法的要件または規制要件への本サービスの不適合に関する請求、(3)
        消費者保護または同様の法律に基づく請求、および (4)
        知的財産権の侵害に関する請求を含め、本サービスまたはお客様による本サービスの所有もしくは利用に関連して、お客様または第三者から行われるいかなる請求についても対処する責任を負いません。Apple
        は、第三者が、本サービスまたはお客様によるアプリの所有および使用が当該第三者の知的財産権を侵害していると主張した場合でも、そのような主張に関する調査、防御、和解および免責について責任を負いません。お客様は、本サービスを利用する際に、該当する第三者の規約に従うことに同意します。Apple
        および Apple
        の子会社は、本規約の第三者受益者です。お客様が本規約に同意した場合、Apple
        は、本規約の第三者受益者としてお客様に対して本規約を強制する権利を有します
        (および強制する権利を受諾しているとみなされます)。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        補償
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様は、お客様の登録主体に代わり、以下の事項に起因もしくは関連する、あらゆる種類の損失、損害、および費用
        (合理的な弁護士費用を含む) について、Spotify
        を補償し、免責することに同意します。(1) お客様による本規約の違反
        (本契約に組み込まれている他の Spotify 契約条件を含む)、(2)
        お客様が投稿またはその他の方法で寄稿したユーザーコンテンツ、(3)
        お客様が本サービス上で、またはこれを通じて行ったあらゆる活動、および (4)
        お客様による法律の違反または第三者の権利の侵害。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        準拠法、強制仲裁および裁判地
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        準拠法および裁判管轄
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本規約は、米国ニューヨーク州法に準拠し、これに従って解釈されるものとします。ただし、ニューヨークの準拠法の選択または法の抵触の原則は適用しないものとします。また、お客様の登録主体と
        Spotify
        は、後述の仲裁合意による強制仲裁の対象とならない、本規約または本サービスに関連もしくは起因する紛争、請求、または論争を解決するために、ニューヨーク州ニューヨーク郡に所在する連邦裁判所および州裁判所の管轄に同意し、当該裁判所に対する管轄権、裁判地、または不便宜な法廷地に関する申立てを放棄します。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        仲裁合意
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        仲裁合意に関する本セクションは、お客様と Spotify
        の間で生じた紛争、請求、および論争を、仲裁を通じて解決するための条件
        (以下「仲裁合意」) を定めるものです。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本仲裁合意は、米国に所在する登録主体およびそのユーザーにのみ適用されます。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        紛争の解決および仲裁
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様 と Spotify は、お客様および/またはお客様の登録主体と Spotify
        との間で本規約または本サービスのユーザーとしての Spotify
        との関係に何らかの形で関連して生じた紛争、請求または論争については、(契約、不法行為、法令、不正行為、不実表示またはその他の法的理論に基づくか、また請求が本規約の終了以降に生じたか否かを問わず)
        すべて強制的な拘束力のある個別の (集団ではない)
        仲裁により解決されることに同意します。お客様の登録主体の代理としてのお客様と
        Spotify は、仲裁人が自身の管轄事項
        (仲裁合意の存在、範囲もしくは妥当性に関する異議、または請求もしくは反訴の仲裁可能性を含む)
        を裁定する独占的な権限を有することに同意します。仲裁では裁判官も陪審員も存在せず、仲裁裁定の裁判所による審査は限定的です。仲裁人は、本規約に従わなければならず、裁判所と同じ損害賠償および救済
        (適用法により許可される限り弁護士報酬および費用を含む)
        を裁定することができます。ただし、仲裁人は、仲裁当事者以外の者に利益をもたらす救済
        (宣言的救済または差止命令による救済を含む)
        を裁定することはできません。本仲裁条項は、本規約の終了後も存続します。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        例外
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様の登録主体の代理としてのお客様と Spotify
        の両者は、本仲裁合意のいかなる部分も、両当事者のいずれかが (1)
        米国の少額裁判所、または (2)
        上記の「紛争の解決および仲裁」のセクションに定める管轄および裁判地に基づく裁判所において、(a)
        仲裁人による最終裁定が下されるまでの間、一時的かつ暫定的な個別化された差止命令による救済、または
        (b)
        仲裁人からそうした請求の実体に関する裁定が下されるまでの間、公的な差止命令による救済を求める個別の訴訟をいつでも提起する権利を放棄、排除またはその他の形で制限するとはみなされないことに同意します。さらに、本仲裁合意は、お客様または弊社が連邦、州または地域の機関に対して問題を提起することを妨げるものではありません。このような機関は、法律で許可されている場合、お客様に代わって弊社に対して救済を求めることができます
        (またはその逆も可能です)。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        集団・代表訴訟手続きの否認、集団訴訟の放棄
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様および Spotify
        は、それぞれが個人としての立場でのみ相手方に対して請求を申し立てることができ、いかなる目的においても集団訴訟または代表訴訟の原告として、またはクラスメンバーとして請求を行わないことに同意します。お客様および
        Spotify
        の双方が同意しない限り、いかなる仲裁人および裁判官も、複数の人物の請求を併合したり、その他の方法で何らかの形式の代表訴訟または集団訴訟を進めたりすることはできません。仲裁人は、救済を求める個々の当事者の利益のために、および当該当事者の個別の請求を根拠とする救済の提供に必要な範囲において、差止命令による救済を裁定することができます。特定の救済の請求に関して、裁判所が、本項の制限のいずれかの実施が適用法で禁止されていると判断した場合、その請求は、(その請求に限り)
        仲裁から分離されなければならず、裁判所に提起することができます。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        仲裁規則
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様または弊社のいずれも仲裁手続きを開始できます。お客様と Spotify
        との間の仲裁は、その時点で有効な米国仲裁協会 (以下「AAA」)
        の消費者仲裁規則 (以下「AAA規則」)
        を本仲裁合意によって変更した規則に基づいて行われます。お客様と Spotify
        は、本条項の解釈および執行については、(上記の準拠法条項にかかわらず)
        米国連邦仲裁法が適用され、これに準拠することに同意します。AAA
        規則、および AAA への仲裁手続きの提起方法に関する手引きは、adr.org
        に掲載されています。または、AAA に電話 (1-800-778-7879)
        で問い合わせることも可能です。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        仲裁の審理は、可能な限り電話またはビデオ会議で行われます。ただし、仲裁人が面談による審理を行うべきと判断した場合、そうした審理の場所は、仲裁人が
        AAA 規則に従い決定するものとします。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        お客様が仲裁手続きの申し立てを選択し、申し立て手数料を支払う必要がある場合、Spotify
        は、お客様の請求額が 1
        万米ドルを超える場合を除き、その申し立て手数料をお客様に支払います。請求額が
        1
        万米ドルを超える場合は、お客様が申し立て手数料に責任を負うものとします。Spotify
        は、AAA
        規則または裁判所命令による別段の要求がない限り、その他の仲裁手数料
        (仲裁人報酬のうちお客様が負担する部分を含む)
        を支払います。仲裁人は、仲裁の実施方法にかかわらず、決定および裁定
        (ある場合)
        の根拠となる重要な所見および結論を十分に説明した書面による決定を発行するものとします。仲裁人は、手続き中はいつでも、および実体的事実に関する仲裁人の裁定から
        14
        日以内に行われたいずれかの当事者からの要求に応じて、手数料または費用の支払いおよび払い戻しに関する紛争に裁定を下し、これを解決することができます。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        通知、プロセス
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        仲裁を求める当事者はまず、電子メールにてlegal@spotify.com
        宛、または配達証明郵便、フェデラルエキスプレス、UPS、もしくは速達郵便
        (署名が必要) にて下記の住所宛に、書面で紛争に関する通知 (以下「通知」)
        を相手方に送付する必要があります。Spotify の通知先住所: Spotify USA
        Inc., Attn: General Counsel, 4 World Trade Center, 150 Greenwich Street,
        62nd Floor, New York, New York 10007, USA。通知には、(1)
        請求または紛争の性質および根拠、ならびに (2) 求める救済の具体的な内容
        (以下「要求」)
        を記載する必要があります。弊社は、請求を直接解決するために誠実に努力することに同意しますが、通知の受領後
        30 日以内に合意に達しない場合、お客様または Spotify
        は、仲裁手続きを開始することができます。仲裁が行われている間に、お客様または
        Spotify
        が行った和解案の金額は、仲裁人が最終的な決定および裁定を下すまで、仲裁人に開示してはなりません。弊社の紛争が仲裁を通じてお客様に有利な形で最終的に解決され、仲裁人がお客様に下した裁定額が
        Spotify の直近の書面による和解案の金額よりも大きい場合、Spotify
        は、代わりに当該裁定額または 1,000
        ドルのいずれか高い方の金額をお客様に支払います。仲裁の過程で開示されたすべての文書および情報は、受領者によって厳密に秘密保持されるものとし、仲裁または仲裁人の決定および裁定を執行する目的以外で受領者が使用してはならず、当該目的のために知る必要がある者に秘密に開示される場合または適用法で義務付けられている場合を除き、開示してはならないものとします。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        強制可能性
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本仲裁合意の全部または一部が無効となった場合、両当事者は、そうした無効化の結果として、本仲裁合意の対象ではなくなった紛争、請求、または論争のあらゆる側面について、上記の「準拠法および裁判管轄」のセクションに定める専属管轄および裁判地に服することに同意します。
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="7-about-terms">
        7. 本規約について
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        適用法に基づき、お客様は、契約により制限できない特定の権利を有する場合があります。本規約は、これらの権利を制限することを意図していません。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        本規約の変更
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        弊社は、該当する Spotify
        サービスに変更後の本規約を掲載することを含む合理的な方法で変更をお客様に通知することにより、本規約
        (参照により本規約に組み込まれる追加の Spotify 規約を含む)
        を随時変更することができます
        (ただし、重大な変更については、電子メール、サービス内のポップアップメッセージ、本サービス内でのその他の明確な通知、またはその他の手段により通知を補足するよう努めます)。当該変更は、本規約が変更された日より前に生じたお客様と弊社との間の紛争には適用されません。本規約の変更後もお客様が本サービスを利用した場合、お客様は変更に同意したことになります。更新された本規約に基づき本サービスの利用を継続したくないお客様は、弊社に連絡してアカウントを終了することができます。本書の冒頭に記載されている効力発生日が本規約が最後に変更された日です。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        完全合意
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本セクションに記載されている場合を除き、またはお客様と Spotify
        との間で書面による明示的な合意がある場合を除き、本規約は、お客様と
        Spotify
        との間で合意されたすべての契約条件を構成し、本規約の主題に関して従前に取り交わされた書面または口頭による合意に優先します。前述のとおり、本サービスの利用に適用されるその他の契約条件
        (Spotify ユーザーガイドライン、Spotify 著作権ポリシー、および Spotify
        サポートコミュニティ規約を含む) は、参照により本規約に組み込まれます。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        可分性および権利放棄
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本規約に別段の定めがある場合を除き、本規約のいずれかの条項が何らかの理由または何らかの範囲で無効または強制不能と判断された場合でも、本規約の残りの条項は影響を受けず、法律で許可されている範囲において、当該条項の適用を強制することができます。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        または第三者受益者が本規約またはそのいずれかの条項を強制しなかった場合でも、Spotify
        または該当する第三者受益者が権利放棄をしたことにはならないものとします。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        譲渡
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        は、本規約の一部またはすべてを譲渡することができます。また、本規約に基づく自己の権利または義務を、全部または一部を問わず、譲渡または委任することができます。お客様は、本規約の全部または一部を第三者に譲渡し、または本規約に基づくお客様の権利を第三者に譲渡またはサブライセンスすることはできません。
      </Type>
    </Layout>
  );
};

const TermsAndConditionsPtBr = () => {
  return (
    <Layout>
      <Type variant="altoBrio" as="h1" paddingBottom={spacer20}>
        Termos e condições de uso
      </Type>
      <Type variant="cello" as="p" paddingBottom={spacer20}>
        Em vigor a partir de 6 de setembro de 2021
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#1-introduction">
          Introdução
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#2-service-provider">
          O Serviço Spotify fornecido por nós
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#3-your-use-of-service">
          Seu uso do Serviço Spotify
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#4-property-rights">
          Direitos de propriedade intelectual e de conteúdo
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#5-customer-support">
          Suporte ao cliente, informações, perguntas, reclamações
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#6-problems-disputes">
          Problemas e litígios
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#7-about-terms">
          Sobre estes Termos
        </TextLink>
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="1-introduction">
        1. Introdução
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Leia estes Termos e condições de uso (“Termos”) atentamente, pois eles
        regem o uso (que inclui o acesso) aos serviços que estes Termos
        fornecem, incluindo todos os sites e aplicativos de software que
        incorporam ou vinculam a estes Termos (coletivamente, o “Serviço”) e
        qualquer material disponibilizado pelo Serviço (o “Conteúdo”). O uso do
        Serviço pode estar sujeito a termos e condições adicionais apresentados
        pelo Spotify, incorporados por meio deste documento por esta referência
        a estes Termos.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        O Serviço é disponibilizado somente para usuários do setor de música
        para fins comerciais e não está aberto a “consumidores”, conforme
        contemplado nas leis de proteção ao consumidor aplicáveis, nem a
        qualquer pessoa que aja para fins pessoais, familiares ou domésticos.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Ao se inscrever, acessar ou de outra forma utilizar o Serviço, você
        concorda com estes Termos em nome da entidade, organização ou empresa
        que você representa (incluindo, sem limitação, seus editores e
        subeditores relacionados) (sua “Entidade assinante”), e você declara e
        garante que: (1) você é um representante autorizado dessa Entidade
        assinante com a autoridade de vincular a Entidade assinante a estes
        Termos, independentemente de você permanecer como representante
        autorizado de tal Entidade assinante no futuro; (2) a Entidade assinante
        concorda em estar vinculada aos presentes Termos; e (3) você concorda em
        estar vinculado aos presentes termos em nome da Entidade assinante. Se
        não concordar com nada da afirmação anterior, você não deve utilizar o
        Serviço.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        ESTES TERMOS CONTÊM UMA CLÁUSULA DE ARBITRAGEM OBRIGATÓRIA QUE, CONFORME
        ESTABELECIDO MAIS ADIANTE NA SEÇÃO 6, EXIGE O USO DE ARBITRAGEM OU
        CRITÉRIO INDIVIDUAL PARA RESOLVER DISPUTAS, EM VEZ DE JULGAMENTO OU
        QUALQUER OUTRO PROCESSO JUDICIAL, OU AÇÕES COLETIVAS DE QUALQUER TIPO.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Provedor de serviços
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Estes Termos são firmados entre sua Entidade assinante, e (a) se a sua
        Entidade assinante for organizada sob, ou de outra forma sujeita às leis
        dos Estados Unidos da América: Spotify USA Inc., uma empresa de Delaware
        com escritórios no endereço 4 World Trade Center, 150 Greenwich Street,
        62nd Floor, New York, New York 10007; ou (b) se a sua Entidade assinante
        for uma entidade organizada sob, ou de outra forma sujeita às leis de
        qualquer país fora dos Estados Unidos da América: Spotify AB, of
        Regeringsgatan 19, 111 53 Estocolmo, Suécia, com número de registro
        556703-7495.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Requisitos de idade e elegibilidade
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Para usar o Serviço em nome de sua Entidade assinante, você precisa (1)
        ter 13 anos de idade (ou a idade mínima equivalente em seu país de
        origem) ou mais, (2) ter consentimento dos pais ou responsáveis se você
        for menor de idade em seu país de origem; (3) ter capacidade civil de
        firmar um contrato vinculativo conosco e não ser impedido de fazê-lo sob
        quaisquer leis aplicáveis e (4) residir em um país onde o Serviço esteja
        disponível. Você também confirma que todas as informações de registro
        enviadas ao Spotify são verdadeiras, precisas e completas, e que você
        concorda em mantê-las sempre assim.
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="2-service-provider"
      >
        2. O Serviço Spotify fornecido por nós
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Recursos beta
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Eventualmente, podemos oferecer recursos beta por meio do Serviço
        (“Recursos beta”). Usamos Recursos beta para testar e experimentar novas
        ideias de recursos. Consequentemente, você pode descobrir que os
        recursos beta aparecem um dia, passam por mudanças periódicas ou até
        mesmo desaparecem completamente sem aviso prévio.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Limitações e modificações do Serviço
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Empreendemos esforços adequados para manter o Serviço operacional. No
        entanto, a disponibilidade do Serviço pode mudar de tempos em tempos,
        sem responsabilidade para você; por exemplo:
      </Type>

      <TypeList as="ul" listStyleReset={false}>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          O Serviço pode sofrer interrupções temporárias devido a dificuldades
          técnicas, manutenção, testes ou atualizações, inclusive aquelas
          necessárias para refletir alterações nas leis relevantes e nos
          requisitos regulatórios.
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          Nosso objetivo é desenvolver e melhorar o Serviço constantemente, e
          podemos modificar, suspender ou interromper (permanente ou
          temporariamente) o fornecimento de todo ou parte do Serviço (incluindo
          funções, recursos, planos de assinatura e ofertas promocionais
          específicos);
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          O Spotify não tem a obrigação de fornecer conteúdo específico por meio
          do Serviço, e o Spotify ou os proprietários aplicáveis podem remover o
          Conteúdo sem aviso prévio.
        </Type>
      </TypeList>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        O Spotify não tem nenhuma responsabilidade perante você com relação a
        interrupções ou falhas no serviço de internet ou em outros serviços
        causadas por ações de autoridades governamentais, outros terceiros ou
        eventos fora do nosso controle.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Aplicativos, dispositivos e software de código-fonte aberto de terceiros
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        O Serviço pode ser integrado ou pode interagir com aplicativos, sites e
        serviços de terceiros (“Aplicativos de terceiros”) e computadores
        pessoais, telefones celulares, tablets, dispositivos vestíveis,
        alto-falantes e outros dispositivos de terceiros (“Dispositivos”). Seu
        uso dos Aplicativos de terceiros e Dispositivos pode estar sujeito a
        termos, condições e políticas adicionais fornecidos a você pelo terceiro
        em questão. O Spotify não garante que Aplicativos de terceiros e
        Dispositivos sejam compatíveis com o Serviço.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Insights de dados; erros
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Você reconhece que o Serviço é opcional e que estamos fornecendo a você
        para uso a nosso critério. O Serviço pode fornecer a você a capacidade
        de visualizar dados de uso das suas músicas e dados demográficos dos
        seus fãs. Embora trabalhemos arduamente para garantir a precisão dos
        dados, não garantimos que o Serviço ou os dados que fornecemos estarão
        disponíveis sem erros ou que eles, inclusive erros nos insights de dados
        que fornecemos a você, não acontecerão eventualmente. Quando houver uma
        falha ou erro no Serviço, empregaremos todos os esforços razoáveis para
        resolver ou corrigir esses erros. Você concorda que indenizará e
        isentará de nós quaisquer danos, responsabilidades ou custos que
        incorram como resultado de um erro, engano ou uma falha neste serviço
        gratuito ou decorrente do seu uso dos dados. Todos os dados são
        fornecidos “no estado em que se encontram”. Você usa todos esses dados
        fornecidos por nós por sua conta e risco.
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Embora o Spotify tome precauções razoáveis para preservar e proteger o
        Conteúdo armazenado no banco de dados usado pelo Spotify para fornecer o
        Serviço, você não deve contar com o Serviço como sua única instalação de
        armazenamento, e deve preservar cópias de backup do seu Conteúdo. O
        Spotify não é responsável por danos, exclusão ou falha no armazenamento
        de qualquer Conteúdo.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="3-your-use-of-service"
      >
        3. Seu uso do Serviço Spotify
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Criar uma conta do Spotify
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Pode ser necessário criar uma conta do Spotify para usar todo ou parte
        do Serviço. Seu nome de usuário e senha são apenas para uso individual e
        devem ser mantidos em sigilo. Você entende que é responsável pelo uso
        (incluindo o uso não autorizado) do seu nome de usuário e senha.
        Notifique nossa equipe de Atendimento ao cliente imediatamente se o seu
        nome de usuário ou senha for perdido ou roubado, ou se você acredita que
        houve acesso não autorizado à sua conta.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Seus direitos de uso do Serviço
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Acesso ao Serviço
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Sujeito à sua conformidade e da sua Entidade assinante com estes Termos
        (incluindo quaisquer outros termos e condições aplicáveis), concedemos a
        você, exclusivamente em nome da sua Entidade assinante, uma permissão
        limitada, não exclusiva, intransferível e revogável para usar o Serviço,
        incluindo, sem limitação, o Conteúdo (coletivamente, “Acesso”). Este
        Acesso permanecerá em vigor, a menos e até que seja encerrado por você,
        sua Entidade assinante ou pelo Spotify. Você concorda em não
        redistribuir ou transferir o Serviço ou o Conteúdo. Os aplicativos de
        software do Spotify e o Conteúdo são licenciados à sua Entidade
        assinante, não são vendidos nem transferidos a você, e o Spotify e seus
        licenciadores mantêm a propriedade de todas as cópias dos aplicativos de
        software e do Conteúdo, mesmo após a instalação em seus Dispositivos. Ao
        acessar o Serviço, você concorda que não tomará nenhuma medida que
        imponha uma carga não razoável ao Serviço.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Conformidade com os Termos; delegação
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Você reconhece e concorda, em nome de sua Entidade assinante, que estes
        Termos regem seu acesso ao Serviço e qualquer outra utilização do
        Serviço. Você, em nome da sua Entidade assinante, concorda em não usar o
        Serviço, o Conteúdo ou qualquer parte dele de qualquer forma não
        expressamente permitida por estes Termos. Exceto conforme
        especificamente previsto nestes Termos, você não pode, no todo ou em
        parte: (a) copiar o Serviço ou qualquer Conteúdo, (b) distribuir cópias
        do Serviço ou de qualquer Conteúdo, no todo ou em parte; (c) modificar,
        adaptar, traduzir, fazer engenharia reversa, fazer alterações,
        descompilar, replicar, desmontar ou fazer trabalhos derivados com base
        no Serviço ou em qualquer Conteúdo; (d) usar, alugar, emprestar,
        sublicenciar, arrendar, distribuir ou tentar conceder outros direitos ao
        Serviço ou a qualquer Conteúdo a terceiros; ou (e) permitir acesso
        remoto ao Serviço ou a qualquer Conteúdo por qualquer meio a qualquer
        pessoa. Ao usar o Serviço, você deve cumprir as leis, regras e os
        regulamentos aplicáveis e respeitar a propriedade intelectual, a
        privacidade e outros direitos de terceiros.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Você pode delegar sua autoridade para usar o Serviço a usuários
        adicionais somente dentro de sua Entidade assinante que tenha um motivo
        comercial para tal uso (cada um, um “Representante”). Você só deve
        adicionar Representantes a equipes específicas no Serviço para as quais
        eles receberam a permissão de sua Entidade assinante, bem como uma
        justificativa de negócios válida. Caso algum dos seus Representantes
        acesse ou de outra forma utilize o Serviço, você reconhece e concorda,
        em nome da sua Entidade assinante, que estes Termos também regem o uso
        dele do Serviço. Você representa, garante e concorda conosco que cada um
        de seus Representantes está autorizado a usar o Serviço e a subdelegar
        sua autoridade a usuários adicionais, para e em nome da Entidade
        assinante.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Em nome de sua Entidade assinante, você concorda expressamente que: (1)
        você e todos os Representantes cumprirão com estes Termos; (2) a
        Entidade assinante será totalmente responsável pela violação destes
        Termos por parte sua ou de cada Representante; e (3) a Entidade
        assinante será responsável pelos atos ou omissões suas e de seus
        Representantes para os fins destes Termos.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Direitos de propriedade do Spotify
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        O Serviço e o Conteúdo são propriedade do Spotify ou dos licenciantes do
        Spotify. Todas as marcas comerciais, marcas de serviço, nomes
        comerciais, logotipos, nomes de domínio e quaisquer outros recursos da
        marca Spotify (“Recursos da marca Spotify”) são propriedade exclusiva do
        Spotify ou de seus licenciadores. Estes Termos não concedem a você ou à
        sua Entidade assinante nenhum direito de usar qualquer recurso da marca
        Spotify, seja para uso comercial ou não comercial.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Controle de exportação e sanções
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Os produtos do Spotify podem estar sujeitos a leis e regulamentos de
        controle de exportação e reexportação dos EUA ou leis semelhantes
        aplicáveis em outras jurisdições, incluindo os Regulamentos de
        Administração de Exportação (“EAR”) mantidos pelo Departamento de
        Comércio dos EUA, sanções comerciais e econômicas mantidas pela Agência
        de Controle de Ativos Estrangeiros do Departamento do Tesouro (“OFAC”)
        dos EUA e pelos Regulamentos de Tráfico Internacional de Armas (“ITAR”)
        mantidos pelo Departamento de Estado. Você e sua Entidade assinante
        garantem que (1) não estão localizados em nenhum país ao qual os Estados
        Unidos aplicaram embargos de mercadorias ou que de outra forma aplicaram
        sanções econômicas; ou (2) não são uma parte recusada conforme
        especificado em qualquer lei ou regulamento de exportação ou
        reexportação aplicável ou leis semelhantes aplicáveis em outras
        jurisdições ou, de outra forma, listada em qualquer lista governamental
        de partes proibidas ou restritas dos EUA.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Em nome de sua Entidade assinante, você concorda em cumprir todas as
        leis e os regulamentos de controle de exportação e reexportação
        aplicáveis, incluindo, sem limitação, as sanções comerciais e econômicas
        e dos EARs mantidos pela OFAC. Especificamente, em nome de sua Entidade
        assinante, você concorda em, direta ou indiretamente, não usar, vender,
        exportar, reexportar, transferir, desviar, liberar ou, de qualquer outra
        forma, dispor de quaisquer produtos, software ou tecnologia (incluindo
        produtos derivados de ou baseados em tal tecnologia), recebidos do
        Spotify conforme estes Termos para qualquer destino, entidade, pessoa ou
        usuário final proibido por quaisquer sanções comerciais e econômicas e
        dos EAR mantidas pela OFAC ou quaisquer leis ou regulamentos aplicáveis
        dos Estados Unidos ou qualquer outra jurisdição sem obter autorização
        prévia das autoridades governamentais competentes, conforme exigido por
        tais leis e regulamentos.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="4-property-rights"
      >
        4. Direitos de propriedade intelectual e de conteúdo
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Conteúdo do usuário
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        O conteúdo que você publica no Serviço
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Você, em nome da sua Entidade assinante, pode publicar, carregar ou, de
        outra forma, contribuir com conteúdo para o Serviço (“Conteúdo do
        usuário”). Para evitar dúvidas, o “Conteúdo do usuário” inclui todas as
        informações, materiais e outros conteúdos adicionados, criados,
        carregados, enviados, distribuídos ou publicados no Serviço por
        usuários. O Spotify e/ou qualquer terceiro nomeado pelo Spotify podem, a
        seu exclusivo critério, decidir usar todos ou partes dos metadados
        fornecidos em relação a tal Conteúdo do usuário, bem como complementar
        e/ou substituir tais metadados.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Você e sua Entidade assinante são os únicos responsáveis por todo o
        Conteúdo do usuário que publicarem.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Em nome de sua Entidade assinante, você confirma que, em relação a
        qualquer Conteúdo de usuário que publicarem no Serviço: (1) você é
        proprietário ou tem o direito de publicar tal Conteúdo do usuário; (2)
        tal Conteúdo do usuário, ou o uso dele pelo Spotify de acordo com as
        licenças concedidas abaixo, não (i) viola estes Termos, incluindo as
        Diretrizes do usuário do Spotify, a lei aplicável, as regulamentações e
        regras de quaisquer associações, sindicatos ou juntas comerciais, nem
        viola ou infringe os direitos de terceiros, incluindo qualquer
        propriedade intelectual (incluindo, sem limitação, direitos autorais),
        publicidade, privacidade, personalidade, contrato ou outros direitos de
        terceiros, ou (ii) implicam qualquer afiliação ou endosso seu ou do seu
        Conteúdo do usuário pelo Spotify ou qualquer artista, banda, gravadora
        ou outro indivíduo ou entidade sem o consentimento expresso por escrito
        do Spotify ou de tal indivíduo ou entidade; (3) você adquiriu, reteve e
        administrou adequadamente quaisquer direitos, licenças, autorizações,
        consentimentos, permissões e aprovações relacionadas ao Conteúdo do
        usuário que você publica no Serviço e exigidos pelo Spotify para exercer
        a licença concedida nestes Termos; (4) você será o único responsável por
        cumprir os termos e condições estabelecidos em cada uma das licenças,
        autorizações, consentimentos, permissões e aprovações de terceiros
        mencionados na cláusula (3) deste parágrafo, e você será o único
        responsável por fazer todo e qualquer pagamento de royalties, taxas e
        quaisquer outros valores (no entanto, caracterizados) a todos e
        quaisquer terceiros, conforme e quando exigido por tais licenças de
        terceiros, autorizações, consentimentos, permissões e aprovações; (5)
        royalties, taxas ou outros valores (embora caracterizados) não são ou
        não devem ser pagos pelo Spotify ou em nome do Spotify ou de pessoas ou
        entidades em conexão com o Conteúdo do usuário ou decorrentes dele que
        você publica no Serviço ou o exercício pelo Spotify da licença concedida
        nestes Termos; (6) todo o Conteúdo do usuário que você publica no
        Serviço é e deve ser correto, preciso e não apresentar conteúdo que
        viole nossas Diretrizes do usuário; e (7) você deve cumprir todas as
        leis, regulamentos, diretrizes e padrões do setor aplicáveis ao publicar
        Conteúdo do usuário no Serviço, incluindo as Diretrizes sobre o uso de
        testemunhos e endossos na propaganda da FTC, o Guia de divulgação da
        FTC, as Diretrizes de propaganda da FTC e outras diretrizes expedidas
        pela FTC de tempos em tempos, e respectivas atualizações.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Ao publicar ou compartilhar Conteúdo do usuário no Serviço, tenha em
        mente que determinado Conteúdo do usuário ficará publicamente acessível
        e poderá ser usado e compartilhado novamente por outras pessoas no
        Serviço e em outros serviços do Spotify e na Web, portanto, tenha
        cuidado ao publicar ou compartilhar no Serviço, e tenha atenção às
        configurações da sua conta. O Spotify não é responsável pelo que você ou
        outras pessoas publicam ou compartilham no Serviço. Na medida em que
        você ou sua Entidade assinante tiverem acesso a uma determinada página
        ou conta no Serviço que também estejam acessíveis a um ou mais usuários
        ou Entidades assinantes, alguns de seus Conteúdos de usuário (incluindo,
        entre outros, seu nome, sua função, seu nível de acesso e determinadas
        ações que você realiza no Serviço) podem ser visíveis a esses outros
        usuários ou Entidades assinantes. Seu direito de acessar e editar
        páginas ou ativos pode variar, dependendo de seus direitos subjacentes
        sobre esse material e seu nível de acesso ao Serviço. Em alguns casos,
        você pode compartilhar direitos de edição de uma determinada página ou
        conta no Serviço com outros usuários ou Entidades assinantes.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Remoções e monitoramento de conteúdo do usuário
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        O Spotify não terá a obrigação de incluir e/ou distribuir Conteúdo do
        usuário por meio do Serviço. O Spotify pode, mas não tem obrigação de
        monitorar ou revisar o Conteúdo do usuário. Exceto na medida em que for
        proibido pela lei aplicável, o Spotify reserva-se o direito de remover
        ou desativar o acesso a qualquer Conteúdo do usuário do Serviço, a seu
        exclusivo critério, incluindo, entre outros, quando o Conteúdo do
        usuário violar as Diretrizes do usuário do Spotify. O Spotify pode tomar
        essas medidas sem notificar previamente a você ou a terceiros e sem
        qualquer responsabilidade por tal remoção.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Licenças que você nos concede
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Conteúdo do usuário
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        O Spotify não reivindica nenhum direito de propriedade no Conteúdo do
        usuário que você publicar no Serviço. Depois de publicar o Conteúdo do
        usuário no Serviço, entre você e o Spotify, você continuará a manter
        quaisquer direitos que você possa ter no seu Conteúdo de usuário,
        incluindo quaisquer direitos de propriedade intelectual ou outros
        direitos de propriedade associados ao seu Conteúdo de usuário, sujeito à
        licença que você concede ao Spotify no próximo parágrafo desta seção.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Ao publicar o Conteúdo do usuário no Serviço, você, em nome de sua
        Entidade assinante, concede ao Spotify uma licença não exclusiva,
        transferível, sublicenciável, sem royalties, totalmente paga,
        irrevogável e mundial para reproduzir, disponibilizar, executar e
        exibir, traduzir, modificar, criar trabalhos derivados, distribuir e de
        outra forma usar tal Conteúdo do usuário por qualquer meio, seja sozinho
        ou em combinação com outros conteúdos ou materiais, de qualquer maneira
        e por qualquer meio, método ou tecnologia, seja agora conhecido ou
        criado no futuro, em conexão com o Serviço e o serviço de streaming de
        música do Spotify, a promoção e o marketing do Serviço e o serviço de
        streaming de música do Spotify. Se você não quiser que o Spotify use seu
        Conteúdo do usuário para essas finalidades, não publique o Conteúdo do
        usuário no Serviço. Na medida em que você fornece o Conteúdo do usuário
        que contém seu nome, sua imagem ou fotografia, você nos concede o
        direito mundial não exclusivo, totalmente pago de usar o nome, a imagem
        e a fotografia no Serviço e no serviço de streaming de música do Spotify
        e nas nossas comunicações de marketing para anunciar, comercializar e
        promover a disponibilidade do seu Conteúdo do usuário no Serviço e no
        serviço de streaming de música do Spotify. Quando aplicável e no limite
        permitido pela lei, você também concorda em renunciar e não impor nenhum
        “direito moral” ou direito equivalente, como seu direito de ser
        identificado como autor de qualquer Conteúdo do usuário, incluindo
        Feedback (conforme definido a seguir), e seu direito de se opor ao
        tratamento depreciativo de tal Conteúdo do usuário.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Feedback
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Se você fornecer ideias, sugestões ou outro feedback ao Spotify em
        relação ao seu uso do Serviço ou ao Conteúdo (“Feedback”), tal Feedback
        não será confidencial e poderá ser usado pelo Spotify sem restrições e
        sem pagamento a você. O Feedback é considerado um tipo de Conteúdo do
        usuário nos termos do presente instrumento.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Seu dispositivo
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Você também nos concede o direito de permitir que o Serviço use o
        processador, a largura de banda e o hardware de armazenamento em seu
        Dispositivo para facilitar a operação do Serviço.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Reivindicações de violação
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        O Spotify respeita os direitos de quem possui propriedade intelectual.
        Se você acredita que qualquer Conteúdo infringe seus direitos autorais,
        consulte a Política de direitos autorais do Spotify.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="5-customer-support"
      >
        5. Suporte ao cliente, informações, perguntas e reclamações.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Suporte ao cliente, informações, perguntas, reclamações
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Para obter suporte ao cliente (“Perguntas de suporte ao cliente”), use
        os recursos de Suporte ao cliente listados na seção Fale conosco do
        nosso site. Você também pode entrar em contato conosco pelo endereço de
        correspondência estabelecido na seção “Provedor de serviços” no início
        destes Termos.
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="6-problems-disputes"
      >
        6. Problemas e litígios
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Suspender e encerrar o Serviço
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Estes Termos continuarão sendo aplicáveis até que sejam rescindidos por
        você, por sua Entidade assinante ou pelo Spotify. O Spotify pode
        rescindir estes Termos (incluindo quaisquer termos e condições
        adicionais aqui incorporados) ou suspender o seu acesso ao Serviço a
        qualquer momento se acreditarmos que você ou sua Entidade assinante
        violou algum destes Termos, se pararmos de fornecer o Serviço ou
        qualquer componente material dele, ou se acreditarmos ser necessário
        para cumprir a lei aplicável.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Se houver um litígio entre você e/ou sua Entidade assinante e qualquer
        terceiro quanto à propriedade ou ao uso autorizado de uma conta
        (incluindo a conta de qualquer um de seus Representantes), o Spotify
        poderá suspender o acesso a essa conta, no todo ou em parte, a qualquer
        momento e sem qualquer responsabilidade para você, seus Representantes
        e/ou qualquer outra pessoa ou entidade, incluindo sua Entidade
        assinante. O Spotify pode resolver disputas entre usuários ou pode
        deixar a resolução de disputas até as partes envolvidas, que podem
        buscar ajuda de um tribunal de jurisdição competente. Se o Spotify
        resolver qualquer disputa, então você concorda que a decisão do Spotify
        é final e vinculativa para você e sua Entidade assinante, e que, nem
        você nem sua Entidade assinante ajuizarão qualquer ação contra o
        Spotify, embora você possa ter recurso contra terceiros, conforme
        previsto na legislação aplicável. O Spotify também cumprirá qualquer
        ordem legal de um tribunal de jurisdição competente.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Se sua Entidade assinante ou o Spotify rescindir estes Termos, ou se o
        Spotify suspender seu acesso ao Serviço, você concorda, em nome de sua
        Entidade assinante, que o Spotify não terá nenhuma responsabilidade
        perante você ou sua Entidade assinante, e (exceto conforme expressamente
        disposto nestes Termos) o Spotify não reembolsará quaisquer valores que
        você já tenha pagado. Sua Entidade assinante pode rescindir estes Termos
        ou seu direito individual de acessar o Serviço a qualquer momento, caso
        em que você não pode continuar acessando ou usando o Serviço. Para saber
        como encerrar sua conta do Spotify, use os recursos de Suporte ao
        cliente em nossa página Sobre nós.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        As seguintes seções permanecerão vigentes ainda que o contrato seja
        rescindido: as Seções 2 (O Serviço Spotify fornecido por nós), 3 (Seu
        uso do Serviço Spotify) (exceto conforme definido na seção), 4 (Direitos
        de propriedade intelectual e de conteúdo), 6 (Problemas e litígios), 7
        (Sobre estes Termos), bem como quaisquer outras seções destes Termos
        que, explicitamente ou por sua natureza, devam permanecer em vigor mesmo
        após a rescisão destes Termos.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Isenções de garantia
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        O SERVIÇO É FORNECIDO “NO ESTADO EM QUE SE ENCONTRA” E “CONFORME
        DISPONÍVEL”, SEM QUALQUER TIPO DE GARANTIA EXPRESSA, IMPLÍCITA OU
        ESTATUTÁRIA. ALÉM DISSO, O SPOTIFY E TODOS OS PROPRIETÁRIOS DO CONTEÚDO
        SE ISENTAM DE QUALQUER GARANTIA EXPRESSA, IMPLÍCITA E LEGAL RELACIONADA
        AO CONTEÚDO, INCLUINDO GARANTIAS DE QUALIDADE SATISFATÓRIA,
        COMERCIABILIDADE, ADEQUAÇÃO A UMA FINALIDADE ESPECÍFICA OU NÃO INFRAÇÃO.
        O SPOTIFY NEM QUALQUER PROPRIETÁRIO DE CONTEÚDO GARANTE QUE O SERVIÇO OU
        O CONTEÚDO DO SPOTIFY ESTÃO LIVRES DE MALWARE OU OUTROS COMPONENTES
        PREJUDICIAIS. ALÉM DISSO, O SPOTIFY NÃO FAZ NENHUMA DECLARAÇÃO A
        RESPEITO, NEM GARANTE OU ASSUME QUALQUER RESPONSABILIDADE POR QUAISQUER
        APLICATIVOS DE TERCEIROS (OU O CONTEÚDO DELES), CONTEÚDO DO USUÁRIO,
        DISPOSITIVOS OU QUALQUER PRODUTO OU SERVIÇO ANUNCIADO, PROMOVIDO OU
        OFERECIDO POR TERCEIROS NO SERVIÇO DO SPOTIFY OU EM QUALQUER SITE
        VINCULADO, E O SPOTIFY NÃO É RESPONSÁVEL POR NENHUMA TRANSAÇÃO ENTRE
        VOCÊ E QUAISQUER FORNECEDORES TERCEIROS MENCIONADOS ACIMA. NENHUM
        CONSELHO OU INFORMAÇÃO, ORAL OU POR ESCRITO, OBTIDOS POR VOCÊ DO SPOTIFY
        CRIARÃO QUALQUER GARANTIA EM NOME DO SPOTIFY. ESTA SEÇÃO SE APLICA AO
        MÁXIMO PERMITIDO PELA LEI APLICÁVEL.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Limitação de responsabilidade e prazo para preenchimento de uma
        solicitação
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        VOCÊ CONCORDA QUE SEU ÚNICO E EXCLUSIVO RECURSO PARA QUAISQUER PROBLEMAS
        OU INSATISFAÇÃO COM O SERVIÇO É DESINSTALAR QUALQUER SOFTWARE SPOTIFY E
        PARAR DE USAR O SERVIÇO. VOCÊ CONCORDA QUE O SPOTIFY NÃO TEM NENHUMA
        OBRIGAÇÃO OU RESPONSABILIDADE DECORRENTE OU RELACIONADA A APLICATIVOS DE
        TERCEIROS OU AO CONTEÚDO DELES DISPONIBILIZADO POR OU EM CONEXÃO COM O
        SERVIÇO, E, EMBORA SEU RELACIONAMENTO COM TAIS APLICATIVOS DE TERCEIROS
        POSSA SER REGIDO POR ACORDOS SEPARADOS COM TAIS TERCEIROS, SEU ÚNICO E
        EXCLUSIVO RECURSO, COMO NO QUE DIZ RESPEITO AO SPOTIFY, PARA QUAISQUER
        PROBLEMAS OU INSATISFAÇÃO COM QUAISQUER APLICATIVOS DE TERCEIROS OU SEU
        CONTEÚDO, É DESINSTALAR OU PARAR DE USAR TAIS APLICATIVOS DE TERCEIROS.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        EM NENHUMA HIPÓTESE, A SPOTIFY, SEUS EXECUTIVOS, ACIONISTAS,
        FUNCIONÁRIOS, AGENTES, DIRETORES, SUBSIDIÁRIAS, AFILIADAS, SUCESSORES,
        CESSIONÁRIOS, FORNECEDORES OU LICENCIADORES SERÃO RESPONSÁVEIS POR (1)
        QUAISQUER DANOS INDIRETOS, ESPECIAIS, INCIDENTAIS, PUNITIVOS, EXEMPLARES
        OU CONSEQUENCIAIS; (2) QUALQUER PERDA DE USO, DADOS, NEGÓCIOS OU LUCROS
        (DIRETOS OU INDIRETOS), EM TODOS OS CASOS DECORRENTES DO USO OU DA
        INCAPACIDADE DE USAR O SERVIÇO, DISPOSITIVOS, APLICATIVOS DE TERCEIROS
        OU CONTEÚDO DE APLICATIVOS DE TERCEIROS, INDEPENDENTEMENTE DA TESE
        JURÍDICA, SEM CONSIDERAR SE O SPOTIFY FOI AVISADO SOBRE A POSSIBILIDADE
        DESSES DANOS, E MESMO SE UMA SOLUÇÃO FALHAR EM SEU PROPÓSITO ESSENCIAL;
        OU (3) PELA RESPONSABILIDADE AGREGADA POR TODAS AS REIVINDICAÇÕES
        RELACIONADAS AO SERVIÇO, APLICATIVOS DE TERCEIROS OU CONTEÚDO DE
        APLICATIVOS DE TERCEIROS MAIS DO QUE O MAIOR DO QUE (A) AS QUANTIAS
        PAGAS POR VOCÊ AO SPOTIFY DURANTE OS DOZE MESES QUE ANTECEDEM A PRIMEIRA
        REIVINDICAÇÃO; OU (B) US$ 30,00.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Para esclarecimento, estes Termos não limitam a responsabilidade do
        Spotify por fraude, deturpação fraudulenta, morte ou lesão corporal na
        medida em que a lei aplicável proibiria tal limitação.
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        QUALQUER REIVINDICAÇÃO DECORRENTE DESTES TERMOS DEVERÁ SER INICIADA (POR
        ARBITRAGEM OU AJUIZAMENTO DE AÇÃO INDIVIDUAL CONFORME A CLÁUSULA DE
        ARBITRAGEM ABAIXO) DENTRO DE 1 (UM) ANO APÓS A DATA EM QUE A PARTE
        AUTORA TOMOU CONHECIMENTO OU RAZOAVELMENTE DEVERIA SABER DO ATO, OMISSÃO
        OU FALTA QUE DÁ ORIGEM À REIVINDICAÇÃO; E NÃO HAVERÁ DIREITO A QUALQUER
        RECURSO PARA QUALQUER REIVINDICAÇÃO NÃO DECLARADA DENTRO DESSE PERÍODO,
        EXCETO CONFORME DISPOSIÇÃO LEGAL EM CONTRÁRIO.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Direitos de terceiros
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Você reconhece e concorda que os proprietários do Conteúdo e de
        determinados distribuidores (como fornecedores de lojas de aplicativos)
        são beneficiários destes Termos e têm o direito de aplicar estes Termos
        diretamente contra você. Além do estabelecido nesta seção, estes Termos
        não se destinam a conceder direitos a ninguém, exceto você e o Spotify,
        e em nenhuma circunstância estes Termos criarão quaisquer direitos de
        terceiros beneficiários.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Se você tiver baixado qualquer um dos nossos aplicativos de software
        para dispositivos móveis (cada um, um “Aplicativo”) pela App Store da
        Apple Inc. (“Apple”) ou se estiver usando o Aplicativo em um dispositivo
        iOS, você confirma que leu, entendeu e concorda com o seguinte aviso
        sobre a Apple. Estes Termos são somente entre sua Entidade assinante e o
        Spotify, e não tem a ver com a Apple. A Apple não é responsável pelo
        Serviço e por seu conteúdo. A Apple não tem nenhuma obrigação de
        fornecer quaisquer serviços de manutenção e suporte em relação ao
        Serviço. Caso o Serviço não esteja em conformidade com qualquer garantia
        aplicável, você poderá notificar a Apple, e a Apple reembolsará o preço
        de compra aplicável do Aplicativo a você; e, na máxima extensão
        permitida pela lei aplicável, a Apple não tem nenhuma outra obrigação de
        garantia em relação ao Serviço. A Apple não é responsável por lidar com
        quaisquer reclamações feitas por você ou por terceiros relacionadas ao
        Serviço ou à sua posse ou utilização do Serviço, inclusive: (1)
        reclamações de responsabilidade do produto; (2) qualquer reclamação de
        que o Serviço não está em conformidade com qualquer requisito legal ou
        regulamentar aplicável; (3) reivindicações decorrentes da proteção do
        consumidor ou de legislação semelhante; e (4) reivindicações
        relacionadas à violação de propriedade intelectual. A Apple não é
        responsável pela investigação, defesa, liquidação e quitação de
        reivindicações de terceiros de que o Serviço ou sua posse e uso do
        aplicativo infrinjam os direitos de propriedade intelectual de
        terceiros. Você concorda em cumprir quaisquer termos de terceiros
        aplicáveis ao usar o Serviço. A Apple e as subsidiárias da Apple são
        terceiros beneficiários destes Termos e, mediante a sua aceitação destes
        Termos, a Apple terá o direito (e será considerada como tendo aceitado o
        direito) de aplicar estes Termos contra você como terceiro beneficiário
        destes Termos.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Indenização
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Em nome de sua Entidade assinante, você concorda em indenizar e isentar
        o Spotify de e contra todos os danos, perdas e despesas de qualquer tipo
        (inclusive honorários advocatícios e custos razoáveis) decorrentes de ou
        relacionados a: (1) sua violação de qualquer um destes Termos (inclusive
        quaisquer termos e condições adicionais do Spotify aqui incorporados);
        (2) qualquer Conteúdo do usuário que você publicar ou de outra forma
        contribuir; (3) qualquer atividade em que você se envolva no Serviço do
        Spotify ou por meio dele; e (4) sua violação de qualquer lei ou dos
        direitos de terceiros.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Lei aplicável, arbitragem obrigatória e foro
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Lei aplicável e jurisdição
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Estes Termos são regidos e devem ser interpretados de acordo com as leis
        do Estado de Nova York, Estados Unidos da América, sem considerar a
        escolha de Nova York ou os princípios de conflitos de leis. Além disso,
        sua Entidade assinante e o Spotify concordam com a jurisdição dos
        tribunais federais e estaduais localizados no Condado de Nova York, Nova
        York, para resolver qualquer litígio, reivindicação ou controvérsia que
        surja relacionada a estes Termos ou ao Serviço que não esteja sujeito à
        arbitragem obrigatória nos termos do Acordo de Arbitragem a seguir e que
        renuncie a quaisquer objeções jurisdicionais, locais ou inconvenientes
        do foro a tais tribunais.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        CONTRATO DE ARBITRAGEM
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Esta seção do Contrato de arbitragem estabelece os termos e condições
        segundo os quais disputas, reivindicações e controvérsias entre você e o
        Spotify serão resolvidas por meio de arbitragem (“Contrato de
        arbitragem”).
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Este contrato de arbitragem se aplica somente a Entidades assinantes e
        seus usuários nos Estados Unidos.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Arbitragem e resolução de conflitos
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Você e o Spotify concordam que qualquer disputa, reivindicação ou
        controvérsia entre você e ou sua Entidade assinante e o Spotify,
        decorrente de ou relacionada em qualquer forma a estes Termos ou ao seu
        relacionamento com o Spotify como usuário do Serviço (seja com base em
        contrato, delito, estatuto, fraude, deturpação ou qualquer outra teoria
        legal, e se as reivindicações surgem durante ou após a rescisão destes
        Termos) serão determinadas pela arbitragem obrigatória individual (não
        coletiva). Em nome de sua Entidade assinante, você e o Spotify concordam
        ainda que o árbitro terá o poder exclusivo de decisão na própria
        jurisdição, incluindo quaisquer objeções relacionadas à existência,
        escopo ou validade do Contrato de arbitragem ou à capacidade de arbitrar
        qualquer reivindicação ou recurso. NÃO HÁ JUIZ OU JÚRI NA ARBITRAGEM, E
        A REVISÃO DO TRIBUNAL DE UMA SENTENÇA ARBITRAL É LIMITADA. O árbitro
        deve seguir estes Termos e pode conceder as mesmas indenizações e
        remédios que um tribunal (incluindo honorários advocatícios e custos
        apenas permitidos conforme a lei aplicável), exceto que o árbitro não
        pode conceder qualquer medida judicial, incluindo medida declaratória ou
        cautelar, beneficiando qualquer pessoa, exceto as partes da arbitragem.
        Esta cláusula de arbitragem subsistirá à rescisão destes Termos.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Exceções
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Em nome de sua Entidade assinante, você e o Spotify concordam que nada
        neste Contrato de arbitragem será considerado como renúncia, impedimento
        ou de outra forma limitará qualquer um dos nossos direitos, a qualquer
        momento, de trazer uma ação individual (1) em um juizado especial dos
        EUA ou (2) em um tribunal de justiça, de acordo com a jurisdição e foro
        descritos na Seção de Arbitragem e resolução de conflitos acima que
        busque (a) apenas medida cautelar temporária ou preliminar
        individualizada, enquanto se aguarda uma decisão final do árbitro ou (b)
        medida cautelar pública, enquanto se aguarda uma decisão sobre a
        substância de tal reivindicação do árbitro. Além disso, este Contrato de
        arbitragem não impede você ou nós de levarmos questões para a atenção de
        agências federais, estaduais ou locais. Tais agências podem, se a lei
        permitir, buscar ajuda contra nós em seu nome (ou vice-versa).
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Nenhuma ação judicial coletiva ou representativa: renúncia de ação
        coletiva
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        VOCÊ E O SPOTIFY CONCORDAM QUE CADA UM PODE APRESENTAR REIVINDICAÇÕES
        CONTRA O OUTRO SOMENTE EM SUA CAPACIDADE INDIVIDUAL E NÃO COMO UM AUTOR
        OU MEMBRO DA CLASSE EM QUALQUER AÇÃO COLETIVA OU REPRESENTATIVA. A menos
        que você e o Spotify concordem, nenhum árbitro ou juiz pode consolidar
        mais de uma reivindicação de pessoa ou, de outra forma, presidir a
        qualquer forma de um processo representativo ou de classe. O árbitro
        poderá conceder uma medida cautelar apenas a favor da parte individual
        que procura resolução e apenas na medida do necessário para prestar a
        reparação garantida pela reivindicação dessa parte. Se um tribunal
        decidir que a lei aplicável impede a aplicação de qualquer uma das
        limitações deste parágrafo em relação a uma reivindicação específica
        para resolução, essa reivindicação (e somente essa reivindicação) deve
        ser separada da arbitragem e pode ser levada ao tribunal.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Regras de arbitragem
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Você ou nós podemos iniciar um processo de arbitragem. Qualquer
        arbitragem entre você e o Spotify ocorrerá de acordo com as Regras de
        Arbitragem do Consumidor da Associação Americana de Arbitragem (“AAA”)
        então em vigor (as “Regras da AAA”), conforme modificadas por este
        Contrato de arbitragem. Você e o Spotify concordam que a Lei de
        Arbitragem Federal aplica e rege a interpretação e aplicação desta
        disposição (apesar da escolha da disposição da lei acima). As Regras da
        AAA, bem como as instruções sobre como registrar um processo de
        arbitragem com a AAA, aparecem em adr.org, ou você pode ligar para a AAA
        em 1-800-778-7879.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Todas as audiências de arbitragem serão conduzidas por telefone ou
        videoconferência na medida do possível, mas se o árbitro determinar que
        uma audiência deve ser conduzida pessoalmente, o local para tal
        audiência será determinado pela arbitragem de acordo com as Regras de
        Arbitragem do Consumidor da AAA.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Se você optar por ajuizar um processo de arbitragem e for solicitado a
        pagar uma taxa de arquivamento, o Spotify reembolsará você por essa taxa
        de arquivamento, a menos que sua solicitação seja superior a US$
        10.000,00, caso em que você será responsável pela taxa de arquivamento.
        O Spotify pagará quaisquer outras taxas de arbitragem, inclusive a sua
        parte no pagamento do árbitro, a menos que exigido de outra forma pelas
        regras da AAA ou ordem judicial. Independentemente da maneira como a
        arbitragem é conduzida, o árbitro deverá emitir uma decisão fundamentada
        por escrito suficiente para explicar as conclusões essenciais sobre as
        quais se baseiam a decisão e a sentença, se houver. O árbitro poderá
        decidir e resolver litígios quanto ao pagamento e reembolso de taxas ou
        despesas a qualquer momento durante o processo e mediante solicitação de
        qualquer das partes, no prazo de 14 dias a contar da decisão do árbitro
        sobre os méritos.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Notificação; processo
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        A parte que pretende buscar arbitragem deve primeiro enviar uma
        notificação por escrito do litígio para a outra parte, por e-mail para
        legal@spotify.com e por correio, Federal Express, UPS ou Express Mail
        (assinatura necessária) para o endereço abaixo (“Notificação”). O
        endereço do Spotify para notificações é: SpotifyUSA Inc., Attn: General
        Counsel, 4 World Trade Center, 150 Greenwich Street, 62nd Floor, New
        York, New York 10007, EUA. A notificação deve (1) descrever a natureza e
        a base da reivindicação ou disputa; e (2) definir a medida específica
        solicitada (“Demanda”). Concordamos em envidar esforços de boa-fé para
        resolver a reclamação diretamente, mas se não chegarmos a um acordo para
        o fazer no prazo de 30 dias após o aviso ser recebido, o usuário ou o
        Spotify poderão iniciar um processo de arbitragem. Durante a arbitragem,
        o valor de qualquer oferta de acordo feita por você ou pelo Spotify não
        será divulgado ao árbitro até que tome uma decisão final e a sentença,
        se houver. Caso nossa disputa seja finalmente resolvida por meio de
        arbitragem em seu favor, e o árbitro emitir uma sentença maior do que o
        valor da última oferta de acordo por escrito do Spotify, o Spotify
        pagará a você o valor da sentença ou US$ 1.000,00, o que for maior.
        Todos os documentos e informações divulgados no decorrer da arbitragem
        devem ser mantidos estritamente confidenciais pelo destinatário e não
        devem ser usados pelo destinatário para qualquer finalidade que não seja
        para fins de arbitragem ou aplicação da decisão e decisão do árbitro e
        não devem ser divulgados, exceto em sigilo para pessoas que tenham
        necessidade de saber para tais fins ou conforme exigido pela lei
        aplicável.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Aplicabilidade
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Se este Contrato de arbitragem for invalidado, no todo ou em parte, as
        partes concordam que a jurisdição exclusiva e o foro descritos na Seção
        “Lei aplicável e jurisdição” regerão com relação a qualquer aspecto de
        qualquer disputa, reivindicação ou controvérsia que, como resultado de
        tal invalidação, não é mais regido por este Contrato de arbitragem.
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="7-about-terms">
        7. Sobre estes Termos
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        De acordo com a lei aplicável, você tem certos direitos que não podem
        ser limitados por um contrato. Estes Termos não têm como objetivo
        restringir esses direitos.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Alterações nestes Termos
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Podemos fazer alterações nestes Termos (incluindo quaisquer termos e
        condições adicionais do Spotify incorporados por referência aqui)
        eventualmente, notificando você sobre tais alterações por qualquer meio
        razoável, incluindo a publicação dos Termos revisados no Serviço Spotify
        aplicável (desde que, para alterações materiais, procuraremos
        complementar esse aviso por e-mail, uma mensagem pop-up em serviço ou
        outra notificação proeminente no Serviço ou outros meios). Tais
        alterações não se aplicarão a qualquer litígio entre você e nós surgidos
        antes da data em que os Termos foram alterados. O uso que você faz do
        Serviço após quaisquer alterações nestes Termos constituirá sua
        aceitação de tais alterações. Se você não deseja continuar a usar o
        Serviço após a atualização dos Termos, você pode encerrar sua conta
        entrando em contato conosco. A data de vigência estabelecida na parte
        superior deste documento indica quando estes Termos foram alterados pela
        última vez.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Inteiro teor do contrato
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Além do que está declarado nesta seção ou conforme explicitamente
        acordado por escrito entre você e o Spotify, estes Termos constituem
        todos os termos e condições acordados entre você e o Spotify e
        substituem quaisquer acordos anteriores em relação ao assunto destes
        Termos, sejam eles escritos ou orais. Como observado acima, outros
        termos e condições que regem o uso do Serviço são incorporados neste
        documento como referência, incluindo os seguintes termos e condições: as
        Diretrizes do usuário do Spotify; a Política de Direitos Autorais do
        Spotify; e os Termos da Comunidade de Suporte do Spotify.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Independência das cláusulas e exoneração de responsabilidade
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Salvo indicação em contrário nestes Termos, se qualquer disposição
        destes Termos for considerada inválida ou inexequível por qualquer
        motivo ou em qualquer medida, as restantes disposições destes Termos não
        serão afetadas e a aplicação dessa disposição será executada na medida
        do permitido por lei.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Qualquer falha do Spotify ou de qualquer terceiro beneficiário em
        aplicar estes Termos ou qualquer cláusula destes não renunciará ao
        direito do Spotify ou do terceiro beneficiário aplicável de fazê-lo.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Atribuição
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        O Spotify pode atribuir qualquer um destes Termos ou todos eles e pode
        atribuir ou delegar, no todo ou em parte, qualquer um de seus direitos
        ou obrigações sob estes Termos. Você não pode atribuir estes Termos,
        total ou em parte, nem transferir ou sublicenciar seus direitos conforme
        estes Termos, a terceiros.
      </Type>
    </Layout>
  );
};

const TermsAndConditionsZhHant = () => {
  return (
    <Layout>
      <Type variant="altoBrio" as="h1" paddingBottom={spacer20}>
        使用條款及條件
      </Type>
      <Type variant="cello" as="p" paddingBottom={spacer20}>
        2021 年 9 月 6 日生效
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#1-introduction">
          引言
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#2-service-provider">
          我們提供的 Spotify 服務
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#3-your-use-of-service">
          您對 Spotify 服務的使用
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#4-property-rights">
          內容與智慧財產權
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#5-customer-support">
          客戶支援、資訊、問題、投訴
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#6-problems-disputes">
          問題與爭議
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#7-about-terms">
          關於本條款
        </TextLink>
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="1-introduction">
        1. 引言
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        請仔細閱讀這些使用條款及條件 (「本條款」)，因為本條款規範您對服務的使用
        (包括存取)，其中包括我們所有包含或連接到本條款的網站和軟體應用程式
        (合稱「服務」) 以及透過服務提供的任何素材 (「內容」)。服務之使用可能受
        Spotify
        所提供的其他條款與條件約束，此等條款與條件特此透過本援引併入本條款。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        服務僅供音樂產業之使用者出於商業目的使用，而不適用於消費者保護法中規定的「消費者」或任何為個人、家庭成員或家庭之目的之人開放。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        註冊、存取或以其他方式使用服務，即表示您所代表的實體、組織或企業
        (包括但不限於與您相關的出版商或版權代理商) (您的「訂閱實體」)
        同意本條款，並且聲明及保證：(1) 您
        是該訂閱實體的授權代表，並有權使訂閱實體受本條款約束，無論您未來是否仍是該訂閱實體的授權代表。；(2)
        該訂閱實體同意受本條款約束；及 (3)
        您同意代表該訂閱實體受本條款約束。如果您無法同意前述所有條款，則不得使用本服務。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本條款包含如下第 6
        節所示的強制性仲裁規定，要求使用個別仲裁決定來解決爭議，而不以陪審團審判或任何其他法庭訴訟程序，或任何類型的集體訴訟方式。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        服務供應商
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本條款適用於您的訂閱實體，以及 (a)
        如果您的訂閱實體是根據美國法律所組織或受美國法律約束，Spotify USA
        Inc.，一間德拉瓦州公司，營業地址為：4 World Trade Center, 150 Greenwich
        Street, 62nd Floor, New York, New York 10007；或 (b)
        如果您的訂閱實體是根據美國以外的任何國家/地區的法律所組織或受其法律約束的實體，則為
        Spotify AB，地址為：Regeringsgatan 19, 111 53 Stockholm,
        Sweden，註冊編號為 556703-7495。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        年齡和資格要求
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        為了代表您的訂閱實體使用服務，您必須：(1) 年滿 13 歲
        (或您所在國家/地區的同等最低年齡) 或以上；(2)
        若您為所在國家/地區的未成年人，則需要父母或監護人同意；(3)
        有權代表您的訂閱實體與我們簽署具約束力的合約，且不受任何適用法律的禁止；以及
        (4) 居住於有提供本服務的國家。您亦承諾提交至 Spotify
        的所有註冊資訊均為真實、準確和完整，並且同意始終保持該狀態。
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="2-service-provider"
      >
        2. 我們提供的 Spotify 服務
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        測試版功能
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        我們可能不時透過服務提供測試版功能
        (「測試版功能」)。我們使用測試版功能來試驗和測試新的功能創意。因此，您可能會發現測試版功能僅出現一天、定期進行變更，或甚至在沒有通知的情況下完全消失。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        服務限制和修改
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        我們會盡合理的努力以維持服務的運作。然而，服務的供應狀態可能不定期變更，對於您不需要承擔任何法律責任；例如：
      </Type>

      <TypeList as="ul" listStyleReset={false}>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          服務可能因技術困難、維護或測試，或是更新，包括為反映相關法律與監管要求變更所需，而暫時中斷。
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          我們的目標是持續改進服務。我們可能會修改、暫停或中止 (永久或暫時)
          提供所有或部分的服務 (包括特定功能、特色，和促銷方案)；
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          Spotify 沒有義務透過服務提供任何特定內容，且 Spotify
          或適用的擁有者得移除內容，恕不另行通知。
        </Type>
      </TypeList>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        對於與網際網路或其他因政府主管機關、其他第三方或我們無法控制的事件所造成的服務中斷或故障，Spotify
        對您不負任何責任。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        第三方應用程式、裝置和開放原始碼軟體
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        服務可與第三方應用程式、網站及服務 (「第三方應用程式」)
        及第三方個人電腦、行動電話、平板電腦、穿戴式裝置、喇叭及其他裝置
        (「裝置」)
        整合，或以其他方式與之互動。您對此類第三方應用程式與裝置的使用可能受到適用第三方提供給您的其他條款、條件與政策規範。Spotify
        不保證第三方應用程式與裝置將與服務相容。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        資料洞察；錯誤
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您確認服務是由我們決定提供給您的選用服務。您可以透過服務查看音樂的使用情況，以及您的粉絲的人口統計資料。雖然我們努力確保資料的準確性，但我們不保證我們提供的服務或資料將完全沒有錯誤，也不保證錯誤不會偶爾發生，包括我們向您提供的資料分析。如果服務出現故障或錯誤，我們將盡一切合理努力來解決或改正這些錯誤。您同意，因此免費服務或因您使用資料而遭受之錯誤、失誤或故障所導致或引起的任何損害、責任或成本，您將對我們作出補償且擔保我們免於損害。所有資料皆依「現狀」提供給您。由您自行決定是否使用我們提供之資料，並自行承擔風險。
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        雖然 Spotify 會採取合理的預防措施來保存和保護存放在 Spotify
        用於提供服務之資料庫中的內容，但您不應依賴服務作為您唯一的儲存設施，並且應保存內容的備份副本。Spotify
        不對任何內容的損害、刪除或儲存失敗負責。
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="3-your-use-of-service"
      >
        3. 您對 Spotify 服務的使用
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        建立 Spotify 帳戶
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您可能需要建立 Spotify
        帳戶，才能使用服務的全部或部分內容。您的使用者名稱和密碼僅供您個人使用並且應保持其機密性。您瞭解您對您的使用者名稱與密碼之一切使用
        (包括任何未經授權的使用)
        負責。如果您的使用者名稱或密碼遺失或遭竊，或您認為帳戶遭未經授權存取，請立即通知我們的客戶服務團隊。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        您使用服務的權利
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        存取服務
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        在您和您的訂閱實體遵守本條款 (包括任何其他適用的條款和條件)
        的情況下，我們授權您、代表您的訂閱實體、在有限的、非獨家、可撤銷的許可下使用服務，包括但不限於內容
        (合稱「存取權」)。本存取權持續有效，直至您的訂閱實體或 Spotify
        終止為止。您同意不會轉發或傳送服務或內容。即使已安裝於您的裝置，服務的軟體應用程式與其內容是授權給您的訂閱實體，而非售予或轉讓給您，且
        Spotify
        及其授權人保留所有服務的軟體應用程式與內容副本的所有權。存取服務時，您同意不會採取任何會對服務施加不合理加載的動作。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        遵守條款；轉授
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您代表您的訂閱實體確認並同意這些條款約束您對服務的存取和其他使用。您代表您的訂閱實體同意不以本條款中未明確表示允許的任何方式使用服務、內容，或任何相關的部分。除本條款特別規定外，您不得將全部或部分
        (a) 複製服務或任何內容，(b) 散佈服務或任何內容的全部或部分副本；(c)
        修改、改編、翻譯、反向工程、更改、解編、重製、拆解，或根據本服務或任何內容製作衍生作品；(d)
        使用、出租、出借、再授權、租賃、散佈，或嘗試向第三方授予服務或任何內容的其他權利；或
        (e)
        允許任何人以任何方式遠端存取服務或任何內容。使用服務時，您必須遵守所有適用的法律、條款和規則，並尊重第三方的智慧財產權、隱私權，和其他權利。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您可以授權您的訂閱實體內具商業考量有的其他使用者
        (「代表」)使用服務。您務必僅能將經過您的訂閱實體允許，且具正當商業考量的代表加入到服務中的特定團隊。如果您的任何代表存取或以其他方式使用服務，即表示您代表您的訂閱實體確認並同意他們對服務的使用亦受本條款之拘束。您向我們聲明、保證並承諾，您的每個代表都已獲授權使用服務，並代表訂閱實體為其自身使用，且有權將其使用權再授權給其他使用者。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您代表訂閱實體明確表示同意：(1) 您和所有代表將遵守本條款；(2)
        訂閱實體應對您和每個代表違反本條款的行為承擔全部責任，及；(3)
        對於這些條款的目的，訂閱實體將對您和您的代表的作為或不作為負責。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Spotify 之所有權
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        服務與內容皆為 Spotify 或 Spotify 之授權人的財產。所有 Spotify
        的商標、服務標誌、商業名稱、徽標、網域名稱以及 Spotify 品牌的其他特色
        (「Spotify 品牌特色」) 為 Spotify
        及其授權人的獨有財產。本條款並未授予您或您的訂閱實體使用 Spotify
        品牌特色的任何權利，無論是作商業或非商業之用。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        出口管制和制裁
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        產品可能受到美國出口與轉出口的管制和規定，或其他司法管轄區內類似的相關法律約束，包括美國商務部制定的出口管理條例
        (「EAR」)、財政部海外資產管制局 (「OFAC」)
        訂定的貿易與經濟制裁，以及國務院制定的國際武器交易條例
        (「ITAR」)。您保證您與您的訂閱實體均非位於 (1)
        美國已禁運貨物或以任何方式施加經濟制裁的任何國家/地區；亦非 (2)
        任何適用出口或轉出口法律或法規或其他司法管轄區之類似適用法律中所註明的拒絕往來方或被列入任何美國政府的禁止或限制對象名單。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您代表您的訂閱實體同意遵循所有適用的出口與轉出口管制法律與規定，包括但不限於
        EAR 以及 OFAC
        制定的貿易與經濟制裁。具體而言，您代表您的訂閱實體同意在未根據相關法律與規定要求，事先取得具管轄權之政府主管機關的授權之下，不會直接或間接使用、販售、出口、轉出口、運送、轉移、釋出，或以其他方式處理任何根據本條款收到來自
        Spotify 的產品、軟體或技術 (包含源自或以此類技術為基礎的產品) 至受到
        EAR、OFAC
        制定的貿易與經濟制裁，或美國或其他司法管轄區的任何適用法律或規定所禁止的任何目的地、實體或個人，或最終用途。
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="4-property-rights"
      >
        4. 內容與智慧財產權
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        使用者內容
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        您發布至本服務的內容
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您可以代表您的訂閱實體發布、上傳，或以其他方式增添內容
        (「使用者內容」)至服務。為避免疑義，「使用者內容」包含所有使用者於服務新增、建立、上傳、提交、散布或發布的所有資訊、素材及其他內容。Spotify
        和/或 Spotify
        指定的任何第三方可自行決定使用與此類使用者內容相關的全部或部分中繼資料，以及補充和/或取代此類中繼資料。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您和您的訂閱實體全權負責您發布的所有使用者內容。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您代表您的訂閱實體承諾，關於您在服務上發布的任何使用者內容：(1)
        您擁有或有權發布此類使用者內容；(2) 此類使用者內容，或 Spotify
        依據以下授權使用此類使用者內容並未 (i) 違反本條款 (包括 Spotify
        使用者指南)、適用法律、任何行會、工會或公會的規定和規則，或是違反或侵犯任何第三方的權利，包括任何智慧財產權
        (包括但不限於著作權)、公開發表權、隱私權、人格權、契約或他人的其他權利，或
        (ii) 未經 Spotify 或此類個人或實體事先明確書面同意，暗示 Spotify
        或任何藝人、樂團、唱片廠牌，或其他個人或實體與您或您的使用者內容有任何關聯，或為其背書；(3)
        您已經並且應該已經獲得、保留和適當管理 Spotify
        行使本條款授權所需，而與您發佈到服務的使用者內容相關之任何第三方權利、許可、授權、同意、允許和核准；(4)
        您應全權負責遵守本節第 (3)
        項提及的每個第三方特許、授權、同意、許可和核准中規定的條款和條件，且您應全權負責根據此類第三方許可、授權、同意、允許和核准，按其所規定的時程向所有任何第三方支付任何一切版稅、費用和任何其他款項
        (無論其名稱為何)；(5) Spotify
        或其代表人皆無須向任何個人或實體，或代表任何個人或實體，支付相關或因您發布到服務的使用者內容，或
        Spotify 行使本條款授權所生之任何版稅、費用或其他款項
        (無論其名稱為何)；(6)
        您發佈到服務的所有使用者內容均為正確、準確，且未含違反我們使用者指南的內容；且
        (7)
        在向服務發布使用者內容時，您已並應遵守所有適用的法律、法規和業界標準，包括美國聯邦交易委員會的「廣告使用推薦與見證指南」、聯邦交易委員會網站的「揭露指引」、「原生廣告指引」，以及其他聯邦交易委員會不定期發佈的指引和更新。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        在服務上發布或分享使用者內容時，請記得某些使用者內容可受公開存取，也可能在服務和其他
        Spotify
        服務或網路上的其他人使用和再次分享，因此在服務上發布或分享時請務必小心，並留意您的帳戶設定。Spotify
        對於您或他人在服務上發布或分享的內容，
        概不負責。如果您或您的訂閱實體可以存取服務上的特定頁面或帳戶，且該頁面或帳戶也可供一個或多個其他使用者或訂閱實體存取，則此類其他使用者或訂閱實體亦有可能看見您的某些使用者內容
        (包括但不限於您在服務上的名稱、角色、存取級別和特定操作)。您存取和編輯頁面或資產的權利可能會有所不同，具體取決於您對該素材的實際權利以及您對服務的存取級別。在某些情況下，您可以與其他使用者或訂閱實體共享服務上特定頁面或帳戶的編輯權限。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        下架和監控使用者內容
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify 沒有義務透過服務納入或散布使用者內容。Spotify
        得，但無義務，監控或審查使用者內容。除適用法律禁止的範圍外，Spotify
        保留以任何理由或不附理由，自行決定移除或停用從服務存取任何使用者內容的權利，包括但不限於當使用者內容違反
        Spotify 使用者指南時。Spotify
        得不經事先通知您或任何第三方的情況下採取這些行動，並且不對您承擔任何此類移除的責任。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        您授予我們的權利
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        使用者內容
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        不會對您發布至服務的使用者內容主張任何所有權。將使用者內容發布到本服務後，在您和
        Spotify
        之間，您將繼續保留您在您的使用者內容中可能擁有的任何權利，包括與您的使用者內容相關聯的任何智慧財產權或其他專有權利，但須受到本節下一條文中您授予
        Spotify 權利之拘束。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        透過向本服務發布使用者內容，您代表您的訂閱實體授予 Spotify
        非獨家、可轉讓、可再授權、免權利金、全額付清的全球性許可，得透過任何媒介，無論單獨或結合其他內容或素材，以任何形式、方式、方法或無論是現在已知或未來創造之技術，重製、提供、表演與展示、翻譯、修改、創作衍生作品、散布和其他方式，使用與服務和
        Spotify 的音樂串流服務，或服務和Spotify
        的音樂串流服務之推廣和行銷相關之，此類使用者內容。如果您不希望 Spotify
        將您的使用者內容用於這些目的，您不應將使用者內容發布到服務。您所提供的使用者內容中，若含有姓名、肖像或照片，代表您進一步授予我們在服務和
        Spotify
        的音樂串流服務以及我們的行銷訊息中，使用該姓名、肖像和照片的非獨家、已全額付清之全球性權利，以在服務和
        Spotify
        的音樂串流服務上廣告、行銷和宣傳您和您的使用者內容的可取得性。在適用法律及其允許範圍內，您亦同意放棄並不執行任何「著作人格權」或同等權利，例如辨識您為任何使用者內容，包括回饋
        (定義如下)，之著作者的權利，以及您反對貶抑處理此類使用者內容的權利。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        回饋
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您所提供有關使用服務或任何內容的想法、建議或其他回饋 (「回饋」)
        並不具機密性，Spotify
        可無限制使用回饋而不需向您支付費用。根據本條款，回饋視為一種使用者內容。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        您的裝置
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您亦授予我們權利，允許服務使用您裝置上的處理器、頻寬，和儲存硬體，以促進服務的運作。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        侵權索賠
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify
        尊重智慧財產權所有人之權利。如果您認為任何內容侵害了您的版權，請參閱
        Spotify 版權政策。
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="5-customer-support"
      >
        5. 客戶支援、資訊、問題和投訴。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        客戶支援、資訊、問題、投訴
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        如需客戶支援
        (「客戶支援諮詢」)，請使用我們網站「聯繫我們」區所列之客戶支援資源。您也可以透過本條款「服務供應商」一節所列的郵寄地址與我們聯繫。
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="6-problems-disputes"
      >
        6. 問題與爭議
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        暫停與終止服務
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本條款將繼續適用至您的訂閱實體或 Spotify
        終止本條款為止。若我們認為您或您的訂閱實體違反任何本條款內容，或我們停止提供服務或任何其重要組件，或為遵守適用法律有此必要時，Spotify
        得隨時終止本條款 (包括併入本條款的任何其他條款與條件) 或暫停您存取
        Spotify 服務。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        如果您和/或您的訂閱實體與任何第三方之間就帳戶 (包括您的任何代表的帳戶)
        的所有權或使用授權產生爭議，則 Spotify
        可能會隨時暫停對該帳戶的全部存取，且不對您、您的代表和/或任何其他個人或實體
        (包括您的訂閱實體) 承擔任何責任。Spotify
        得解決使用者之間的爭議，亦得由涉入之當事人自行向有管轄權的法院尋求救濟以解決爭議。如果
        Spotify 解決了任何爭議，則您同意 Spotify
        的決定是最終決定並對您和您的訂閱實體具有約束力，您和您的訂閱實體都沒有任何可針對
        Spotify
        的實體請求權，即便您仍可根據適用法律的規定向任何第三方追索。Spotify
        亦將遵守具有合法管轄權的法院的任何合法命令。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        若您的訂閱實體或 Spotify 終止本條款，或是 Spotify
        暫停您存取服務，您代表您的訂閱實體同意 Spotify
        對您或您的訂閱實體不負任何責任，並且 (除本條款明文規定之情形外)
        不會退還您已支付的任何金額。您的訂閱實體可以隨時終止本條款或您個人存取服務的權利，在這種情況下，您便無法繼續存取或使用服務。若要瞭解如何終止您的
        Spotify 帳戶，請使用「關於我們」頁面上的客戶支援資源。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        以下部分在本條款終止後繼續有效：第 2 節 (我們提供的 Spotify 服務)、第 3
        節 (您對 Spotify 服務的使用) (其中另有規定者除外)、第 4 節
        (內容與智慧財產權)、第 6 節 (問題與爭議)、第 7 節
        (關於本條款)，以及因有明示或視其性質，即使在本條款終止後也必須繼續有效之任何其他部分。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        保證免責聲明
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本服務係依「現狀」和「可用性」提供，不含任何明示，默示或法定的保證。此外，SPOTIFY
        和所有內容所有權者概不提供任何有關內容的明示、默示及法定的保證，包括有關令人滿意的品質、適銷性、特定用途的適用性或不侵權的任何保證。SPOTIFY
        與任何內容所有權者皆不保證服務或內容無惡意軟體或其他有害組件之虞。此外，對於第三方在服務上或透過服務或任何超連結網站所行銷、推廣或提供的任何第三方應用程式
        (或其內容)、使用者內容、裝置或任何產品或服務，SPOTIFY
        不做任何聲明，也不做任何保證或承擔任何責任。SPOTIFY
        對您與第三方供應商之間的任何交易亦概不負責。您從 SPOTIFY
        獲得的口頭或是書面的任何建議或資訊，均不構成代表 SPOTIFY
        的保證。此節會在適用法律允許的最大限度內適用。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        責任限制和申請索賠的時間
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您同意，您對服務有任何問題或不滿，您唯一且專有的補救措施為解除安裝任何
        SPOTIFY 軟體以及停止使用服務。您同意 SPOTIFY 對於透過或與 SPOTIFY
        服務相關而取得之第三方應用程式或其內容，所引起或與該第三方應用程式或其內容有關的任何義務或責任概不承擔，且您與該第三方應用程式的關係可能由與該第三方的個別協議所約束，就
        SPOTIFY
        而言，若您對於第三方應用程式或其內容有任何問題或不滿，您唯一的補救方法為解除安裝或停止使用該第三方應用程式。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        在任何情況下
        SPOTIFY、其主管、股東、員工、代理人、董事、子公司、附屬公司、繼承人、受讓人、供應商或授權人皆無須對於下列事項負責：(1)
        任何間接、特殊、意外、懲罰性的、懲戒性的或衍生性的損害；(2)
        所有因使用或未能使用服務、裝置、第三方應用程式或第三方應用程式內容而引起的任何使用、資料、業務或利潤
        (無論直接或間接) 的損失，而不論法律依據為何，也不管是否已警告 SPOTIFY
        這些損失的可能性，且即使補救措施未能滿足其基礎目的亦然；或 (3)
        與服務、第三方應用程式或第三方應用程式內容相關之所有索賠，累計總體責任額超過
        (A) 在第一次索賠前十二個月內向 SPOTIFY 支付的金額，或美金三十元
        ($30.00)。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        在此澄清，本條款並不限制 Spotify
        對詐欺、虛偽不實陳述、死亡或人身傷害的責任，此類限制為適用法律所禁止。
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        根據本條款所產生的任何索賠必須自主張索賠方首次得知或應合理得知引發索賠之行為、不行為或違約當日起的一
        (1) 年內展開
        (根據下方仲裁協議提出仲裁要求或提出個人訴訟)；未於該期間內主張的任何索賠將無權取得任何賠償。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        第三方權利
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您確認並同意內容所有權者與特定經銷商 (例如 app store 供應商)
        為本條款的預期受益人，且有權直接對您執行條款。除本節所規定者外，本條款並未意圖將權利授予您與
        Spotify 以外的任何人，且在任何情況下，本條款創造任何受益第三人之權利。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        如果您已自 Apple Inc. (「Apple」) 的 App Store
        下載我們的任何行動應用程式 (「App」)，或若您正在 iOS 裝置上使用此
        App，您確認已閱讀、理解。並同意下列關於 Apple
        的通知。本條款僅存在於您的訂閱實體與 Spotify 間，與 Apple 無涉，且 Apple
        不對服務及其內容負責。Apple
        在服務方面沒有義務對服務提供任何維護或支援。如果本服務未能符合任何適用的保證，您可以通知
        Apple 且 Apple 將退還適用 App
        購買金額給您；且於適用法律允許的最大範圍內，Apple
        對於本服務沒有任何其他保證義務。Apple
        不負責處理您或任何第三方關於服務或您擁有或使用服務的索賠，包含：(1)
        產品責任索賠；(2) 服務未符合任何相關法律或監管要求的任何索賠；(3)
        根據消費者保護或類似法律所引起的索賠；及 (4)
        有關侵害智慧財產權的索賠。Apple 不對任何第三方對本服務或您擁有以及使用
        App
        侵害第三方的智慧財產權索賠之調查、辯護，和解與清償負責。在使用本服務時，您同意遵循任何適用的第三方條款。Apple
        與 Apple 的子公司為本條款的第三方受益人，在您接受本條款時，Apple
        身為本條款的第三方受益人，將有權 (且將視為已接受該權利) 對您執行本條款。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        賠償
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您代表您的訂閱實體同意賠償，並使 Spotify
        免受因下列情況而衍生或相關之所有損害、損失及任何型式的費用
        (包括合理的律師費和成本) 的傷害：(1) 您違反本條款的任何部分
        (包括併入本條款的其他 Spotify 條款與條件)；(2)
        您發布或以其他方式發表的任何使用者內容；(3)
        您在服務或透過服務從事的任何活動；以及 (4)
        您違反任何法律或第三方的權利。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        準據法、強制仲裁和裁決地點
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        準據法與司法管轄權
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本條款受美國紐約州法律管轄，並應依據美國紐約州法律解釋，無需考量紐約的法律原則選擇或牴觸。此外，您的訂閱實體和
        Spotify
        同意在美國紐約州聯邦法院和州立法院管轄下解決與本條款或服務相關或衍生任何爭議、索賠或糾紛，且該爭議、索賠或糾紛不受下述仲裁協議的強制性仲裁約束，並放棄對此類法院提出任何司法管轄、審判地點或不方便法庭之異議。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        仲裁協議
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本仲裁協議章節載明您與 Spotify
        之間的爭議、索賠或糾紛將透過仲裁解決的條款與條件 (「仲裁協議」)。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        本仲裁協議僅適用於訂閱實體以及其在美國的使用者。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        爭議解決和仲裁
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您和 Spotify 同意，您和/或您的訂閱實體與 Spotify
        之間因與本條款有關或以任何方式與本條款相關所引起的任何爭議、索賠或糾紛
        (無論是基於契約、侵權、法規、詐騙、不實陳述，或任何其他法律理論，且無論該索賠是產生於本條款期間或終止後)，將由具強制約束力的個別
        (而非集體) 仲裁決定。您代表您的訂閱實體與 Spotify
        進一步同意，仲裁人應擁有專屬權限，得自行決定其自身的管轄權，包括對於仲裁協議之存續、範圍或效力的任何異議，或與任何索賠或反索賠之可仲裁性有關的任何異議。仲裁中無法官或陪審團，且法院對仲裁裁定的複審是有限的。仲裁人必須遵循本條款，且可授予和法院相同的損害賠償與救濟
        (包含僅適用法律允許的律師費和支出)，但仲裁人無法裁定有益於非仲裁當事者的任何救濟，包括確認性或禁制性救濟。本仲裁規定將於本條款終止後存續。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        例外
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您代表您的訂閱實體和 Spotify
        均同意，本仲裁協議中的任何內容均不得視為放棄、排除或以其他方式限制我們任一方在任何時候提起以下個人訟訴的權利：(1)
        在美國小額索賠法院或 (2)
        根據上述爭議解決與仲裁一節所述的司法管轄和審判地點的法院，尋求 (a)
        暫時或初步的個別禁制性救濟，以待仲裁員做出最終判決，或 (b)
        公共禁制性救濟，以待仲裁員就該索賠的實質性做出判決。此外，本仲裁協議並未禁止您或我方將問題提交給聯邦、州級或地方機構處理。此等機構可在法律容許的情況下，代表您對我們尋求救濟
        (反之亦然)。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        不進行團體訴訟或代表訴訟程序；團體訴訟棄權
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您與 SPOTIFY
        同意，雙方僅能以您或其個人身分向對方提出索賠，而不能在任何所謂的團體訴訟或代表訴訟中作為原告或團體訴訟成員提出索賠。除非您與
        Spotify
        皆同意，否則任何仲裁人或法官不得整合一人以上的索賠或以其他方式審理任何形式的代表或團體訴訟。仲裁人僅可為尋求救濟的一方當事人裁定禁制性救濟，且僅限於提供該方當事人索賠所保證之救濟的必要範圍內。若法院裁定適用法律已排除本條款任何限制對於某一特定救濟請求的效力，則該項請求
        (也只有該項請求) 必須自仲裁程序分割開來，而得以向法院提出。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        仲裁規則
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        您或我們皆得啟動仲裁程序。您與 Spotify 之間的任何仲裁將根據美國仲裁協會
        (“AAA”) 當時有效施行之消費者仲裁規則 (「AAA
        規則」)，並依照本仲裁協議的修改內容進行。您與 Spotify
        同意，本條款之解釋與執行應適用美國聯邦仲裁法並以其為準據法
        (儘管上述準據法條款規定)。如須查看 AAA 規則以及如何向 AAA
        提出仲裁程序的說明，請造訪 adr.org，或請致電 AAA，電話為
        1-800-778-7879。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        任何仲裁聽證將盡可能透過電話或視訊會議進行，但若仲裁人判定應親自進行聽證會，則該聽證會的地點應由仲裁人根據
        AAA 規則決定。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        如果您選擇提出仲裁程序，而您需要支付申請費，Spotify
        將償還您的申請費，但若您的索賠金額超過 10,000
        美元，申請費將由您負擔。Spotify
        將支付任何其他仲裁費用，包括您應分擔的仲裁人報酬，除非 AAA
        規則或法院命令另有要求。無論仲裁以何種方式進行，仲裁人均應作成具理由的書面決定，所載內容必須足以闡明決定和裁決
        (如有)
        所依據的必要調查結果與結論。仲裁人可在程序進行期間的任何時間點，裁定並解決與支付及補償費用或支出有關的爭議，仲裁人做出實質裁決後
        14 日內，若任一方當事人提出此等請求，仲裁人亦得為之。
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        通知；程序
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        欲尋求仲裁的一方當事人，必須先向他方寄出書面的爭議通知，可透過電子郵件寄送至
        legal@spotify.com，並透過掛號郵件、聯邦快遞、UPS 或快遞 (需簽名)
        寄送至以下地址 (「通知」)。Spotify 的通知地址為：Spotify USA
        Inc.，收件人：法律總顧問，4 World Trade Center, 150 Greenwich Street,
        62nd Floor, New York, New York 10007, USA。該通知必須 (1)
        描述該索賠或爭議的性質或依據；以及 (2) 說明所尋求的特定救濟
        (「要求」)。我們同意盡力以誠信直接解決索賠，但是若我們未在收到該通知的
        30 天內達成協議，您或 Spotify 可以啟動仲裁程序。於仲裁期間，您或 Spotify
        所提出任何和解提議的金額，在仲裁人做出最後的決定與裁決，如有，之前，不得向仲裁人透露。如果我們之間的爭議最終透過仲裁以對您有利的方式解決，並且仲裁人做出的裁決金額高於
        Spotify 最後一次以書面提出的和解條件，則 Spotify
        將向您支付該裁決的金額或 1,000
        美元，以較高者為準。在仲裁過程中揭露的所有文件與資訊應由接收方嚴格保密，且接收方不得將其用於仲裁或執行仲裁人決定與裁決以外的任何目的，除對基於相關目的而需要知道的人私下揭露，或適用法律要求外，不得對外揭露。
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        可執行性
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        若本仲裁協議完全或部分失去效力，雙方同意，對於任何因該等無效而引起的爭議、索賠或糾紛，應適用上述「準據法和司法管轄權」一節中所述之專屬司法管轄和審判地點，不再受本仲裁協議管轄。
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="7-about-terms">
        7. 關於本條款
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        根據適用法律，您可能擁有合約無法限制的特定權利。本條款的意圖並非限制這些權利。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        本條款的變更
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        只要我們以任何合理方式向您通知，我們得不定期變更本條款
        (包括任何透過援引納入本條款的附加 Spotify 條款和條件)，方式包括在適用的
        Spotify 服務上發布修訂過的條款
        (若為重大變更，我們會以電子郵件、服務內彈出式訊息或服務內其他重要通知，或其他方式來補充此類通知)。任何此類變更均不適用於您與我們之間，在本條款變更之日前所發生的任何爭議。在本條款的任何變更後使用服務，即表示您接受此類變更。如果您不希望依照新版本的本條款繼續使用服務，可以聯絡我們以終止您的帳戶。本文件頂端所列的生效日期表示本條款上次的變更時間。
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        完整協議
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        除了本節所述或您與 Spotify 之間以書面明文協議以外，本條款構成您與
        Spotify
        之間達成共識的所有條款與條件，且取代關於本條款事項的任何先前書面或口頭協議。如上所述，本條款併入規範服務使用的其他條款與條件，包括下列條款與條件：Spotify
        使用者指南；Spotify 版權政策；以及 Spotify 支援社群條款。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        可分割性和棄權
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        除非本條款中另有規定，若本條款的任何規定因任何理由或在任何範圍內被認定為無效或無法執行，本條款之其他條文將不受影響，且該條款之適用應在法律允許的範圍內執行。
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify 或任何第三方受益人未能執行本條款或其任何規定之行為，不得解讀為
        Spotify 或相關第三方受益人放棄執行本條款的權利。
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        轉讓
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify 可轉讓本條款的部分或全部，也可轉讓或委任其於本條款的任何
        (全部或部分)
        權利或義務。您不得轉讓本條款之全部或其任何部分，或是將您根據本條款享有的權利移轉或再授權給任何第三方。
      </Type>
    </Layout>
  );
};

const TermsAndConditionsEs419 = () => {
  return (
    <Layout>
      <Type variant="altoBrio" as="h1" paddingBottom={spacer20}>
        Términos y Condiciones de uso
      </Type>
      <Type variant="cello" as="p" paddingBottom={spacer20}>
        Con vigencia a partir del 6 de septiembre del 2021
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#1-introduction">
          Introducción
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#2-service-provider">
          El Servicio de Spotify que proporcionamos
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#3-your-use-of-service">
          Su uso del Servicio de Spotify
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#4-property-rights">
          Derechos de propiedad intelectual y de contenido
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#5-customer-support">
          Servicio de atención al cliente, información, preguntas, quejas
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#6-problems-disputes">
          Problemas y conflictos
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#7-about-terms">
          Acerca de estos Términos
        </TextLink>
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="1-introduction">
        1. Introducción
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Lea cuidadosamente estos Términos y Condiciones de uso (estos
        “Términos”), ya que rigen el uso de los servicios en relación con los
        que se proporcionan estos Términos, lo que incluye todos los sitios web
        y las aplicaciones de software que incorporan estos Términos o
        proporcionan enlaces a estos (colectivamente, el “Servicio”) y cualquier
        material que esté disponible a través del Servicio (el “Contenido”),
        además del acceso a dichos servicios. El uso del Servicio puede estar
        sujeto a otros términos y condiciones proporcionados por Spotify, los
        que se incorporan a estos Términos mediante esta referencia.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        El Servicio está disponible solo para usuarios en la industria de la
        música con fines comerciales y no está abierto a “consumidores” según lo
        contemplado en las leyes de protección al consumidor pertinentes, ni a
        ninguna persona que actúe con fines personales, familiares o domésticos.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Con su registro en el Servicio, su acceso a este o su uso de este de
        alguna otra forma, usted acepta estos Términos en nombre de la entidad,
        organización o empresa que representa (lo que incluye, entre otros, los
        editores o subeditores relacionados con usted) (su “Entidad
        suscriptora”), y declara y garantiza lo siguiente: (1) usted es un
        representante autorizado de esa Entidad suscriptora con la autoridad
        para vincularla a estos Términos, sin importar si sigue siendo un
        representante autorizado de esa Entidad suscriptora en el futuro; (2) la
        Entidad suscriptora acepta estar sujeta a estos Términos; y (3) usted
        acepta estar sujeto a estos Términos en nombre de dicha Entidad
        suscriptora. Si usted no puede aceptar todo lo dispuesto en la oración
        anterior, no debe utilizar el Servicio.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        ESTOS TÉRMINOS CONTIENEN UNA DISPOSICIÓN DE ARBITRAJE OBLIGATORIA, QUE,
        COMO SE ESTABLECE MÁS ADELANTE EN LA SECCIÓN 6, EXIGE RECURRIR A
        ARBITRAJE INDIVIDUAL PARA RESOLVER CONFLICTOS, EN LUGAR DE JUICIOS CON
        JURADO O CUALQUIER OTRO PROCEDIMIENTO JUDICIAL, O ACCIONES COLECTIVAS DE
        CUALQUIER TIPO.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Proveedor de servicios
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Estos Términos se acuerdan entre su Entidad suscriptora y (a) Spotify
        USA Inc., una empresa de Delaware con oficinas en 4 World Trade Center,
        150 Greenwich Street, piso 62, Nueva York, Nueva York 10007, en caso de
        que su Entidad suscriptora esté constituida conforme a las leyes de los
        Estados Unidos de América o se encuentra sujeta a estas de alguna otra
        forma; o (b) Spotify AB, de Regeringsgatan 19, 111 53 Estocolmo, Suecia,
        con el número registrado 556703-7495, en caso de que su Entidad
        suscriptora sea una entidad constituida conforme a las leyes de
        cualquier país que no sea los Estados Unidos de América o se encuentre
        sujeta a estas de alguna otra forma.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Edad y requisitos de elegibilidad
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Para utilizar el Servicio en nombre de su Entidad suscriptora, usted
        debe cumplir con lo siguiente: (1) tener, al menos, 13 años de edad (o
        la edad mínima equivalente en su país); (2) contar con el consentimiento
        de un padre, una madre o un tutor si, en su país, a usted se lo
        considera menor de edad; (3) que ninguna ley pertinente le prohíba
        celebrar un contrato vinculante con nosotros en nombre de su Entidad
        suscriptora; y (4) residir en un país en el que esté disponible el
        Servicio. Usted promete que cualquier información de registro que envíe
        a Spotify es verdadera, precisa y está completa, y acepta mantenerla de
        esa manera en todo momento.
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="2-service-provider"
      >
        2. El Servicio de Spotify que proporcionamos
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Funciones beta
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        De vez en cuando, podemos ofrecer funciones beta mediante el Servicio
        (“Funciones beta”). Usamos funciones beta para experimentar y probar
        ideas de funciones nuevas. De esta manera, es posible que descubra que
        las Funciones beta aparecen un día, experimentan cambios periódicos o
        incluso desaparecen por completo sin aviso.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Limitaciones y modificaciones del Servicio
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Realizamos todos los esfuerzos razonables para mantener el Servicio en
        funcionamiento. Sin embargo, no seremos responsables ante usted por
        cambios que puedan ocurrir en la disponibilidad del Servicio, por
        ejemplo, en situaciones como las siguientes:
      </Type>

      <TypeList as="ul" listStyleReset={false}>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          Es posible que el Servicio experimente interrupciones temporales
          debido a dificultades técnicas, mantenimiento, pruebas o
          actualizaciones, incluidas las necesarias para reflejar los cambios en
          las leyes y los requisitos normativos pertinentes.
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          Nuestro objetivo es evolucionar y mejorar el Servicio de forma
          constante, por lo que es posible que lo modifiquemos, lo suspendamos o
          dejemos de proporcionarlo (de manera temporal o permanente) en parte o
          en su totalidad (lo que incluye funciones características, planes de
          suscripción y ofertas promocionales en particular).
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          Spotify no está obligado a proporcionar ningún contenido específico
          mediante el Servicio y es posible que Spotify u otros dueños
          correspondientes eliminen Contenido sin previo aviso.
        </Type>
      </TypeList>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify no tiene ninguna responsabilidad ante usted en relación con la
        interrupción de Internet o de otros servicios provocados por acciones de
        las autoridades gubernamentales, de otros terceros o de eventos que
        escapen a nuestro control.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Aplicaciones, dispositivos y software de código abierto de terceros
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Es posible que el Servicio se integre en aplicaciones, sitios web y
        servicios de terceros (“Aplicaciones de terceros”), y también en
        computadoras personales, teléfonos celulares, tabletas, dispositivos
        móviles, bocinas y otros dispositivos de terceros (“Dispositivos”) o que
        interactúe con ellos. El uso de las Aplicaciones de terceros y los
        Dispositivos puede estar sujeto a términos, condiciones y políticas
        adicionales que le proporcionen los terceros correspondientes. Spotify
        no garantiza que las Aplicaciones de terceros ni los Dispositivos sean
        compatibles con el Servicio.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Información de datos; errores
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted reconoce que el Servicio es un servicio opcional, que le
        proporcionamos para que lo utilice a nuestro criterio. Es posible que el
        Servicio le permita ver los datos de uso de su música y los datos
        demográficos de sus fans. Si bien nos esforzamos para asegurar la
        precisión de los datos, no garantizamos que el Servicio ni los datos que
        le proporcionemos estén libres de errores o que no se producirán errores
        de vez en cuando, incluso en la información de datos que le
        proporcionamos. Cuando se produzca un error o falla en el Servicio,
        haremos todo lo posible dentro de lo razonable para abordarlo o
        corregirlo. Acepta que se hará responsable de cualquier daño,
        responsabilidad o costo en que incurra como resultado de un error o
        falla de este servicio gratuito o que surja de su uso de los datos. Le
        proporcionamos todos los datos “EN EL ESTADO EN QUE SE ENCUENTRAN”.
        Usted usa todos los datos que le proporcionamos a su exclusivo riesgo y
        criterio.
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Si bien Spotify toma precauciones razonables para preservar y proteger
        el Contenido almacenado en la base de datos que utiliza para brindar el
        Servicio, usted no deberá depender de este como su única instalación de
        almacenamiento y deberá conservar copias de seguridad de su Contenido.
        Spotify no se hace responsable de los daños del Contenido, la
        eliminación de este o la imposibilidad de almacenarlo.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="3-your-use-of-service"
      >
        3. El uso del Servicio de Spotify
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Crear una cuenta de Spotify
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Es posible que deba crear una cuenta de Spotify para utilizar el
        Servicio de forma parcial o total. Su nombre de usuario y contraseña son
        únicamente para su uso individual y deben ser confidenciales. Usted
        comprende que es responsable de todo uso (incluido el uso no autorizado)
        de su nombre de usuario y contraseña. Notifique de forma inmediata a
        nuestro equipo de servicio de atención al cliente si perdió o le robaron
        su nombre de usuario o contraseña, o si piensa que alguien ingresó a su
        cuenta sin autorización.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Sus derechos de uso del Servicio
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Acceso al Servicio
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Siempre y cuando usted y su Entidad suscriptora cumplan con estos
        Términos (lo que incluye cualquier otro término y condición aplicable),
        le otorgamos, en nombre de su Entidad suscriptora, un permiso limitado,
        no exclusivo y revocable para utilizar el Servicio, lo que incluye,
        entre otras cosas, el Contenido (colectivamente, “Acceso”). Este Acceso
        permanecerá vigente, a menos que su Entidad suscriptora o Spotify lo
        rescindan y hasta el momento en que eso suceda. Acepta que no
        redistribuirá ni transferirá el Servicio o el Contenido. Las
        aplicaciones de software del Servicio y el Contenido se le conceden bajo
        licencia a la Entidad suscriptora, no se le venden ni transfieren a
        usted, y Spotify y sus licenciatarios retienen la propiedad de todas las
        copias de las aplicaciones de software del Servicio y el Contenido,
        incluso después de la instalación en sus Dispositivos. Al acceder al
        Servicio, usted acepta no realizar nada que le imponga una carga poco
        razonable al Servicio.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Cumplimiento de los Términos, delegación
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted reconoce y acepta, en nombre de su Entidad suscriptora, que estos
        Términos rigen su acceso al Servicio y otros usos de este. Usted acepta,
        en nombre de su Entidad suscriptora, no utilizar el Servicio, el
        Contenido ni ninguna parte de estos de ninguna manera que no esté
        expresamente permitida por estos Términos. Salvo en lo dispuesto de
        forma específica en estos Términos, usted no puede realizar nada de lo
        siguiente, ni total ni parcialmente: (a) copiar el Servicio ni ningún
        Contenido, (b) distribuir copias del Servicio ni de ningún Contenido, ni
        total ni parcialmente; (c) modificar el Servicio ni ningún Contenido,
        adaptarlos, traducirlos, realizarles ingeniería inversa, alterarlos,
        descompilarlos, replicarlos, desensamblarlos ni realizar obras derivadas
        basadas en estos; (d) utilizar el Servicio ni ningún Contenido,
        arrendarlos, prestarlos, sublicenciarlos, distribuirlos ni intentar
        conceder otros derechos al Servicio ni a ningún Contenido a terceros; ni
        (e) permitir el acceso remoto al Servicio ni a ningún Contenido por
        ningún medio a ninguna persona. Al utilizar el Servicio, usted debe
        cumplir todas las leyes, las reglas y los reglamentos aplicables, y
        respetar la propiedad intelectual, la privacidad y otros derechos de
        terceros.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Puede delegar su autoridad para utilizar el Servicio a usuarios
        adicionales únicamente dentro de su Entidad suscriptora si tienen una
        razón comercial para tal uso (cada uno de estos usuarios se denomina
        “Delegado”). Solo debe agregar Delegados a equipos específicos dentro
        del Servicio autorizados por la Entidad suscriptora, así como con una
        justificación comercial válida. En el caso de que cualquiera de sus
        Delegados acceda al Servicio o lo utilice de otro modo, usted reconoce y
        acepta, en nombre de su Entidad suscriptora, que estos Términos regirán
        también el uso del Servicio por parte de estos Delegados. Declara,
        garantiza y se compromete a que cada uno de sus Delegados está
        autorizado a utilizar el Servicio y subdelegar su autoridad a otros
        usuarios, en nombre de la Entidad suscriptora.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted acepta expresamente, en nombre de su Entidad suscriptora, lo
        siguiente: (1) usted y todos los Delegados cumplirán con estos Términos;
        (2) la Entidad suscriptora será completamente responsable de la
        infracción de estos Términos en que incurran usted o cualquier Delegado;
        y (3) la Entidad suscriptora será responsable de los actos u omisiones
        de usted y de sus Delegados a los efectos de estos Términos.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Derechos de propiedad de Spotify
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        El Servicio y el Contenido son propiedad de Spotify o de los
        licenciatarios de Spotify. Todas las marcas comerciales, las marcas de
        servicio, los nombres registrados, los logotipos, los nombres de dominio
        y cualquier otra función de la marca Spotify (las “Funciones de la marca
        Spotify”) son propiedad exclusiva de Spotify o de sus licenciatarios.
        Estos Términos no le otorgan a usted ni a su Entidad suscriptora ningún
        derecho para utilizar ninguna de las Funciones de la marca Spotify, ya
        sea para uso comercial o no comercial.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Control de exportación y sanciones
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Los productos de Spotify pueden estar sujetos a las leyes y regulaciones
        de control de exportaciones y reexportaciones de EE. UU. o leyes
        similares aplicables en otras jurisdicciones, incluidas las Regulaciones
        de Administración de Exportaciones (“EAR”) que mantiene el Departamento
        de Comercio y Sanciones Económicas de la Oficina de Control de Activos
        Extranjeros (“OFAC”) del Departamento de Tesorería y las regulaciones
        internacionales sobre tráfico de armas (“ITAR”) que mantiene el
        Departamento de Estado de EE. UU. Usted garantiza que ni usted ni su
        Entidad suscriptora (1) se encuentran en ningún país al que Estados
        Unidos le haya embargado bienes o al que le haya aplicado alguna sanción
        económica; ni (2) son una parte prohibida según lo especifique ninguna
        ley ni ningún reglamento de exportación o reexportación, o alguna ley
        similar aplicable en otras jurisdicciones, ni están incluidas en ninguna
        lista del Gobierno de EE. UU. de partes prohibidas o restringidas.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted, en nombre de su Entidad suscriptora, acepta cumplir con todas las
        leyes y los reglamentos de control de exportaciones y reexportaciones,
        incluidas, entre otras, las EAR y las sanciones comerciales y económicas
        que mantiene la OFAC. Específicamente, usted, en nombre de su Entidad
        suscriptora, acepta no utilizar ningún producto, software ni tecnología
        (incluidos los productos derivados de dicha tecnología o basados en
        esta) que reciba de Spotify según estos Términos, como tampoco
        venderlos, exportarlos, transferirlos, derivarlos, liberarlos ni
        entregarlos, directa o indirectamente, a ningún destinatario, entidad o
        persona para ningún uso final prohibido por la EAR, por sanciones
        comerciales y económicas mantenidas por la OFAC, ni por ninguna ley o
        ningún reglamento aplicable de Estados Unidos ni de ninguna otra
        jurisdicción sin obtener la debida autorización de las autoridades
        gubernamentales competentes según lo exijan dichas leyes o dichos
        reglamentos.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="4-property-rights"
      >
        4. Derechos de propiedad intelectual y de contenido
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Contenido de usuario
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        El contenido que usted publica en el Servicio
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted, en nombre de su Entidad suscriptora, puede publicar contenido,
        subirlo o compartirlo en el Servicio (“Contenido de usuario”). Para
        evitar dudas, el término “Contenido de usuario” incluye toda la
        información, los materiales y otro contenido que los usuarios agregan,
        crean, suben, envían, distribuyen o publican en el Servicio. Spotify, o
        cualquier tercero que haya designado Spotify, puede, a su entera
        discreción, decidir usar todos los metadatos proporcionados, o parte de
        ellos, en conexión con dicho Contenido de usuario, así como
        complementarlos o reemplazarlos.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted y su Entidad suscriptora son los únicos responsables de todo el
        Contenido de usuario que publican.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Respecto cualquier Contenido de usuario que usted publique en el
        Servicio, usted promete, en nombre de su Entidad suscriptora, lo
        siguiente: (1) usted es propietario de dicho Contenido de usuario o
        tiene derecho a publicarlo; (2) ni dicho Contenido de usuario ni su uso
        por parte de Spotify según la licencia otorgada a continuación (i)
        infringen estos Términos, lo que incluye las Pautas de usuario de
        Spotify, la ley aplicable, los reglamentos y las reglas de cualquier
        gremio, sindicato o colectivo, ni infringen los derechos de ningún
        tercero, lo que incluye cualquier propiedad intelectual (incluidos los
        derechos de autor), publicidad, privacidad, personalidad, contrato o
        cualquier otro derecho de otras personas, ni (ii) implican que Spotify
        ni ningún artista, ninguna banda, ningún sello ni otras personas o
        entidades estén afiliados a su Contenido de usuario ni lo patrocinen,
        sin el consentimiento previo por escrito de Spotify o de dichas personas
        o entidades; (3) usted ha adquirido cualquier derecho, licencia,
        autorización, consentimiento, permiso o aprobación de terceros
        relacionados con el Contenido de usuario que usted publique en el
        Servicio y que Spotify exija para ejercer la licencia otorgada en estos
        Términos, y los habrá adquirido, retenido y administrado correctamente;
        (4) usted será el único responsable de cumplir con los términos y
        condiciones estipulados en cada una de las licencias, las
        autorizaciones, los consentimientos, los permisos o las aprobaciones de
        terceros aludidos en la cláusula 3 de este párrafo, y será el único
        responsable de realizar el pago de cualquier regalía, tarifa u otro
        cobro (de cualquier forma que esté denominado) a todas las partes en la
        forma y en el plazo que se exijan en las licencias, las autorizaciones,
        los consentimientos, los permisos o las aprobaciones de dichos terceros;
        (5) ni Spotify ni ninguna persona ni entidad relacionada con el
        Contenido de usuario que usted publique en el Servicio, relacionada con
        el ejercicio de Spotify de la licencia otorgada en estos Términos ni que
        surja de estos pagarán ni deberán pagar ninguna regalía, tarifa ni otro
        cobro (de cualquier forma que esté denominado), los que tampoco se
        deberán pagar en nombre de estos; (6) todo el Contenido de usuario que
        usted publique en el Servicio es y deberá ser correcto y veraz, y
        carecer de contenido que infrinja las Pautas de usuario; y (7) usted
        deberá cumplir con todas las leyes, los reglamentos y los estándares de
        la industria al publicar Contenido de usuario en el Servicio, incluidas
        las pautas de la FTC (del inglés Federal Trade Commission, Comisión
        Federal de Comercio) sobre el uso de testimonios y patrocinios en los
        anuncios, las pautas de divulgaciones .com de la FTC, las pautas de
        anuncios nativos de la FTC, cualquier otra pauta emitida por la FTC
        oportunamente y las actualizaciones a dichas pautas.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Al publicar Contenido de usuario en el Servicio o compartirlo, tenga en
        cuenta que el público podrá acceder a cierto Contenido de usuario y que
        otras personas pueden utilizarlo y volver a compartirlo en el Servicio y
        en otros servicios de Spotify y en la Web. Por este motivo, le pedimos
        que tenga cuidado al publicar o compartir en el Servicio, y que sea
        consciente de la configuración de su cuenta. Spotify no se hace
        responsable de lo que usted u otros publican o comparten en el Servicio.
        En la medida en que usted o su Entidad suscriptora tengan acceso a una
        página o cuenta particular en el Servicio que también sea accesible para
        uno o más usuarios o Entidades suscriptoras, parte de su Contenido de
        usuario (lo que incluye, entre otros elementos, su nombre, función,
        nivel de acceso y ciertas acciones que realiza en el Servicio) pueden
        ser visibles para otros usuarios o Entidades suscriptoras. Su derecho a
        acceder y editar páginas o activos puede variar según sus derechos
        subyacentes sobre ese material y su nivel de acceso al Servicio. En
        algunos casos, usted puede compartir derechos de edición de una página o
        cuenta en particular en el Servicio con otros usuarios o Entidades
        suscriptoras.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Eliminaciones y supervisión del Contenido de usuario
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify no tendrá obligación de incluir el Contenido de usuario ni
        distribuirlo a través del Servicio. Spotify puede supervisar y revisar
        el Contenido de usuario autorizado, aunque no está obligado a hacerlo.
        Spotify se reserva el derecho de eliminar o deshabilitar el acceso a
        cualquier Contenido de usuario del Servicio a su exclusivo criterio, por
        cualquier razón o sin ninguna razón, lo que incluye, entre otras
        situaciones, cuando el Contenido de usuario infrinja las Pautas de
        usuario de Spotify, excepto según lo prohibido por las leyes
        pertinentes. Spotify puede llevar a cabo estas medidas sin notificarlo a
        usted ni a ningún tercero, y sin ninguna responsabilidad ante a usted
        por dicha eliminación.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Licencias que nos proporciona
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Contenido de usuario
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify no afirma poseer ningún derecho de propiedad sobre el Contenido
        de usuario que usted publique en el Servicio. Después de publicar
        Contenido de usuario en el Servicio, según lo acordado entre usted y
        Spotify, usted conservará todos sus derechos sobre su Contenido de
        usuario, lo que incluye cualquier derecho de propiedad intelectual u
        otros derechos de propiedad asociados con su Contenido de usuario,
        sujetos a la licencia que usted le otorga a Spotify en el siguiente
        párrafo de esta sección.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Mediante la publicación de Contenido de usuario en el Servicio, usted,
        en nombre de su Entidad suscriptora, otorga a Spotify una licencia no
        exclusiva, transferible, sublicenciable, libre de regalías, totalmente
        pagada y mundial para reproducir dicho Contenido de usuario, ponerlo a
        disposición de terceros, presentarlo, traducirlo, modificarlo, crear
        obras derivadas basadas en este, distribuirlo y utilizarlo de otras
        formas por cualquier medio, ya sea solo o en combinación con otro
        contenido u otros materiales, de cualquier forma y por cualquier medio,
        método o tecnología, ya sean conocidos actualmente o creados en el
        futuro, en relación con el Servicio y con el servicio de transmisión de
        música de Spotify, la promoción y el marketing del Servicio y el
        servicio de transmisión de música de Spotify, y la promoción y el
        marketing del Servicio y el servicio de transmisión de música de
        Spotify. Si no desea que Spotify utilice su Contenido de usuario con
        estos fines, no debe publicar Contenido de usuario en el Servicio. En la
        medida en que usted proporcione Contenido de usuario que contenga su
        nombre, similitud o fotografía, usted nos otorga, además, el derecho no
        exclusivo, totalmente pagado y mundial de utilizar dicho nombre, dicha
        similitud o dicha fotografía en el Servicio, en el servicio de
        transmisión de música de Spotify y en nuestras comunicaciones de
        marketing, con el fin de publicitar la disponibilidad de su Contenido de
        usuario en el Servicio y en el servicio de transmisión de música de
        Spotify, comercializarla y promocionarla. En los casos en que
        corresponda y lo permita la ley pertinente, también acepta renunciar y
        no hacer cumplir ningún “derecho moral” o derechos equivalentes, tales
        como el de que se lo identifique como autor de cualquier Contenido de
        usuario autorizado, incluidos los Comentarios (como se definen a
        continuación), y su derecho a oponerse al tratamiento despectivo de
        dicho Contenido de usuario.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Comentarios
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Si proporciona ideas, sugerencias u otro tipo de comentarios en relación
        con su uso del Servicio o cualquier Contenido (“Comentarios”), tales
        Comentarios no son confidenciales y Spotify puede usarlos sin
        restricción y sin pagarle a usted. Los Comentarios se consideran un tipo
        de Contenido de usuario en función de estos Términos.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Su Dispositivo
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        También nos otorga el derecho de permitir que el Servicio utilice el
        procesador, el ancho de banda y el hardware de almacenamiento en su
        Dispositivo para facilitar el funcionamiento del Servicio.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Reclamo de infracciones
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify respeta los derechos de los propietarios de la propiedad
        intelectual. Si cree que cualquier Contenido infringe sus derechos de
        autor, consulte la Política de derechos de autor de Spotify.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="5-customer-support"
      >
        5. Servicio de atención al cliente, información, preguntas y quejas.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Servicio de atención al cliente, información, preguntas, quejas
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Para obtener servicio de atención al cliente (“Consultas de atención al
        cliente”), utilice los recursos de servicio de atención al cliente que
        se indican en la sección Comuníquese con nosotros de nuestro sitio web.
        También puede comunicarse con nosotros a la dirección postal que se
        indica en la sección “Proveedor de servicios” al comienzo de estos
        Términos.
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="6-problems-disputes"
      >
        6. Problemas y conflictos
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Suspender y rescindir el Servicio
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted seguirá rigiéndose por estos Términos hasta que su Entidad
        suscriptora o Spotify los rescindan. Spotify puede rescindir estos
        Términos (lo que incluye cualquier término y condición adicionales
        incorporados en este acuerdo) o suspender su acceso al Servicio en
        cualquier momento si creemos que usted o su Entidad suscriptora
        incumplió cualquiera de estos Términos, si dejamos de proporcionar el
        Servicio o cualquier material que sea parte de este, o si lo creemos
        necesario para cumplir con las leyes pertinentes.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Si existe un conflicto entre usted o su Entidad suscriptora y cualquier
        tercero en cuanto a la propiedad o el uso autorizado de una cuenta
        (incluida la cuenta de cualquiera de sus Delegados), Spotify puede
        suspender cualquier acceso a dicha cuenta en cualquier momento y sin
        ninguna responsabilidad ante usted, sus Delegados ni ninguna otra
        persona o entidad, incluida su Entidad suscriptora. Spotify podrá
        resolver las disputas entre los usuarios o dejar que las partes
        involucradas las resuelvan. Dichas partes podrán solicitar la
        intervención de un tribunal de la jurisdicción competente. Si Spotify
        resuelve algún conflicto, usted acepta que la decisión de Spotify es
        definitiva y vinculante para usted y su Entidad suscriptora, y que ni
        usted ni su Entidad suscriptora tendrán derecho de acción contra
        Spotify, sin perjuicio de que usted sí pueda aplicar recursos contra
        algún tercero según lo dispuesto en la ley pertinente. Spotify también
        cumplirá cualquier orden legal de un tribunal de jurisdicción
        competente.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Si su Entidad suscriptora o Spotify rescinden estos Términos, o si
        Spotify suspende su acceso al Servicio, usted, en nombre de su Entidad
        suscriptora, acepta que Spotify no tendrá ninguna responsabilidad ante
        usted ni su Entidad suscriptora y que, con excepción de lo establecido
        de forma expresa en estos Términos, Spotify no reembolsará ningún
        importe que usted haya pagado. Su Entidad suscriptora puede rescindir
        estos Términos o su derecho individual de acceder al Servicio en
        cualquier momento, en cuyo caso, usted no podrá seguir accediendo al
        Servicio ni utilizarlo. Para obtener información acerca de cómo
        rescindir su cuenta de Spotify, utilice los recursos del Servicio de
        atención al cliente disponibles en la página Acerca de nosotros.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Las siguientes secciones se mantendrán vigentes incluso después de la
        rescisión: las secciones 2 (El Servicio de Spotify que proporcionamos),
        3 (Su uso del Servicio de Spotify) (excepto lo establecido en dicha
        sección), 4 (Derechos de propiedad intelectual y de contenido), 6
        (Problemas y conflictos) y 7 (Acerca de estos Términos), así como
        cualquier otra sección de estos Términos que deba mantenerse vigente
        después de la rescisión, ya sea de manera explícita o debido a su
        naturaleza.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Descargos de responsabilidad de garantía
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        EL SERVICIO SE PROPORCIONA “EN EL ESTADO EN QUE SE ENCUENTRA” Y “SEGÚN
        ESTÉ DISPONIBLE”, SIN GARANTÍAS DE NINGÚN TIPO, YA SEAN EXPLÍCITAS,
        IMPLÍCITAS O LEGALES. ADEMÁS, SPOTIFY Y TODOS LOS DUEÑOS DEL CONTENIDO
        RENUNCIAN A CUALQUIER GARANTÍA EXPLÍCITA, IMPLÍCITA Y LEGAL EN RELACIÓN
        CON EL CONTENIDO, INCLUIDAS LAS GARANTÍAS DE CALIDAD SATISFACTORIA,
        COMERCIABILIDAD, APTITUD PARA CUALQUIER PROPÓSITO O NO INFRACCIÓN. NI
        SPOTIFY NI NINGÚN DUEÑO DE CONTENIDO GARANTIZAN QUE EL SERVICIO O EL
        CONTENIDO ESTARÁ LIBRE DE MALWARE U OTROS COMPONENTES DAÑINOS. SPOTIFY
        TAMPOCO REALIZA NINGUNA DECLARACIÓN SOBRE NINGUNA APLICACIÓN DE TERCEROS
        (NI SU CONTENIDO), CONTENIDO DE USUARIO, DISPOSITIVOS NI NINGÚN PRODUCTO
        O SERVICIO PUBLICITADO, PROMOCIONADO U OFRECIDO POR TERCEROS, YA SEA EN
        EL SERVICIO O A TRAVÉS DE ESTE O CUALQUIER SITIO WEB HIPERVINCULADO, NO
        GARANTIZA NI ASUME NINGUNA RESPONSABILIDAD POR ESTOS NI ES RESPONSABLE
        DE NINGUNA TRANSACCIÓN ENTRE USTED Y NINGÚN PROVEEDOR EXTERNO DE LO
        MENCIONADO ANTERIORMENTE. NINGÚN CONSEJO O INFORMACIÓN EN FORMATO ORAL O
        ESCRITO QUE HAYA OBTENIDO DE SPOTIFY CREARÁ GARANTÍAS EN NOMBRE DE
        SPOTIFY. ESTA SECCIÓN SE APLICA EN LA MÁXIMA MEDIDA PERMITIDA POR LAS
        LEYES PERTINENTES.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Limitación de responsabilidad y tiempo para presentar un reclamo
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        USTED ACEPTA QUE SU ÚNICO Y EXCLUSIVO RECURSO PARA RESOLVER CUALQUIER
        PROBLEMA O INSATISFACCIÓN CON EL SERVICIO ES DESINSTALAR CUALQUIER
        SOFTWARE DE SPOTIFY Y DEJAR DE USAR EL SERVICIO. USTED ACEPTA QUE
        SPOTIFY NO TIENE OBLIGACIÓN NI RESPONSABILIDAD ALGUNA EN RELACIÓN CON
        APLICACIONES DE TERCEROS O CONTENIDO DE ESTAS QUE ESTÉ DISPONIBLE A
        TRAVÉS DEL SERVICIO O EN RELACIÓN CON ESTE, Y, AUNQUE SU RELACIÓN CON
        DICHAS APLICACIONES DE TERCEROS ESTÉ REGIDA POR ACUERDOS INDEPENDIENTES
        CON DICHOS TERCEROS, SU ÚNICO Y EXCLUSIVO RECURSO CON RESPECTO A SPOTIFY
        POR CUALQUIER PROBLEMA O INSATISFACCIÓN CON CUALQUIER APLICACIÓN DE
        TERCEROS O EL CONTENIDO DE ESTAS ES DESINSTALAR DICHAS APLICACIONES O
        DEJAR DE UTILIZARLAS.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        EN NINGÚN CASO SPOTIFY, SUS FUNCIONARIOS, ACCIONISTAS, EMPLEADOS,
        AGENTES, DIRECTORES, SUBSIDIARIAS, AFILIADOS, SUCESORES, CESIONISTAS,
        PROVEEDORES NI LICENCIANTES SERÁN RESPONSABLES DE LO SIGUIENTE: (1)
        DAÑOS INDIRECTOS, ESPECIALES, INCIDENTALES, PUNITIVOS, EJEMPLARES O
        CONSECUENTES; (2) NINGUNA PÉRDIDA DE USO, DATOS, NEGOCIOS O GANANCIAS
        (YA SEA DIRECTA O INDIRECTA), EN TODOS LOS CASOS, DERIVADA DEL USO DEL
        SERVICIO DE SPOTIFY, LOS DISPOSITIVOS, LAS APLICACIONES DE TERCEROS O SU
        CONTENIDO, O LA INCAPACIDAD DE USARLOS, SIN IMPORTAR LA TEORÍA JURÍDICA,
        INDEPENDIENTEMENTE DE SI SE HA ADVERTIDO A SPOTIFY DE LA POSIBILIDAD DE
        TALES DAÑOS, E INCLUSO SI UN RECURSO NO FUNCIONA PARA SU PROPÓSITO
        ESENCIAL; O (3) LA RESPONSABILIDAD AGREGADA POR TODAS LAS RECLAMACIONES
        RELACIONADAS CON EL SERVICIO DE SPOTIFY, LAS APLICACIONES DE TERCEROS O
        EL CONTENIDO DE APLICACIONES DE TERCEROS MÁS QUE LO QUE SEA MAYOR ENTRE
        (A) LAS CANTIDADES PAGADAS POR USTED A SPOTIFY DURANTE LOS DOCE MESES
        ANTERIORES AL PRIMER RECLAMO Y (B) USD 30.00.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Para fines de aclaración, estos Términos no limitan la responsabilidad
        de Spotify por fraude, tergiversación fraudulenta, muerte o lesiones
        personales en la medida en que las leyes pertinentes prohíban dicha
        limitación.
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        CUALQUIER RECLAMACIÓN QUE PROVENGA DE LOS TÉRMINOS SE DEBE INICIAR
        (MEDIANTE LA PRESENTACIÓN DE UNA DEMANDA DE ARBITRAJE O LA PRESENTACIÓN
        DE UNA ACCIÓN INDIVIDUAL SEGÚN EL ACUERDO DE ARBITRAJE A CONTINUACIÓN)
        DENTRO DEL PLAZO DE UN (1) AÑO DESPUÉS DE LA FECHA EN QUE LA PARTE QUE
        HACE LA RECLAMACIÓN SE ENTERA DEL ACTO, LA OMISIÓN O EL INCUMPLIMIENTO
        DEL QUE DERIVA EL RECLAMO, O DE LA FECHA EN QUE DEBERÍA HABERLOS
        CONOCIDO DE MANERA RAZONABLE; Y NO HABRÁ DERECHO A NINGÚN RECURSO PARA
        NINGUNA RECLAMACIÓN QUE NO SE PRESENTE DENTRO DE ESE PERÍODO.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Derechos de terceros
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted reconoce y acepta que los dueños del Contenido y ciertos
        distribuidores (tales como los proveedores de tiendas de aplicaciones)
        son los beneficiarios previstos de estos Términos y tienen el derecho de
        hacerlos cumplir de forma directa contra usted. Aparte de lo establecido
        en esta sección, los Términos no están destinados a otorgar derechos a
        nadie, excepto a Spotify y a usted, y en ningún caso los Términos
        crearán derechos de terceros beneficiarios.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Si usted descargó cualquiera de nuestras aplicaciones de software
        móviles (cada una, “Aplicación”) desde la tienda de aplicaciones de
        Apple Inc. (“Apple”) o si utiliza la Aplicación en un dispositivo iOS,
        usted reconoce que leyó, comprendió y acepta el siguiente aviso con
        respecto a Apple. Estos Términos se acuerdan solo entre su Entidad
        suscriptora y Spotify, no con Apple, y Apple no es responsable del
        Servicio ni del contenido de este. Apple no tiene obligación alguna de
        brindar ningún servicio de mantenimiento ni soporte con respecto al
        Servicio. En caso de que el Servicio no cumpla con alguna garantía
        aplicable, usted puede notificar a Apple, y esta le reembolsará el
        precio de compra aplicable por la aplicación, y, en la medida que lo
        permita la ley aplicable, Apple no tiene ninguna otra obligación en
        absoluto respecto del Servicio. Apple no se hace responsable de abordar
        ninguna reclamación que usted ni ningún tercero realicen en relación con
        el Servicio ni con o su posesión o uso del Servicio, lo que incluye lo
        siguiente: (1) las reclamaciones de responsabilidad del producto; (2)
        cualquier reclamación de que el Servicio de Spotify no cumple con
        requisitos legales o normativos pertinentes; (3) reclamaciones que se
        amparen en la protección del consumidor y otras legislaciones similares;
        y (4) reclamaciones relacionadas con la infracción de la propiedad
        intelectual. Apple no es responsable de la investigación, la defensa, el
        acuerdo ni la extinción de ninguna reclamación de terceros de que el
        Servicio o la posesión y uso de la Aplicación por parte de usted
        infringen los derechos de propiedad intelectual de dicho tercero. Usted
        acepta cumplir con todos los términos de terceros pertinentes cuando usa
        el Servicio. Apple, y sus subsidiarios, son terceros beneficiarios de
        los Términos, y con la aceptación de los Términos, Apple tiene el
        derecho (y se validará que acepte el derecho) de hacer cumplir estos
        Términos en su contra como un tercero beneficiario de los Términos.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Indemnización
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted, en nombre de su Entidad suscriptora, acepta indemnizar a Spotify
        y eximirla de responsabilidad por cualquier daño, pérdida y gasto de
        cualquier tipo (incluidos los honorarios y costos razonables de
        abogados) que surja de lo siguiente o en relación con lo siguiente: (1)
        el incumplimiento por parte de usted de cualquiera de estos Términos
        (incluido cualquier término y condición adicional de Spotify
        incorporados en este acuerdo); (2) cualquier Contenido de usuario que
        usted publique o aporte de otra manera; (3) cualquier actividad en la
        que usted participe en el Servicio o a través de este; y (4) la
        infracción por parte de usted de cualquier ley o derecho de terceros.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Ley vigente, arbitraje obligatorio y lugar
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Ley vigente y jurisdicción
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Estos Términos se rigen por las leyes del estado de Nueva York, Estados
        Unidos de Norteamérica, y se deberán interpretar según estas,
        independientemente de los principios de selección de la ley aplicable o
        los conflictos de leyes de Nueva York. Asimismo, su Entidad suscriptora
        y Spotify aceptan la jurisdicción de los tribunales federales y
        estatales ubicados en el condado de Nueva York, estado de Nueva York,
        para resolver cualquier conflicto, reclamación o controversia respecto
        de estos Términos o del Servicio que no estén sujetos a arbitraje
        obligatorio según el Acuerdo de arbitraje a continuación, y renuncian a
        cualquier objeción jurisdiccional, de competencia o de foro
        inconveniente a dichos tribunales.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        ACUERDO DE ARBITRAJE
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        En esta sección de Acuerdo de arbitraje, se establecen los términos y
        condiciones según los cuales se resolverán los conflictos, las
        reclamaciones y las controversias entre usted y Spotify a través de
        arbitraje (“Acuerdo de arbitraje”).
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Este Acuerdo de arbitraje se aplica solo a las Entidades suscriptoras y
        sus usuarios en Estados Unidos.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Resolución de conflictos y arbitraje
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted y Spotify acuerdan que cualquier conflicto, reclamación o
        controversia entre usted o su Entidad suscriptora y Spotify
        relacionados, de cualquier forma, con estos Términos o con la relación
        de usted con Spotify como usuario del Servicio (ya sea por contrato,
        agravio, estatuto, fraude, tergiversación o cualquier otra teoría legal,
        independientemente de si las reclamaciones surgen durante la vigencia de
        estos Términos o después de su rescisión) se resolverán por arbitraje
        obligatorio, vinculante e individual (no colectivo). Usted, en nombre de
        su Entidad suscriptora, y Spotify aceptan, además, que el árbitro tendrá
        el poder exclusivo de decidir sobre su propia jurisdicción, lo que
        incluye cualquier objeción con respecto a la existencia, el alcance o la
        validez del Acuerdo de arbitraje o la arbitrabilidad de cualquier
        reclamación o contrademanda. NO HAY JUEZ NI JURADO EN EL ARBITRAJE, Y LA
        REVISIÓN JUDICIAL DE UN LAUDO ARBITRAL ES LIMITADA. El árbitro debe
        acatar estos Términos y puede adjudicar las mismas indemnizaciones por
        concepto de daños y perjuicios y compensaciones que un tribunal
        (incluidos los honorarios y costos de abogados permitidos por la ley
        pertinente), con la excepción de que el árbitro no puede adjudicar
        ninguna compensación, incluidas sentencias declaratorias o medidas
        cautelares, que beneficie a cualquier persona que no sean los
        participantes en el arbitraje. Esta disposición de arbitraje tendrá
        vigencia tras la rescisión de estos Términos.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Excepciones
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted, en nombre de su Entidad suscriptora, y Spotify aceptan que no se
        considerará que ninguna parte de este Acuerdo de arbitraje es una
        renuncia, un impedimento ni un límite de ninguna de las partes respecto
        de sus derechos de llevar a cabo, en cualquier momento, una acción
        individual (1) en un tribunal con jurisdicción sobre controversias de
        cuantía menor de EE. UU. o (2) en un tribunal de justicia
        correspondiente a la jurisdicción y la competencia descritas
        anteriormente en la sección Resolución de conflictos y arbitraje,
        destinada a (a) solo medidas cautelares temporales o preliminares
        individualizadas a la espera del fallo final del árbitro, o (b) medidas
        cautelares públicas a la espera de un fallo sobre la esencia de dicha
        reclamación por parte del árbitro. Además, este Acuerdo de arbitraje no
        le impide a usted o a nosotros plantear problemas ante agencias
        federales, estatales o locales. Dichas agencias pueden, si la ley lo
        permite, solicitar compensación en nuestra contra, en su nombre (o
        viceversa).
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        No hay procedimientos colectivos o representativos, renuncia de acciones
        colectivas
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        SPOTIFY Y USTED ACUERDAN QUE CADA UNO PUEDE DEMANDAR AL OTRO SOLO DE
        FORMA INDIVIDUAL Y NO COMO UN DEMANDANTE O MIEMBRO DE UNA ACCIÓN
        COLECTIVA O REPRESENTATIVA. A menos que tanto usted como Spotify lo
        acuerden, ningún árbitro o juez puede consolidar más de un reclamo por
        persona ni presidir ningún tipo de procedimiento representativo o
        colectivo. El árbitro puede otorgar medidas cautelares solo a favor de
        la parte individual que busca compensación y solo en la medida necesaria
        para proporcionar la compensación garantizada por el reclamo individual
        de esa parte. Si un tribunal decide que la ley pertinente excluye el
        cumplimiento de cualquiera de las limitaciones de este párrafo respecto
        de un reclamo particular, dicho reclamo (y solo ese reclamo) debe
        separarse del arbitraje y puede presentarse ante un tribunal.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Reglas de arbitraje
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Tanto usted como nosotros podemos iniciar procedimientos de arbitraje.
        Cualquier arbitraje entre Spotify y usted se llevará a cabo en virtud de
        las Reglas de arbitraje del consumidor de la Asociación Americana de
        Arbitraje (“AAA”) en vigencia en ese momento (“Reglas de la AAA”) según
        lo modificado por este Acuerdo de arbitraje. Spotify y usted acuerdan
        que la Ley federal de arbitraje se aplica y rige la interpretación y
        aplicación de esta disposición (a pesar de la disposición sobre la
        elección de la ley antes mencionada). Las Reglas de la AAA, así como las
        instrucciones sobre cómo presentar una demanda para arbitraje ante
        ellos, aparecen en adr.org, o puede llamar al 1-800-778-7879.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Las audiencias de arbitraje se llevarán a cabo por teléfono o
        videoconferencia en la medida de lo posible, pero si el árbitro
        determina que una audiencia debe llevarse a cabo en persona, el árbitro
        determinará el lugar para dicha audiencia de acuerdo con las reglas de
        arbitraje de la AAA.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Si decide presentar un procedimiento de arbitraje y tiene la obligación
        de pagar una tarifa de presentación, Spotify reembolsará la tarifa de
        presentación, a menos que su reclamo sea por más de USD 10 000, en cuyo
        caso usted será responsable de la tarifa de presentación. Spotify pagará
        cualquier otra tarifa de arbitraje, incluida la parte de usted de la
        compensación del árbitro, a menos que las reglas de AAA o una orden
        judicial exijan lo contrario. Sin importar la manera en que se lleve a
        cabo el arbitraje, el árbitro emitirá una decisión escrita y
        fundamentada que sea suficiente para explicar los hechos y conclusiones
        esenciales sobre los cuales se basa la decisión y el fallo, si los
        hubiera. El árbitro puede tomar decisiones y resolver disputas sobre el
        pago y el reembolso de honorarios o gastos en cualquier momento durante
        el procedimiento y a solicitud de cualquiera de las partes dentro de los
        14 días de haber tomado la decisión del árbitro sobre el asunto.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Aviso, proceso
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        La parte que tenga la intención de solicitar el arbitraje primero debe
        enviar un aviso por escrito del conflicto a la otra parte por correo
        electrónico a legal@spotify.com y por correo certificado, Federal
        Express, UPS o Express Mail (firma obligatoria) a la dirección que
        aparece a continuación (“Aviso”). La dirección para Avisos de Spotify
        es: Spotify USA Inc., Attn: General Counsel, 4 World Trade Center, 150
        Greenwich Street, 62nd Floor, New York, New York 10007, USA. El Aviso
        debe (1) describir la naturaleza y la base del reclamo o la disputa; y
        (2) establecer la compensación específica que se solicita (“Demanda”).
        Acordamos hacer lo posible de buena fe para resolver el reclamo
        directamente, pero si no llegamos a un acuerdo para hacerlo dentro de
        los 30 días posteriores a la recepción del Aviso, Spotify o usted podrán
        iniciar un procedimiento de arbitraje. Durante el arbitraje, el importe
        de cualquier oferta de acuerdo que haga Spotify o usted no se le
        divulgará al árbitro hasta que este tome una decisión y fallo final, si
        los hubiere. En caso de que nuestro conflicto se resuelva finalmente a
        través del arbitraje a su favor y el árbitro emita un fallo que es mayor
        que el valor de la última oferta de acuerdo escrita de Spotify, entonces
        Spotify le pagará el monto del fallo o USD 1000, el monto que sea mayor.
        Todos los documentos y la información divulgados durante el arbitraje
        serán estrictamente confidenciales por parte del destinatario y no los
        usará para ningún fin que no sean los del arbitraje o la aplicación de
        la decisión y el fallo del árbitro, y no los divulgará, excepto en forma
        confidencial, a las personas que tengan la necesidad de conocerlos para
        dichos efectos o según lo requiera la ley aplicable.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Exigibilidad
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Si este Acuerdo de arbitraje se invalida en su totalidad o parcialmente,
        las partes acuerdan que la jurisdicción y la competencia exclusivas
        descritas en la sección “Ley vigente y jurisdicción” anterior regirán en
        relación con cualquier aspecto de cualquier conflicto, reclamación o
        controversia que, como resultado de dicha invalidación, ya no se rija
        por el Acuerdo de arbitraje.
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="7-about-terms">
        7. Acerca de estos Términos
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Usted puede gozar de algunos derechos que no pueden limitarse mediante
        un contrato, conforme a las leyes pertinentes. Estos Términos no están
        destinados a restringir dichos derechos.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Cambios en estos Términos
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Es posible que realicemos cambios esporádicos en estos Términos (lo que
        incluye cualquier término y condición adicionales de Spotify,
        incorporados en este acuerdo como referencia) notificándolo a usted de
        tales cambios por cualquier medio razonable, lo que incluye la
        publicación de los Términos modificados en el Servicio de Spotify
        pertinente (para cambios sustanciales, buscaremos complementar tal aviso
        mediante correo electrónico, un mensaje emergente en el servicio, alguna
        otra notificación visible en el Servicio u otros medios). Dichos cambios
        no se aplicarán a ningún conflicto entre usted y nosotros que surja
        antes de la fecha en que se cambiaron los Términos. Su uso del Servicio
        posterior a los cambios en los Términos será considerado una aceptación
        de tales cambios. Si desea dejar de utilizar el Servicio debido a la
        actualización de los Términos, puede comunicarse con nosotros para
        rescindir su cuenta. La fecha de entrada en vigor indicada al comienzo
        de este documento indica la última fecha en que se realizaron cambios en
        estos Términos.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Totalidad del acuerdo
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Aparte de lo que se indica en esta sección o según lo acordado de manera
        explícita por escrito entre Spotify y usted, los Términos constituyen
        todos los términos y condiciones acordados entre Spotify y usted, y
        sustituyen cualquier acuerdo previo en relación con el objeto de estos
        Términos, ya sea escrito u oral. Como se mencionó previamente, otros
        términos y condiciones que rigen el uso del Servicio se incorporan en
        este acuerdo como referencia, lo que incluye los siguientes términos y
        condiciones: las Pautas de usuario de Spotify, la Política de derechos
        de autor de Spotify y los Términos de la Comunidad de Soporte de
        Spotify.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Divisibilidad y renuncia
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        En caso de que cualquier disposición de estos Términos se considere no
        válida o no exigible por cualquier motivo o en cualquier medida, las
        disposiciones restantes no se verán afectadas y la aplicación de tal
        disposición se cumplirá en la medida de lo permitido por la ley, a menos
        que se establezca lo contrario en estos Términos.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        En caso de que Spotify o cualquier tercero beneficiario no exija el
        cumplimiento de estos Términos o cualquiera de sus disposiciones, esto
        no significará la renuncia al derecho de hacerlo por parte de Spotify o
        cualquier tercero beneficiario pertinente.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Transferencia
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify puede transferir parte de los Términos o la totalidad de estos,
        y puede transferir o delegar, en parte o en su totalidad, cualquiera de
        los derechos u obligaciones conforme a estos Términos. Usted no puede
        transferir los Términos, ni ninguna parte de ellos, ni ceder o
        sublicenciar sus derechos en virtud de estos Términos a ningún tercero.
      </Type>
    </Layout>
  );
};

const TermsAndConditions = () => {
  const { locale } = useRouter();
  const [testCookie, , deleteTestCookie] = useCookie('terms-test-cookie');
  useEffect(() => {
    if (testCookie === 'true') {
      // eslint-disable-next-line no-alert
      alert('hello and welcome to terms and conditions!');
      deleteTestCookie();
    }
  }, [deleteTestCookie, testCookie]);
  if (locale === 'ko') {
    return <TermsAndConditionsKo />;
  } else if (locale === 'ja') {
    return <TermsAndConditionsJa />;
  } else if (locale === 'pt-BR') {
    return <TermsAndConditionsPtBr />;
  } else if (locale === 'zh-Hant') {
    return <TermsAndConditionsZhHant />;
  } else if (locale === 'es-419') {
    return <TermsAndConditionsEs419 />;
  }
  return (
    <Layout>
      <Type variant="altoBrio" as="h1" paddingBottom={spacer20}>
        Terms and Conditions of Use
      </Type>
      <Type variant="cello" as="p" paddingBottom={spacer20}>
        Effective as of 6 September 2021
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#1-introduction">
          Introduction
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#2-service-provider">
          The Spotify Service Provided by Us
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#3-your-use-of-service">
          Your Use of the Spotify Service
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#4-property-rights">
          Content and Intellectual Property Rights
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#5-customer-support">
          Customer Support, Information, Questions, Complaints
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#6-problems-disputes">
          Problems and Disputes
        </TextLink>
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        <TextLink standalone href="#7-about-terms">
          About These Terms
        </TextLink>
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="1-introduction">
        1. Introduction
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Please read these Terms and Conditions of Use (these “Terms”) carefully
        as they govern use of (which includes access to) the services that these
        Terms are provided in connection with, including all websites and
        software applications that incorporate or link to these Terms,
        (collectively, the “Service”) and any material that is made available
        through the Service (the “Content”). Use of the Service may be subject
        to additional terms and conditions presented by Spotify, which are
        hereby incorporated by this reference into these Terms.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        The Service is made available only to users in the music industry for
        business purposes, and is not open to “consumers” as contemplated in
        applicable consumer protection laws, or anyone acting for personal,
        family or household purposes.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        By signing up for, accessing, or otherwise using the Service, you agree
        to these Terms on behalf of the entity, organization or business that
        you represent (including without limitation, your related publishers and
        sub-publishers) (your “Subscribing Entity”), and you represent and
        warrant that: (1) you are an authorized representative of that
        Subscribing Entity with the authority to bind the Subscribing Entity to
        these Terms, regardless of whether you remain an authorized
        representative of that Subscribing Entity in the future; (2) the
        Subscribing Entity agrees to be bound by these Terms; and (3) you agree
        to be bound by these Terms on behalf of such Subscribing Entity. If you
        cannot agree to everything in the preceding sentence, then you must not
        use the Service.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        THESE TERMS CONTAIN A MANDATORY ARBITRATION PROVISION THAT, AS FURTHER
        SET FORTH IN SECTION 6 BELOW, REQUIRES THE USE OF ARBITRATION ON AN
        INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER THAN JURY TRIALS OR ANY
        OTHER COURT PROCEEDINGS, OR CLASS ACTIONS OF ANY KIND.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Service Provider
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        These Terms are between your Subscribing Entity, and (a) if your
        Subscribing Entity is organized under, or otherwise subject to the laws
        of, the United States of America: Spotify USA Inc., a Delaware
        Corporation with offices at 4 World Trade Center, 150 Greenwich Street,
        62nd Floor, New York, New York 10007; or (b) if your Subscribing Entity
        is an entity organized under, or otherwise subject to the laws of, any
        country outside of the United States of America: Spotify AB, of
        Regeringsgatan 19, 111 53 Stockholm, Sweden, with registered number
        556703-7495.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Age and eligibility requirements
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        In order to use the Service on behalf of your Subscribing Entity, you
        need to (1) be 13 years of age (or the equivalent minimum age in your
        home country) or older; (2) have parent or guardian consent if you are a
        minor in your home country; (3) have the power to enter a binding
        contract with us on behalf of your Subscribing Entity and not be barred
        from doing so under any applicable laws; and (4) reside in a country
        where the Service is available. You also promise that any registration
        information that you submit to Spotify is true, accurate, and complete,
        and you agree to keep it that way at all times.
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="2-service-provider"
      >
        2. The Spotify Service Provided by Us
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Beta Features
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        From time-to-time, we may offer beta features through the Service (“Beta
        Features”). We use Beta Features to experiment with and test new feature
        ideas. Accordingly, you may find that Beta Features appear one day,
        undergo periodic changes, or even disappear completely without notice.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Service limitations and modifications
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        We use reasonable efforts to keep the Service operational. However, the
        Service’s availability may change from time to time, without liability
        to you; for example:
      </Type>

      <TypeList as="ul" listStyleReset={false}>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          The Service may experience temporary interruptions due to technical
          difficulties, maintenance or testing, or updates, including those
          required to reflect changes in relevant laws and regulatory
          requirements.
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          We aim to evolve and improve the Service constantly, and we may
          modify, suspend, or stop (permanently or temporarily) providing all of
          part of the Service (including particular functions, features, and
          offerings);
        </Type>
        <Type variant="ballad" as="li" paddingBottom={spacer16}>
          Spotify has no obligation to provide any specific content through the
          Service, and Spotify or the applicable owners may remove Content
          without notice.
        </Type>
      </TypeList>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify has no liability to you in connection with internet or other
        service outages or failures that are caused by the actions of government
        authorities, other third parties, or events beyond our control.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Third-Party applications, devices and open source software
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        The Service may be integrated with, or may otherwise interact with,
        third-party applications, websites, and services (“Third-Party
        Applications”) and third-party personal computers, mobile handsets,
        tablets, wearable devices, speakers, and other devices (“Devices”). Your
        use of such Third-Party Applications and Devices may be subject to
        additional terms, conditions, and policies provided to you by the
        applicable third party. Spotify does not guarantee that Third-Party
        Applications and Devices will be compatible with the Service.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Data Insights; Mistakes
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You acknowledge that the Service is an optional service that we are
        providing to you for use at our discretion. The Service may provide you
        with the ability to view usage data of your music and demographic data
        on your fans. While we work hard to ensure the accuracy of the data, we
        do not guarantee that the Service or the data we provide will be
        available error-free or that mistakes, including mistakes in the data
        insights that we provide to you, will not happen from time to time.
        Where there is a glitch or mistake in the Service, we will take all
        reasonable efforts to address or correct these mistakes. You agree that
        you will indemnify and hold us harmless against any damage, liability,
        or costs that you incur as a result of a mistake, error, or glitch in
        this free service or arising from your use of the data. All data is
        provided to you “AS-IS.” You use all such data provided by us at your
        sole risk and discretion.
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Although Spotify takes reasonable precautions to preserve and protect
        the Content stored in the database used by Spotify to provide the
        Service, you shall not rely on the Service as your only storage
        facility, and you should preserve backup copies of your Content. Spotify
        is not liable for damage to, deletion of, or failure to store any
        Content.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="3-your-use-of-service"
      >
        3. Your Use of the Spotify Service
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Creating a Spotify account
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You may need to create a Spotify account to use all or part of the
        Service. Your username and password are for your individual use only and
        should be kept confidential. You understand that you are responsible for
        all use (including any unauthorized use) of your username and password.
        Notify our Customer Service team immediately if your username or
        password is lost or stolen, or if you believe there has been
        unauthorized access to your account.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Your rights to use the Service
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Access to the Service
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Subject to your and your Subscribing Entity’s compliance with these
        Terms (including any other applicable terms and conditions), we grant to
        you, on behalf of your Subscribing Entity, a limited, non-exclusive,
        revocable permission to use the Service, including without limitation
        the Content (collectively, “Access”). This Access shall remain in effect
        unless and until terminated by your Subscribing Entity or Spotify. You
        agree that you will not redistribute or transfer the Service or the
        Content. The Service’s software applications and the Content are
        licensed to your Subscribing Entity, not sold or transferred to you, and
        Spotify and its licensors retain ownership of all copies of the
        Service’s software applications and Content even after installation on
        your Devices. When Accessing the Service, you agree that you will not
        take any action that imposes an unreasonable load on the Service.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Compliance with Terms; Delegation
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You acknowledge and agree, on behalf of your Subscribing Entity, that
        these Terms govern your access to and other use of the Service. You, on
        behalf of your Subscribing Entity, agree not to use the Service, the
        Content, or any part thereof in any manner not expressly permitted by
        these Terms. Except as specifically provided in these Terms, you may
        not, in whole or in part: (a) copy the Service or any Content, (b)
        distribute copies of the Service or any Content, in whole or in part;
        (c) modify, adapt, translate, reverse engineer, make alterations,
        decompile, replicate, disassemble or make derivative works based on the
        Service or any Content; (d) use, rent, loan, sub-license, lease,
        distribute or attempt to grant other rights to the Service or any
        Content to third parties; or (e) permit remote access to the Service or
        any Content by any means to any person. In using the Service, you must
        comply with all applicable laws, rules, and regulations, and respect the
        intellectual property, privacy, and other rights of third parties.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You may delegate your authority to use the Service to additional users
        solely within your Subscribing Entity who have a business reason for
        such use (each, a "Delegate"). You must only add Delegates to specific
        teams within the Service for which they have permission by your
        Subscribing Entity as well as a valid business justification. In the
        event that any of your Delegates access or otherwise use the Service,
        you acknowledge and agree on behalf of your Subscribing Entity that
        these Terms shall govern their use of the Service as well. You
        represent, warrant and covenant to us that each of your Delegates is
        authorized to use the Service, and sub-delegate their authority to
        additional users, for and on behalf of the Subscribing Entity.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You expressly agree on behalf of the Subscribing Entity that: (1) you
        and all Delegates will comply with these Terms; (2) the Subscribing
        Entity shall be fully liable for your and each Delegate's violation of
        these Terms, and; (3) the Subscribing Entity will be responsible for the
        acts or omissions of you and your Delegates for purposes of these Terms.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Spotify’s Proprietary Rights
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        The Service and the Content are the property of Spotify or Spotify’s
        licensors. All Spotify trademarks, service marks, trade names, logos,
        domain names, and any other features of the Spotify brand (“Spotify
        Brand Features”) are the sole property of Spotify or its licensors.
        These Terms do not grant you or your Subscribing Entity any rights to
        use any Spotify Brand Features whether for commercial or non-commercial
        use.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Export control and sanctions
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify’s products may be subject to U.S. export and re-export control
        laws and regulations or similar laws applicable in other jurisdictions,
        including the Export Administration Regulations (“EAR”) maintained by
        the U.S. Department of Commerce, trade and economic sanctions maintained
        by the Treasury Department’s Office of Foreign Assets Control (“OFAC”),
        and the International Traffic in Arms Regulations (“ITAR”) maintained by
        the Department of State. You warrant that neither you nor your
        Subscribing Entity are: (1) located in any country to which the United
        States has embargoed goods or has otherwise applied any economic
        sanctions; or (2) a denied party as specified in any applicable export
        or re-export laws or regulations or similar laws applicable in other
        jurisdictions or otherwise listed on any U.S. government list of
        prohibited or restricted parties.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You, on behalf of your Subscribing Entity, agree to comply with all
        applicable export and reexport control laws and regulations, including
        without limitation the EAR and trade and economic sanctions maintained
        by OFAC. Specifically, you, on behalf of your Subscribing Entity, agree
        not to – directly or indirectly – use, sell, export, reexport, transfer,
        divert, release, or otherwise dispose of any products, software, or
        technology (including products derived from or based on such technology)
        received from Spotify under these Terms to any destination, entity, or
        person or for any end-use prohibited by the EAR, trade and economic
        sanctions maintained by OFAC, or any applicable laws or regulations of
        the United States or any other jurisdiction without obtaining any
        required prior authorization from the competent government authorities
        as required by those laws and regulations.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="4-property-rights"
      >
        4. Content and Intellectual Property Rights
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        User Content
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        The content you post on the Service
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You, on behalf of your Subscribing Entity, may post, upload, or
        otherwise contribute content to the Service (“User Content”). For the
        avoidance of doubt, “User Content” includes all information, materials
        and other content that is added, created, uploaded, submitted,
        distributed, or posted to the Service by users. Spotify, and/or any
        third party appointed by Spotify, may in its sole discretion decide to
        use all, or parts of, the metadata provided in connection with such User
        Content, as well as to supplement and/or replace such metadata.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You and your Subscribing Entity are solely responsible for all User
        Content that you post.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You promise, on behalf of your Subscribing Entity, that, with respect to
        any User Content you post on the Service: (1) you own or have the right
        to post such User Content; (2) such User Content, or its use by Spotify
        pursuant to the license granted below, does not (i) violate these Terms,
        including the Spotify User Guidelines, applicable law, the regulations
        and rules of any guilds, unions or collectives, or violate or infringe
        the rights of any third party, including any intellectual property
        (including without limitation, copyright), publicity, privacy,
        personality, contract or other rights of others, or (ii) imply any
        affiliation with or endorsement of you or your User Content by Spotify
        or any artist, band, label, or other individual or entity without the
        prior express written consent from Spotify or such individual or entity;
        (3) you have and shall have acquired, retained and properly administered
        any third-party rights, licenses, authorizations, consents, permissions
        and approvals relating to the User Content you post to the Service and
        required by Spotify to exercise the license granted in these Terms; (4)
        you shall be solely responsible for complying with the terms and
        conditions set forth in each of the third-party licenses,
        authorizations, consents, permissions and approvals referenced in clause
        (3) of this paragraph, and you shall be solely responsible for making
        any and all payments of royalties, fees and any other monies (however
        characterized) to any and all third parties as and when required under
        such third-party licenses, authorizations, consents, permissions and
        approvals; (5) no royalties, fees or other monies (however
        characterized) are or shall be payable by or on behalf of Spotify to or
        on behalf of any person or entity in connection with or arising out of
        the User Content you post to the Service or the exercise by Spotify of
        the license granted in these Terms; (6) all User Content you post to the
        Service is and shall be correct, accurate, and does not contain content
        that violates our User Guidelines; and (7) you have and shall comply
        with all applicable laws, regulations and industry standards when
        posting User Content to the Service, including the FTC’s Guidelines
        Concerning the Use of Testimonials and Endorsements in Advertising, the
        FTC’s.com Disclosures Guide, the FTC’s Native Advertising Guidelines,
        and any other guidelines issued by the FTC from time to time, and
        updates thereto.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        In posting or sharing User Content on the Service, please keep in mind
        that certain User Content will be publicly accessible, and may be used
        and re-shared by others on the Service and on other Spotify services and
        across the web, so please use caution in posting or sharing on the
        Service, and be mindful of your account settings. Spotify is not
        responsible for what you or others post or share on the Service. To the
        extent you or your Subscribing Entity has access to a particular page or
        account on the Service which is also accessible to one or more other
        users or Subscribing Entities, certain of your User Content (including,
        but not limited to, your name, role, access level and certain actions
        you take on the Service) may be visible to such other users or
        Subscribing Entities. Your right to access and edit pages or assets may
        differ depending on your underlying rights over that material and your
        level of access to the Service. In some cases, you may share editing
        rights of a particular page or account on the Service with other users
        or Subscribing Entities.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Takedowns and monitoring user content
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify shall be under no obligation to include or distribute User
        Content via the Service. Spotify may, but has no obligation to, monitor
        or review User Content. Except to the extent prohibited by applicable
        law, Spotify reserves the right to remove or disable access to any User
        Content from the Service in its sole discretion, for any or no reason,
        including, but not limited to, when User Content violates the Spotify
        User Guidelines. Spotify may take these actions without prior
        notification to you or any third party and without any liability to you
        for such removal.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Licenses that you grant to us
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        User Content
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify does not claim any ownership rights in the User Content you post
        to the Service. After posting User Content to the Service, as between
        you and Spotify, you will continue to retain any rights you may have in
        your User Content, including any intellectual property rights or other
        proprietary rights associated with your User Content, subject to the
        license you grant to Spotify in the next paragraph of this section.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        By posting User Content to the Service, you, on behalf of your
        Subscribing Entity, grant Spotify a non-exclusive, transferable,
        sub-licensable, royalty-free, fully paid, worldwide license to
        reproduce, make available, perform and display, translate, modify,
        create derivative works from, distribute, and otherwise use such User
        Content through any medium, whether alone or in combination with other
        content or materials, in any manner and by any means, method or
        technology, whether now known or hereafter created, in connection with
        the Service and Spotify’s music streaming service, the promotion and
        marketing of the Service and Spotify’s music streaming service and the
        promotion and marketing of the Service and Spotify’s music streaming
        service. If you do not want Spotify to use your User Content for these
        purposes, you should not post User Content to the Service. To the extent
        you provide User Content that contains your name, likeness or
        photograph, you further grant us the non-exclusive, fully paid,
        worldwide right to use such name, likeness, and photograph on the
        Service and Spotify’s music streaming service and in our marketing
        communications to advertise, market and promote the availability of your
        User Content on the Service and Spotify’s music streaming service. Where
        applicable and to the extent permitted under applicable law, you also
        agree to waive, and not to enforce, any “moral rights” or equivalent
        rights, such as your right to be identified as the author of any User
        Content, including Feedback (as defined below), and your right to object
        to derogatory treatment of such User Content.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Feedback
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        If you provide ideas, suggestions, or other feedback in connection with
        your use of the Service or any Content (“Feedback”), such Feedback is
        not confidential and may be used by Spotify without restriction and
        without payment to you. Feedback is considered a type of User Content
        under these Terms.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Your Device
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You also grant us the right to allow the Service to use the processor,
        bandwidth, and storage hardware on your Device in order to facilitate
        the operation of the Service.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Infringement claims
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify respects the rights of intellectual property owners. If you
        believe that any Content infringes your copyright rights, please see the
        Spotify Copyright Policy.
      </Type>
      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="5-customer-support"
      >
        5. Customer Support, Information, Questions, and Complaints.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Customer support, information, questions, complaints
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        For customer support (“Customer Support Queries”), please use Customer
        Support resources listed on the Contact Us section of our website. You
        may also contact us at the mailing address set forth in the “Service
        Provider” section at the start of these Terms.
      </Type>

      <Type
        variant="alto"
        paddingBottom={spacer8}
        as="h2"
        id="6-problems-disputes"
      >
        6. Problems and Disputes
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Suspending and terminating the Service
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        These Terms will continue to apply to you until terminated by either
        your Subscribing Entity or Spotify. Spotify may terminate these Terms
        (including any additional terms and conditions incorporated herein) or
        suspend your access to the Service at any time if we believe you or your
        Subscribing Entity have breached any of these Terms, if we stop
        providing the Service or any material component thereof, or as we
        believe necessary to comply with applicable law.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        If there is a dispute between you and/or your Subscribing Entity and any
        third party as to the ownership or authorized use of an account
        (including the account of any of your Delegates), then Spotify may
        suspend all access to such account at any time and without any liability
        to you, your Delegates and/or any other person or entity, including your
        Subscribing Entity. Spotify may resolve disputes among users or it may
        leave the resolution of disputes up to the parties involved, who may
        seek relief from a court of competent jurisdiction. If Spotify resolves
        any dispute, then you agree that Spotify’s decision is final and binding
        upon you and your Subscribing Entity, and that neither you nor your
        Subscribing Entity will have any cause of action against Spotify,
        although you may have recourse against any third parties as provided
        under applicable law. Spotify will also abide by any lawful order from a
        court of competent jurisdiction.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        If your Subscribing Entity or Spotify terminates these Terms, or if
        Spotify suspends your access to the Service, you, on behalf of your
        Subscribing Entity, agree that Spotify shall have no liability or
        responsibility to you or your Subscribing Entity, and (except as
        expressly provided in these Terms) Spotify will not refund any amounts
        that you have already paid. Your Subscribing Entity may terminate these
        Terms at any time or your individual right to Access the Service, in
        which case you may not continue accessing or using the Service. To learn
        how to terminate your Spotify account, please use the Customer Support
        resources on our About Us page.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        The following sections shall survive termination: Sections 2 (The
        Spotify Service Provided by Us), 3 (Your Use of the Spotify Service)
        (except as set forth therein), 4 (Content and Intellectual Property
        Rights), 6 (Problems and Disputes), 7 (About These Terms), as well as
        any other sections of these Terms that, either explicitly or by their
        nature, must remain in effect even after termination of these Terms.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Warranty disclaimers
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE,” WITHOUT ANY
        WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR STATUTORY. FURTHER,
        SPOTIFY AND ALL OWNERS OF THE CONTENT DISCLAIM ANY EXPRESS, IMPLIED, AND
        STATUTORY WARRANTIES REGARDING THE CONTENT, INCLUDING WARRANTIES OF
        SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
        OR NON-INFRINGEMENT. NEITHER SPOTIFY NOR ANY OWNER OF CONTENT WARRANTS
        THAT THE SERVICE OR CONTENT IS FREE OF MALWARE OR OTHER HARMFUL
        COMPONENTS. IN ADDITION, SPOTIFY MAKES NO REPRESENTATION REGARDING, NOR
        DOES IT WARRANT OR ASSUME ANY RESPONSIBILITY FOR, ANY THIRD-PARTY
        APPLICATIONS (OR THE CONTENT THEREOF), USER CONTENT, DEVICES OR ANY
        PRODUCT OR SERVICE ADVERTISED, PROMOTED OR OFFERED BY A THIRD PARTY ON
        OR THROUGH THE SERVICE OR ANY HYPERLINKED WEBSITE, AND SPOTIFY IS NOT
        RESPONSIBLE FOR ANY TRANSACTIONS BETWEEN YOU AND ANY THIRD-PARTY
        PROVIDERS OF THE FOREGOING. NO ADVICE OR INFORMATION WHETHER ORAL OR IN
        WRITING OBTAINED BY YOU FROM SPOTIFY SHALL CREATE ANY WARRANTY ON BEHALF
        OF SPOTIFY. THIS SECTION APPLIES TO THE FULLEST EXTENT PERMITTED BY
        APPLICABLE LAW.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Limitation of liability and time for filing a claim
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        YOU AGREE THAT YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY PROBLEMS OR
        DISSATISFACTION WITH THE SERVICE IS TO UNINSTALL ANY SPOTIFY SOFTWARE
        AND TO STOP USING THE SERVICE. YOU AGREE THAT SPOTIFY HAS NO OBLIGATION
        OR LIABILITY ARISING FROM OR RELATED TO THIRD-PARTY APPLICATIONS OR THE
        CONTENT THEREOF MADE AVAILABLE THROUGH OR IN CONNECTION WITH THE
        SERVICE, AND WHILE YOUR RELATIONSHIP WITH SUCH THIRD-PARTY APPLICATIONS
        MAY BE GOVERNED BY SEPARATE AGREEMENTS WITH SUCH THIRD PARTIES, YOUR
        SOLE AND EXCLUSIVE REMEDY, AS WITH RESPECT TO SPOTIFY, FOR ANY PROBLEMS
        OR DISSATISFACTION WITH ANY THIRD-PARTY APPLICATIONS OR THE CONTENT
        THEREOF, IS TO UNINSTALL OR STOP USING SUCH THIRD-PARTY APPLICATIONS.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        IN NO EVENT WILL SPOTIFY, ITS OFFICERS, SHAREHOLDERS, EMPLOYEES, AGENTS,
        DIRECTORS, SUBSIDIARIES, AFFILIATES, SUCCESSORS, ASSIGNS, SUPPLIERS, OR
        LICENSORS BE LIABLE FOR (1) ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE,
        EXEMPLARY, OR CONSEQUENTIAL DAMAGES; (2) ANY LOSS OF USE, DATA,
        BUSINESS, OR PROFITS (WHETHER DIRECT OR INDIRECT), IN ALL CASES ARISING
        OUT OF THE USE OF OR INABILITY TO USE THE SERVICE, DEVICES, THIRD-PARTY
        APPLICATIONS, OR THIRD-PARTY APPLICATION CONTENT, REGARDLESS OF LEGAL
        THEORY, WITHOUT REGARD TO WHETHER SPOTIFY HAS BEEN WARNED OF THE
        POSSIBILITY OF THOSE DAMAGES, AND EVEN IF A REMEDY FAILS OF ITS
        ESSENTIAL PURPOSE; OR (3) AGGREGATE LIABILITY FOR ALL CLAIMS RELATING TO
        THE SERVICE, THIRD-PARTY APPLICATIONS, OR THIRD-PARTY APPLICATION
        CONTENT MORE THAN THE GREATER OF (A) THE AMOUNTS PAID BY YOU TO SPOTIFY
        DURING THE TWELVE MONTHS PRIOR TO THE FIRST CLAIM; OR $30.00.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        For clarification, these Terms do not limit Spotify’s liability for
        fraud, fraudulent misrepresentation, death or personal injury to the
        extent that applicable law would prohibit such a limitation.
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        ANY CLAIM ARISING UNDER THESE TERMS MUST BE COMMENCED (BY FILING A
        DEMAND FOR ARBITRATION OR FILING AN INDIVIDUAL ACTION UNDER THE
        ARBITRATION AGREEMENT BELOW) WITHIN ONE (1) YEAR AFTER THE DATE THE
        PARTY ASSERTING THE CLAIM FIRST KNOWS OR REASONABLY SHOULD KNOW OF THE
        ACT, OMISSION, OR DEFAULT GIVING RISE TO THE CLAIM; AND THERE SHALL BE
        NO RIGHT TO ANY REMEDY FOR ANY CLAIM NOT ASSERTED WITHIN THAT TIME
        PERIOD.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Third party rights
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You acknowledge and agree that owners of the Content and certain
        distributors (such as app store providers) are intended beneficiaries of
        these Terms and have the right to enforce these Terms directly against
        you. Other than as set out in this section, these Terms are not intended
        to grant rights to anyone except you and Spotify, and in no event shall
        these Terms create any third-party beneficiary rights.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        If you have downloaded any of our mobile software applications (each, an
        “App”) from the Apple Inc. (“Apple”) App Store or if you are using the
        App on an iOS device, you acknowledge that you have read, understood,
        and agree to the following notice regarding Apple. These Terms are
        between your Subscribing Entity and Spotify only, not with Apple, and
        Apple is not responsible for the Service and the content thereof. Apple
        has no obligation whatsoever to furnish any maintenance and support
        services with respect to the Service. In the event of any failure of the
        Service to conform to any applicable warranty, you may notify Apple and
        Apple will refund the applicable purchase price for the App to you; and,
        to the maximum extent permitted by applicable law, Apple has no other
        warranty obligation whatsoever with respect to the Service. Apple is not
        responsible for addressing any claims by you or any third party relating
        to the Service or your possession or use of the Service, including: (1)
        product liability claims; (2) any claim that the Service fails to
        conform to any applicable legal or regulatory requirement; (3) claims
        arising under consumer protection or similar legislation; and (4) claims
        with respect to intellectual property infringement. Apple is not
        responsible for the investigation, defense, settlement, and discharge of
        any third-party claim that the Service or your possession and use of the
        App infringe that third party’s intellectual property rights. You agree
        to comply with any applicable third-party terms, when using the Service.
        Apple, and Apple’s subsidiaries, are third-party beneficiaries of these
        Terms, and upon your acceptance of these Terms, Apple will have the
        right (and will be deemed to have accepted the right) to enforce these
        Terms against you as a third-party beneficiary of these Terms.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Indemnification
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You agree, on behalf of your Subscribing Entity, to indemnify and hold
        Spotify harmless from and against all damages, losses, and expenses of
        any kind (including reasonable attorney fees and costs) arising out of
        or related to: (1) your breach of any of these Terms (including any
        additional Spotify terms and conditions incorporated herein); (2) any
        User Content you post or otherwise contribute; (3) any activity in which
        you engage on or through the Service; and (4) your violation of any law
        or the rights of a third party.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Governing law, mandatory arbitration and venue
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Governing law and jurisdiction
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        These Terms are governed by and shall be construed in accordance with
        the laws of the State of New York, United States of America, without
        regard to New York’s choice or conflicts of law principles. Further,
        your Subscribing Entity and Spotify agree to the jurisdiction of the
        federal and state courts located in New York County, New York, to
        resolve any dispute, claim, or controversy that relates to or arises in
        connection with these Terms or the Service that is not subject to
        mandatory arbitration under the Arbitration Agreement below, and waive
        any jurisdictional, venue or inconvenient forum objections to such
        courts.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        ARBITRATION AGREEMENT
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        This Arbitration Agreement section sets forth the terms and conditions
        pursuant to which disputes, claims and controversies between you and
        Spotify will be resolved through arbitration (“Arbitration Agreement”).
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        This Arbitration Agreement applies only to Subscribing Entities and
        their users in the United States.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Dispute resolution and arbitration
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You and Spotify agree that any dispute, claim, or controversy between
        you and/or your Subscribing Entity and Spotify arising in connection
        with or relating in any way to these Terms or to your relationship with
        Spotify as a user of the Service (whether based in contract, tort,
        statute, fraud, misrepresentation, or any other legal theory, and
        whether the claims arise during or after the termination of these Terms)
        will be determined by mandatory binding individual (not class)
        arbitration. You, on behalf of your Subscribing Entity, and Spotify
        further agree that the arbitrator shall have the exclusive power to rule
        on his or her own jurisdiction, including any objections with respect to
        the existence, scope or validity of the Arbitration Agreement or to the
        arbitrability of any claim or counterclaim. THERE IS NO JUDGE OR JURY IN
        ARBITRATION, AND COURT REVIEW OF AN ARBITRATION AWARD IS LIMITED. The
        arbitrator must follow these Terms and can award the same damages and
        relief as a court (including attorney fees and costs only where
        allowable under applicable law), except that the arbitrator may not
        award any relief, including declaratory or injunctive relief, benefiting
        anyone but the parties to the arbitration. This arbitration provision
        will survive termination of these Terms.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Exceptions
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        You, on behalf of your Subscribing Entity, and Spotify both agree that
        nothing in this Arbitration Agreement will be deemed to waive, preclude,
        or otherwise limit either of our rights, at any time, to bring an
        individual action (1) in a U.S. small claims court or (2) in a court of
        law, in accordance with the jurisdiction and venue described in the
        Dispute Resolution and Arbitration section above, seeking (a) only
        temporary or preliminary individualized injunctive relief, pending a
        final ruling from the arbitrator or (b) public injunctive relief,
        pending a ruling on the substance of such claim from the arbitrator. In
        addition, this Arbitration Agreement doesn’t stop you or us from
        bringing issues to the attention of federal, state, or local agencies.
        Such agencies can, if the law allows, seek relief against us on your
        behalf (or vice versa).
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        No class or representative proceedings; class action waiver
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        YOU AND SPOTIFY AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY
        IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS
        MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE ACTION. Unless both you
        and Spotify agree, no arbitrator or judge may consolidate more than one
        person’s claims or otherwise preside over any form of a representative
        or class proceeding. The arbitrator may award injunctive relief only in
        favor of the individual party seeking relief and only to the extent
        necessary to provide relief warranted by that party’s individual claim.
        If a court decides that applicable law precludes enforcement of any of
        this paragraph’s limitations as to a particular claim for relief, then
        that claim (and only that claim) must be severed from the arbitration
        and may be brought in court.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Arbitration rules
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Either you or we may start arbitration proceedings. Any arbitration
        between you and Spotify will take place under the Consumer Arbitration
        Rules of the American Arbitration Association (“AAA”) then in force (the
        “AAA Rules”), as modified by this Arbitration Agreement. You and Spotify
        agree that the Federal Arbitration Act applies and governs the
        interpretation and enforcement of this provision (despite the choice of
        law provision above). The AAA Rules, as well as instructions on how to
        file an arbitration proceeding with the AAA, appear at adr.org, or you
        may call the AAA at 1-800-778-7879.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Any arbitration hearings will be conducted by phone or videoconference
        to the extent possible, but if the arbitrator determines that a hearing
        should be conducted in person, the locale for such hearing shall be
        determined by the arbitrator in accordance with the AAA Rules.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        If you choose to file an arbitration proceeding and you are required to
        pay a filing fee, Spotify will reimburse you for that filing fee, unless
        your claim is for greater than US $10,000, in which case you will be
        responsible for the filing fee. Spotify will pay any other arbitration
        fees, including your share of arbitrator compensation, unless otherwise
        required by AAA Rules or court order. Regardless of the manner in which
        the arbitration is conducted, the arbitrator shall issue a reasoned
        written decision sufficient to explain the essential findings and
        conclusions on which the decision and award, if any, are based. The
        arbitrator may make rulings and resolve disputes as to the payment and
        reimbursement of fees or expenses at any time during the proceeding and
        upon request from either party made within 14 days of the arbitrator’s
        ruling on the merits.
      </Type>
      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Notice; process
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        A party who intends to seek arbitration must first send a written notice
        of the dispute to the other, by electronic mail to legal@spotify.com and
        by certified mail, Federal Express, UPS, or Express Mail (signature
        required) to the address below ("Notice"). Spotify's address for Notice
        is: Spotify USA Inc., Attn: General Counsel, 4 World Trade Center, 150
        Greenwich Street, 62nd Floor, New York, New York 10007, USA. The Notice
        must (1) describe the nature and basis of the claim or dispute; and (2)
        set forth the specific relief sought ("Demand"). We agree to use good
        faith efforts to resolve the claim directly, but if we do not reach an
        agreement to do so within 30 days after the Notice is received, you or
        Spotify may commence an arbitration proceeding. During the arbitration,
        the amount of any settlement offer made by you or Spotify shall not be
        disclosed to the arbitrator until after the arbitrator makes a final
        decision and award, if any. In the event our dispute is finally resolved
        through arbitration in your favor, and the arbitrator issues you an
        award that is greater than the value of Spotify’s last written
        settlement offer, then Spotify will instead pay you either the amount of
        the award or $1,000, whichever is greater. All documents and information
        disclosed in the course of the arbitration shall be kept strictly
        confidential by the recipient and shall not be used by the recipient for
        any purpose other than for purposes of the arbitration or the
        enforcement of the arbitrator’s decision and award and shall not be
        disclosed except in confidence to persons who have a need to know for
        such purposes or as required by applicable law.
      </Type>

      <Type variant="cello" as="h4" paddingBottom={spacer16}>
        Enforceability
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        If this Arbitration Agreement is invalidated in whole or in part, the
        parties agree that the exclusive jurisdiction and venue described in the
        ‘Governing law and jurisdiction’ section above shall govern with respect
        to any aspect of any dispute, claim or controversy that, as a result of
        such invalidation, is no longer governed by this Arbitration Agreement.
      </Type>

      <Type variant="alto" paddingBottom={spacer8} as="h2" id="7-about-terms">
        7. About These Terms
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Under applicable law, you may have certain rights that cannot be limited
        by a contract. These Terms are in no way intended to restrict those
        rights.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Changes to these Terms
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        We may make changes to these Terms (including any additional Spotify
        terms and conditions incorporated by reference herein) from time to time
        by notifying you of such changes by any reasonable means, including by
        posting the revised Terms on the applicable Spotify Service (provided
        that, for material changes, we will seek to supplement such notice by
        email, an in-service pop-up message or other prominent notice within the
        Service, or other means). Any such changes will not apply to any dispute
        between you and us arising prior to the date on which the Terms were
        changed. Your use of the Service following any changes to these Terms
        will constitute your acceptance of such changes. If you do not wish to
        continue using the Service under the updated Terms, you may terminate
        your account by contacting us. The effective date set forth at the top
        of this document indicates when these Terms were last changed.
      </Type>

      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Entire agreement
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Other than as stated in this section or as explicitly agreed upon in
        writing between you and Spotify, these Terms constitute all the terms
        and conditions agreed upon between you and Spotify and supersede any
        prior agreements in relation to the subject matter of these Terms,
        whether written or oral. As noted above, other terms and conditions
        governing use of the Service are incorporated herein by reference,
        including the following terms and conditions: the Spotify User
        Guidelines; the Spotify Copyright Policy; and the Spotify Support
        Community Terms.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Severability and waiver
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Unless as otherwise stated in these Terms, should any provision of these
        Terms be held invalid or unenforceable for any reason or to any extent,
        the remaining provisions of these Terms will not be affected, and the
        application of that provision shall be enforced to the extent permitted
        by law.
      </Type>

      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Any failure by Spotify or any third-party beneficiary to enforce these
        Terms or any provision thereof shall not waive Spotify’s or the
        applicable third-party beneficiary’s right to do so.
      </Type>
      <Type variant="celloCanon" as="h3" paddingBottom={spacer16}>
        Assignment
      </Type>
      <Type variant="ballad" as="p" paddingBottom={spacer16}>
        Spotify may assign any or all of these Terms, and may assign or
        delegate, in whole or in part, any of its rights or obligations under
        these Terms. You may not assign these Terms, in whole or in part, nor
        transfer or sub-license your rights under these Terms, to any third
        party.
      </Type>
    </Layout>
  );
};
export default TermsAndConditions;
